/* eslint-disable max-lines */

export default {
  translation: {
    // Generic
    INIT_KEY: 'Iniciando',
    AUTO_PANEL_TITLE_KEY: 'Autosky Console',
    EXTERNAL_INFO_KEY:
      'Código externo a la plataforma Autosky, utilizado para identificar a un cliente',
    PANEL_KEY: 'Panel',
    CONFIG_KEY: 'Ajustes',
    COLORS_KEY: 'Colores',
    FONTS_KEY: 'Fuentes',
    VISUALIZE_EDITION_KEY: 'Ver edición',
    ADMIN_PANEL_KEY: 'Panel administración',
    LOGIN_KEY: 'Iniciar sesión',
    ADD_KEY: 'Añadir',
    PRODUCT_KEY: 'Producto',
    FINALIZE_KEY: 'Finalizar',
    SUPPORT: 'Soporte',
    FAVORITES_KEY: 'Mis favoritos',
    PREPARATION: 'Preparación',
    NEWS_KEY: 'Noticias',
    ACTIVE_KEY: 'Activo',
    PRIVACY_KEY: 'Privacidad',
    NOT_FOUND_NOTIFICATION_KEY: 'No se encontró ninguna notificación',
    PASSWORD_MUST_CONTAIN_KEY: 'La contraseña debe contener',
    REQUIRE_MIN_LENGTH_TEXT_KEY: 'Mínimo {{min_length}} caracteres',
    REQUIRE_MAX_LENGTH_TEXT_KEY: 'Máximo {{max_length}} caracteres',
    REQUIRED_LETTER_UPPERCASE_KEY: 'Al menos un caractere en mayúscula',
    REQUIRED_LETTER_LOWERCASE_KEY: 'Al menos un caractere en minúscula',
    REQUIRED_LETTER_TO_NUMBER_KEY: 'Al menos un número',
    REQUIRED_LETTER_SPECIAL_CHARACTER_KEY: 'Al menos un caractere especial',
    REQUIRED_OPTION_KEY: 'Seleccione al menos una opción',
    EXTEND_KEY: 'Prorrogar',
    WORK_KEY: 'Tarea',
    STATE_KEY: 'Estado',
    OF_DAY_KEY: 'de',
    AT_HOUR_KEY: 'às',
    APPLY_KEY: 'Aplicar',
    REVERT_KEY: 'Invertir',
    DO_NOT_APPLY_KEY: 'No aplicar',
    SEE_DETAILS_KEY: 'Ver detalles',
    SUCCESS_KEY: 'Éxito',
    ATTENTION_KEY: 'Aviso',
    NOT_ENOUGH_DATA_KEY: 'No hay suficientes datos',
    COPY_KEY: 'Copia',
    COPY_CLICK_HERE_KEY: 'Haga clic aquí para copiar',
    EDIT_KEY: 'Editar',
    DETAILS_KEY: 'Detalles',
    ZOHO_ID_KEY: 'Zoho ID',
    CLONE_KEY: 'Clonar',
    STOP_KEY: 'Parar',
    REMOVE_KEY: 'Eliminar',
    DELETE_KEY: 'Eliminar',
    BLOCK_KEY: 'Bloquear',
    UNBLOCK_KEY: 'Desbloquear',
    CODE_KEY: 'Código',
    INCLUDE_APPLICATION_KEY: 'Incluir aplicación',
    OPERATOR_NAME_KEY: 'Nombre del operador',
    OPERATOR_ID_KEY: 'ID del operador',
    DISABLE_KEY: 'Desactivar',
    INACTIVATED_KEY: 'Desactivado',
    ENABLE_KEY: 'Activar',
    TERMINATE_KEY: 'Terminar',
    SIMPLE_KEY: 'Simple',
    GO_OUT_KEY: 'Salir',
    ENTER_KEY: 'Entrar',
    PLATFORM_KEY: 'Plataforma',
    SAVE_KEY: 'Guardar',
    REGISTER_KEY: 'Registro',
    RECOVER_KEY: 'Recuperar',
    RESEND_KEY: 'Reenviar',
    CHANGE_KEY: 'Cambiar',
    DUPLICATE_KEY: 'Duplicar',
    CANCEL_KEY: 'Cancelar',
    CLEAR_FORM_KEY: 'Limpio',
    CONFIRM_KEY: 'Confirmar',
    CONNECT_KEY: 'Conectar',
    DOWNLOAD_KEY: 'Descargar',
    EXPORT_KEY: 'Exportar',
    LOADING_KEY: 'Cargando',
    SEARCH_KEY: 'Buscar',
    ACTION_KEY: 'Acción',
    ACTIONS_KEY: 'Acciones',
    ACTIVATE_KEY: 'Activar',
    INACTIVE_KEY: 'Inactivo',
    MFA_ACTIVE_KEY: 'MFA activo',
    MFA_CONFIGURED_KEY: 'MFA configurado',
    MFA_RESET_KEY: 'Redefinir MFA',
    ACTIVE_MFA_TO_ALL_KEY: 'Ativar MFA para todos los usuarios',
    STARTED_KEY: 'Iniciado',
    REMOVING_KEY: 'Eliminando',
    RECOVERING_KEY: 'Recuperante',
    START_KEY: 'Iniciar',
    REINITIALIZE_KEY: 'Reiniciar',
    UNLINK_KEY: 'Desmarque',
    BACK_KEY: 'Volver',
    STATUS_KEY: 'Estatus',
    OPERATION_MODE_KEY: 'Modo de operación',
    OPERATION_MODE_MANUAL_KEY: 'Manual',
    OPERATION_MODE_PERIOD_KEY: 'Periodo',
    OPERATION_MODE_MICRO_KEY: 'Micro',
    OPERATION_MODE_SPOT_PERIOD_KEY: 'Periodo (Spot)',
    FLAVOR_KEY: 'Sabor',
    ID_ZOHO_KEY: 'ID Zoho',
    ZOHO_ID_ALREADY_EXISTS:
      'El Zoho ID que ha introducido ya está asociado a una empresa',
    OTHERS_KEY: 'Otros',
    CLOSE_KEY: 'Cerrar',
    CLOSED_KEY: 'Cerrado',
    PROFILE_KEY: 'Perfil',
    INTERNAL_KEY: 'Interno',
    COMPANY_KEY: 'Compañía',
    COMPANIES_KEY: 'Compañías',
    PARTNERS_KEY: 'Cuentas',
    ENVIRONMENTS_KEY: 'Entornos',
    ENVIRONMENT_KEY: 'Entorno',
    PROVIDER_KEY: 'Proveedor',
    CLIENTS_KEY: 'Clientes',
    CLIENT_KEY: 'Cliente',
    APPLICATIONS_KEY: 'Aplicaciones',
    REASON_KEY: 'Razón',
    APPLICATIONS_TOOLTIP_KEY:
      'Para que las aplicaciones sean configuradas en Autosky, es necesario que estén registradas en Autosky Platform',
    NO_ACTIONS_AVAILABLE_KEY: 'No hay acciones disponibles',
    NO_USERNAME_AVAILABLE_KEY: 'No hay usuario disponible',

    APPLICATIONS_REMOVED_KEY: '¡Aplicaciones eliminadas con éxito!',
    APPLICATIONS_INACTIVE_KEY: '¡Aplicaciones desactivadas con éxito!',
    APPLICATIONS_ACTIVE_KEY: '¡Aplicaciones activadas con éxito!',

    WANT_ACTIVATE_APPLICATIONS_KEY: 'Activar aplicaciones',
    WANT_INACTIVATE_APPLICATIONS_KEY: 'Desactivar aplicaciones',
    WANT_REMOVE_APPLICATIONS_KEY: 'Eliminar aplicaciones',

    ACTIVATE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      '¿Está seguro de que desea activar las aplicaciones seleccionadas?',
    INACTIVATE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      '¿Está seguro de que desea desactivar las aplicaciones seleccionadas?',
    REMOVE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      '¿Está seguro de que desea eliminar las aplicaciones seleccionadas?',

    BUTTON_ACTIVATE_APPLICATIONS_KEY: 'Activar seleccionados',
    BUTTON_INACTIVATE_APPLICATIONS_KEY: 'Desactivar seleccionados',
    BUTTON_REMOVE_APPLICATIONS_KEY: 'Eliminar seleccionados',

    APPLICATION_KEY: 'Agregar aplicación',
    USERS_KEY: 'Usuarios',
    USER_KEY: 'Usuario',
    USER_AD_KEY: 'Código en AD',
    OPERATORS_KEY: 'Operadores',
    OPERATOR_KEY: 'Operador',
    GENERAL_KEY: 'General',
    ADMINISTRATION_KEY: 'Administración',
    DASHBOARD_KEY: 'Dashboard',
    INSTANCES_KEY: 'Instancias',
    INSTANCE_KEY: 'Instancia',
    SERVERS_KEY: 'Servidores',
    SERVER_KEY: 'Servidor',
    MODELS_KEY: 'Modelos',
    MODEL_KEY: 'Modelo primario',
    SESSIONS_KEY: 'Sesiones',
    IMAGE_KEY: 'Imagen',
    IMAGES_KEY: 'Imagens',
    JPEG_PNG_KEY: 'JPEG o PNG',
    ALL_KEY: 'Todos',
    PORT_KEY: 'Puerta',
    ZONE_KEY: 'Zona',
    PRIMARY_PORT_KEY: 'Puerta primaria',
    SECONDARY_PORT_KEY: 'Puerta secundaria',
    ROWS_PER_PAGE_KEY: 'Líneas por página',
    DESCRIPTION_KEY: 'Descripción',
    FULL_NAME_KEY: 'Nombre completo ',
    NAME_KEY: 'Nombre',
    OPERATOR_VIEW_NAME_KEY: 'Nombre del cliente',
    NOT_FOUND_KEY: 'No encontrado',
    LAST_NAME_KEY: 'Apellido',
    CELLPHONE_KEY: 'Celular',
    SUGGESTION_KEY: 'Sugerencia',
    DESCRIBE_SUGGESTION_KEY: 'Describa su sugerencia.',
    BUSINESS_PHONE_KEY: 'Teléfono comercial',
    YES_KEY: 'Sí',
    SETTINGS_KEY: 'Ajustes',
    MAINTENANCE_KEY: 'Mantenimiento',
    MAINTENANCE_DISPLAY_WARNING_KEY: 'Entorno con aviso de mantenimiento',
    MAINTENANCE_WARNING_KEY: 'Entorno en manutención',
    CLIENT_MAINTENANCE_WARNING_KEY: 'Cliente en manutención',
    MAINTENANCE_SCHEDULED_KEY: 'Mantenimiento programado',
    MAINTENANCE_MANUAL_KEY: 'Mantenimiento manual',
    LOGS_KEY: 'Registros',
    LOGS_LISTING_KEY: 'Listado de registros de entorno',
    DOMAIN_KEY: 'Dominio',
    SUBJECT_KEY: 'Asunto',
    NO_KEY: 'No',
    GENERAL_ACTIONS_KEY: 'Acciones generales',
    REMOVE_SELECT_KEY: 'Eliminar seleccionados',
    RESET_PASSWORD_KEY: 'Restablecer contraseña',
    MFA_ENABLE_KEY: 'Activar MFA',
    LANGUAGE_KEY: 'Idioma',
    EXTERNAL_KEY: 'Externo',
    MANAGED_KEY: 'Gestionado',
    CREATION_DATE_KEY: 'Fecha de creación',
    EXPIRATION_DATE_KEY: 'Fecha de expiración',
    START_DATE_KEY: 'Fecha de inicio',
    END_DATE_KEY: 'Fecha de finalización',
    INITIAL_DATE_KEY: 'Fecha de inicio',
    FINAL_DATE_KEY: 'Final final',
    DATE_KEY: 'Fecha',
    TIME_KEY: 'Hora',
    MINUTE_KEY: 'Minuto',
    MINUTES_KEY: 'Minutos',
    TYPE_KEY: 'Tipo',
    MESSAGE_KEY: 'Mensaje',
    PERIOD_KEY: 'Período',
    PERIODS_KEY: 'Períodos',
    PERIOD_1_KEY: 'Período 1',
    PERIOD_2_KEY: 'Período 2',
    RESTRICTION_RULE_1_KEY: 'Regla de restricción 1',
    RESTRICTION_RULE_2_KEY: 'Regla de restricción 2',
    TIME_ZONE_KEY: 'Huso zone',
    GENERAL_INFORMATION_KEY: 'Información general',
    MONITORING_KEY: 'Monitorización',
    MEMORY_KEY: 'Memoria',
    CONNECTIONS_KEY: 'Conexiones',
    TEMPERATURE_KEY: 'Temperatura',
    DAILY_VARIATION_KEY: 'Variación diaria',
    LAST_HOUR_KEY: 'Última Hora',
    LAST_HOUR_UNI_ONLY_KEY: 'Últimas',
    HOUR_KEY: 'Horas',
    LATTER_KEY: 'Últimos',
    DAYS_KEY: 'Días',
    ACCESS_RATE_KEY: 'Tasa de acceso',
    VACANCIES_AVAILABLE_KEY: 'Vacantes disponibles',
    TOTAL_KEY: 'Total',
    OCCUPIED_KEY: 'Ocupadas',
    BLOCKED_KEY: 'Bloqueadas',
    UNAVAILABLE_KEY: 'Inaccesible',
    MODIFIED_BY_KEY: 'Modificado por',
    CREATE_DATE_KEY: 'Fecha de creación',
    SHOW_ALERT_KEY: 'Mostrar aviso',
    ENV_DISPLAY_WARNING_ENABLED_KEY: 'Habilitado en el entorno',
    ENV_DISPLAY_WARNING_ENABLED_TOOLTIP_KEY:
      'El entorno tiene advertencia active',
    ENV_DISPLAY_WARNING_ENABLED_TOOLTIP_DATE_KEY: 'hasta {{date}}',
    GENERAL_SETTINGS_KEY: 'Configuraciones generales',
    COUNTRY_KEY: 'País',
    ENABLED_KEY: 'Activado',
    DISABLED_KEY: 'Desactivado',
    COPIED_KEY: '¡Copiado!',
    TEST_OPEN_KEY: 'Prueba de apertura',
    CONNECT_LIKE_KEY: 'Conectar como',
    OBJECT_KEY: 'Objeto',
    START_TIME_KEY: 'Hora de inicio',
    END_TIME_KEY: 'Hora de finalización',
    COMING_SOON_KEY: 'Próximamente',
    TEST_KEY: 'Prueba',
    MIN_LENGTH_KEY: 'Mínimo de {{value}} caracteres',
    MAX_LENGTH_KEY: 'Máximo de {{value}} caracteres',
    NEXT_KEY: 'Siguiente',
    PREVIOUS_KEY: 'Anterior',
    GROUPS_KEY: 'Grupos',
    CURRENT_KEY: 'Actual',
    FIRST_PERIOD_KEY: 'Primer período',
    SECOND_PERIOD_KEY: 'Segundo período',
    LISTING_KEY: 'Listado',
    IGNORE_KEY: 'Ignorar',
    MAX_VALUE_KEY: 'El valor máximo de este campo es {{value}}',
    MIN_VALUE_KEY: 'El valor mínimo de este campo es {{value}}',
    ID_ZOHO_EXCEPTION: 'Zoho ID no se puede iniciar con 9',

    ADDITION_KEY: 'Añadir',
    MODIFICATION_KEY: 'Modificar',
    REMOVAL_KEY: 'Exclusión',
    VISUALIZATION_KEY: 'Visualización',
    CLONING_REQUESTED_KEY: 'Clonación solicitada',
    CLONING_STARTED_KEY: 'Clonación iniciada',
    CLONING_FINISHED_KEY: 'Clonación finalizada',
    CLONING_FAILED_KEY: 'Clonación fallida',

    SHORT_WEEK_DAYS_KEY: 'D, L, M, M, J, V, S',

    // Errors
    UNEXPECTED_ERROR: 'Se ha producido un error inesperado',
    OPERATOR_IS_BLOCKED: 'Operador bloqueado',
    OPERATOR_DOES_NOT_EXIST: 'Operador no existe',
    MULTICLOUD_PROVIDER_NOT_SUPPORTED:
      'Los entornos de proveedores multicloud no admiten servidores',

    BOOT_VOLUME_KEY: 'Volumen de Boot',
    BOOT_VOLUME_BACKUP_KEY: 'Backup del Volumen de Boot',
    CUSTOM_IMAGE_KEY: 'Imagen Personalizada',

    CHANGES_SAVED: '¡Cambios guardados con éxito!',
    LIST_USERS_EXPORT_FILENAME: 'Lista_de_Usuarios',
    LIST_HISTORY_SESSION_EXPORT_FILENAME: 'Lista_de_historial_de_sesiones',

    // Coutries
    BRAZIL_KEY: 'Brasil',
    SPAIN_KEY: 'España',
    USA_KEY: 'Estados Unidos',

    LANGUAGES: {
      PORTUGUESE_KEY: 'Portugués',
      ENGLISH_KEY: 'Inglés',
      SPANISH_KEY: 'Español',
    },
    ROLE_KEY: 'Role',
    ROLES: {
      SUPERADMIN_KEY: 'Súper admin Skyone',
      ADMIN_KEY: 'Admin Skyone',
      OPERATOR_KEY: 'Operador Skyone',
      CLIENT_OPERATOR_KEY: 'Operador cliente',
    },

    SESSION_EXPIRED:
      'Su sesión ha caducado o el token no es válido. Por favor, inicie la sesión nuevamente.',
    EXPIRED_SESSION_MODAL: {
      TITLE: '¡Sesión expirada!',
      HEADER: 'Su sesión ha expirado',
      MESSAGE: 'Será redirigido a la pantalla de inicio de sesión.',
      BUTTON_LABEL: 'OK',
    },

    CODE_NOT_FOUND: 'Código não encontrado',
    EXPIRED_CODE:
      "Código expirado. Solicite un nuevo enlace de registro de contraseña haciendo clic en 'He olvidado mi contraseña'",

    UPDATE_MODAL: {
      MODAL_VERSION_TITLE_KEY: 'Bienvenido a Autosky',
      MODAL_VERSION_CONTENT_KEY:
        'Bienvenido al panel de administración de Autosky. Haga clic en el botón de abajo para continuar.',
      MODAL_BUTTON_KEY: 'OK',
    },

    BACK_SELECTED_COMPANY_KEY: 'Cambiar compañía',
    DO_NOT_SELECT_PARTNER_KEY: 'No seleccione cuenta',
    DO_NOT_SELECT_COMPANY_KEY: 'No seleccione compañía',
    DO_NOT_HAVE_DASHBOARD_KEY: 'Aún no tienes elementos en tus favoritos',
    TO_LIST_SELECT_COMPANY_AND_PARTNER_KEY:
      'Para ver la lista, seleccione una compañía y una cuenta',
    DO_NOT_HAVE_PERMISSIONS_KEY:
      'No tienes permiso para acceder a esta funcionalidad. Póngase en contacto con el administrador.',
    CREATE_ENVIRONMENT_COMPANY_AND_PARTNER_KEY:
      'Para crear un entorno seleccione una compañía y una cuenta',
    CREATE_CLIENT_COMPANY_AND_PARTNER_KEY:
      'Para crear un cliente seleccione una compañía y una cuenta',
    TO_LIST_SELECT_COMPANY_KEY: 'Para ver la lista, seleccione una compañía',
    SELECT_COMPANY_KEY: 'Seleccione una compañía',

    // TopBar
    NOTIFICATIONS_KEY: 'Notificaciones',
    ACTIVITY_LOG_KEY: 'Registro de actividades',
    OPEN_TICKET_KEY: 'Abrir llamado',
    INCREASE_RESOURCES_KEY: 'Aumentar los recursos',
    DOCUMENTATION_KEY: 'Documentación',
    TUTORIAL_KEY: 'Tutorial Autosky',
    REQUEST_SUPPORT_KEY: 'Solicitar soporte',
    SEND_SUGGESTIONS_KEY: 'Enviar sugerencias',
    CONTRACT_LICENSES_KEY: 'Contratar licencias',
    CHANGE_REGION_KEY: 'Cambio de región',
    CHANGE_REGION_MSG_KEY: 'Iniciar sesión con contraseña y MFA',
    MY_PROFILE_KEY: 'Mi perfil',
    CHANGE_AVATAR_KEY: 'Cambiar avatar',
    LOGOUT_KEY: 'Finalizar sesión',
    LOGOUT_MSG_KEY: 'Su sesión será terminada. Confirmar para continuar',

    // SideBar
    PARTNER_TYPE_KEY: 'Tipo de cuenta',
    SIDEBAR: {
      MANAGE_COMPANIES_KEY: 'Gestionar compañías',
      COMPANIES_LIST_KEY: 'Listar compañías',
      ADD_COMPANY_KEY: 'Añadir compañías',

      MANAGE_PARTNERS_KEY: 'Gestionar cuentas',
      PARTNERS_LIST_KEY: 'Listar cuentas',
      ADD_PARTNER_KEY: 'Añadir cuenta',

      MANAGE_ENVIRONMENTS_KEY: 'Gestionar entornos',
      ENVIRONMENTS_LIST_KEY: 'Listar entornos',
      ADD_ENVIRONMENT_KEY: 'Añadir entorno',

      MANAGE_CLIENTS_KEY: 'Gestionar clientes',
      CLIENTS_LIST_KEY: 'Listar clientes',
      ADD_CLIENT_KEY: 'Añadir cliente',

      MANAGE_OPERATORS_KEY: 'Gestionar operadores',
      OPERATORS_LIST_KEY: 'Listar operadores',
      ADD_OPERATOR_KEY: 'Añadir operador',

      MANAGE_ADVISORS_KEY: 'Gestionar optimizaciones',
      ADVISORS_LIST_KEY: 'Listar optimizaciones',

      MANAGE_GROUPS_KEY: 'Gestionar grupos',
      GROUPS_LIST_KEY: 'Listar grupos',
      ADD_GROUP_KEY: 'Añadir grupo',
      OPTIMIZATION_DASHBOARD_KEY: 'Dashboard de optimizaciones',
      MANAGEMENT_KEY: 'Administración',
      OPERATORS_AND_PERMISSIONS_KEY: 'Operadores y permisos',
    },

    // Dialogs
    LAST_ACCESS_KEY: 'Últimos accesos',
    LAST_ACCESS_SINGULAR_KEY: 'Último aceso',
    LIST_GENERAL_KEY: 'Listado general',
    SINGLE_CORPORATE_NAME_KEY: 'Razón social',

    CHOOSE_COMPANY_KEY: 'Elija una compañía',
    NEW_COMPANY_KEY: 'Nueva compañía',
    SEARCH_COMPANY_KEY: 'Buscar compañía',

    CHOOSE_PARTNER_KEY: 'Elija una cuenta',
    NEW_PARTNER_KEY: 'Nueva cuenta',
    SEARCH_PARTNER_KEY: 'Buscar cuenta',

    CHOOSE_CLIENT_KEY: 'Elige un cliente',

    CHOOSE_ENVIRONMENT_KEY: 'Elige un ambiente',

    // Cloud providers
    AMAZON_WEB_SERVICES_KEY: 'Amazon Web Services',
    AMAZON_WEB_SERVICES_CONFIRM_KEY:
      '¡Configuración Amazon Web Services completada con éxito!',
    GOOGLE_CLOUD_PLATFORM_KEY: 'Google Cloud Platform',
    GOOGLE_CLOUD_PLATFORM_CONFIRM_KEY:
      '¡Configuración Google Cloud Platform completada con éxito!',
    ORACLE_CLOUD_KEY: 'Oracle Cloud Infrastructure',
    ORACLE_CLOUD_CONFIRM_KEY:
      '¡Configuración Oracle Cloud Infrastructure completada con éxito!',

    // Fields
    MUST_BE_A_NUMBER_KEY: 'Este campo debe ser un número',
    LAST_LOGIN_DATE_KEY: 'Último acceso',
    STATUS_MFA_CONFIGURED_KEY: 'MFA',
    STATUS_MFA_CONFIGURED_ACTIVE_KEY: 'Activo',
    STATUS_MFA_CONFIGURED_INACTIVE_KEY: 'Inactivo',
    STATUS_MFA_CONFIGURED_PENDING_KEY: 'Pendiente',
    STATUS_OPERATOR_ACTIVE_KEY: 'Activo',
    STATUS_OPERATOR_BLOCKED_KEY: 'Bloqueado',
    LOGIN_DATE_KEY: 'Inicio de sesión',
    LOGOUT_DATE_KEY: 'Cierre de sesión',
    IP_ORIGIN_KEY: 'IP de origen',
    IP_DESTINY_KEY: 'IP destino',
    IPS_VALID_KEY: 'IPs válidas',
    TERMINATE_RATE_KEY: 'Motivo de terminación',
    EMAIL_KEY: 'E-mail',
    PASSWORD_KEY: 'Contraseña',
    YOUR_PASSWORD_KEY: 'Su contraseña',
    CURRENT_PASSWORD_KEY: 'Contraseña actual',
    NEW_PASSWORD_KEY: 'Nueva contraseña',
    CONFIRM_NEW_PASSWORD_KEY: 'Confirme la nueva contraseña',
    PASSWORD_NOT_MATCH_KEY: 'La contraseña no coincide',
    FORGOT_PASSWORD_KEY: 'He olvidado mi contraseña',
    EMAIL_INVALID_KEY: 'E-mail inválido',
    NUMBER_INVALID_KEY: 'Número inválido',
    REQUIRED_FIELD_KEY: '¡Campo obligatorio!',
    NOT_HEX_FIELD_KEY:
      'Este valor no es válido, introduzca un valor hexadecimal',
    PASSWORD_MIN_LENGTH_OPERATOR_KEY: 'Escriba al menos 8 caracteres',
    PASSWORD_MAX_LENGTH_OPERATOR_KEY: 'Escriba al menos 32 caracteres',
    LAST_ONE_CAPITAL_LETTER_KEY:
      'La contraseña debe tener al menos una letra mayúscula',
    MUST_CONTAIN_AT_LEST_ONE_NUMBER_KEY:
      'La contraseña debe contener al menos un número',
    MUST_CONTAIN_AT_LEST_ONE_SPECIAL_KEY:
      'Debe contener al menos un caractere especial',
    PASSWORD_MIN_LENGTH_KEY: 'Escriba al menos 6 caracteres',
    PASSWORD_MAX_LENGTH_KEY: 'Escriba al menos 20 caracteres',
    ONLY_NUMBERS_KEY: 'Este campo sólo acepta números',
    ONLY_LETTERS_KEY: 'Este campo sólo acepta letras',
    EMAIL_NOTIFICATION_KEY: '¿Desea recibir comunicaciones por este e-mail?',
    MIN_NUMBER_CANNOT_BE_LESS_THAN_ONE_KEY:
      'El número mínimo de dígitos no puede ser inferior a 1',
    EMAIL_FICTITIOUS_KEY: '¿E-mail ficticio?',
    IS_INTEGRATION_USER_KEY: '¿Usuario de integración?',
    DATE_GREATER_THAN_START_DATE_KEY:
      'La fecha debe ser mayor que la fecha de inicio',
    ENTER_YOUR_PASSWORD_BELOW_KEY: 'Escriba su contraseña a continuación',

    // Links
    PRIVACY_POLICY_KEY: 'Privacidad',
    CODE_OF_ETHICS_KEY: 'Ética y Conducta',

    // 404
    NOT_FOUND_PAGE: {
      TITLE_KEY: 'Página no encontrada',
      BUTTON_KEY: 'Volver a la página de inicio',
    },

    // Login
    LOGIN_PAGE: {
      SUBTITLE_KEY: 'Iniciar sesión con correo electrónico y contraseña',
      DESCRIPTION_KEY: 'Su jornada para la nube.',
    },
    INVALID_CREDENTIALS:
      '¡El correo electrónico o la contraseña del operador no coinciden!',
    CONFIGURE_MFA_KEY: 'Configurar código de autenticación MFA',
    INSERT_MFA_CODE_KEY: 'Ingrese su código de autenticación MFA',
    AUTHENTICATION_CODE_KEY: 'Código de autenticación',
    INVALID_MFA_CODE: 'Código de autenticación inválido',

    // Reset password
    RESET_PASSWORD_PAGE: {
      TITLE_KEY: '¿Olvidaste tu contraseña?',
      SUBTITLE_KEY: 'Ingrese su e-mail para iniciar la recuperación.',
      DESCRIPTION_KEY:
        'Ingrese su correo electrónico y haga clic en Recuperar para recibir un correo electrónico de restablecimiento de contraseña.',
    },

    // Register password
    REGISTER_PASSWORD_PAGE: {
      TITLE_KEY: 'Introduzca su nueva contraseña',
      SUBTITLE_KEY:
        'Contraseñas de al menos 10 caracteres, con números y caracteres especiales.',
      DESCRIPTION_KEY:
        'Ingrese su nueva contraseña al lado. Utilice letras, números y caracteres especiales para aumentar la seguridad.',
    },

    // Partners
    ADD_PARTNER_KEY: 'Añadir cuenta',
    PARTNER_NAME_KEY: 'Nombre de la cuenta',
    OPERATOR_VIEW_PARTNER_NAME_KEY: 'Cuenta',
    PARTNER_LANGUAGE_KEY: 'Idioma de la cuenta',
    ALIAS_KEY: 'Alias',
    LDAP_TOOLTIP_KEY: 'Aquí se debe incluir la configuración para acceder a AD',
    NOT_USE_AT_SIGN_KEY: "No es necesario agregar '@' en este campo",
    LDAP_EXTERNAL_KEY: 'LDAP externo',
    CLOUD_KEY: 'Cloud',
    USE_FRONT_KEY: 'Utilizar el front nuevo',
    PARTNER_BLOCKED_SUCCESSFULLY_KEY: '¡Cuenta bloqueada con éxito!',
    PARTNER_UNBLOCKED_SUCCESSFULLY_KEY: '¡Cuenta desbloqueada con éxito!',
    SUCCESS_PARTNER_EDIT_KEY: '¡Cuenta editada con éxito!',
    NO_PARTNER_KEY: '¡Ningún partner encontrado!',

    PARTNER_PAGE: {
      NOT_EQUAL_COLOR_MAIN_KEY:
        'Este color no puede ser igual al color primario',
      PUBLIC_CUSTOM_KEY: 'Publicar personalizaciones',
      PUBLIC_CUSTOM_MSG_KEY: '¿Quieres publicar la personalización?',
      CUSTOM_STATUS_NOT_DEFINE_KEY: 'No definido',
      CUSTOM_STATUS_PUBLICATION_KEY: 'Estado de publicación personalizado',
      HAS_DRAFT_KEY: 'Tienes un borrador guardado',
      SAVE_DRAFT_TITLE_KEY: 'Guardar borrador',
      SAVE_DRAFT_DESCRIPTION_KEY:
        'El borrador le permite guardar su edición, para que pueda volver más tarde',
      MANUAL_COLORS_KEY: 'Manual de edición de color',
      FIRST_COLOR_TITLE_KEY: '1. El color del texto principal: ',
      SECOND_COLOR_TITLE_KEY: '2. El color primario: ',
      THIRD_COLOR_TITLE_KEY: '3. El color de los botones de inicio de sesión: ',
      FOUR_COLOR_TITLE_KEY: '4. Los colores del banner de inicio de sesión: ',
      FIVE_COLOR_TITLE_KEY: '5. Los colores del texto del mensaje: ',
      SIX_COLOR_TITLE_KEY: '6. Los colores de texto al pasar el mouse: ',
      FIRST_COLOR_KEY:
        'Cambia el color de los títulos de las tarjetas en la lista de entornos en el panel de control.',
      SECOND_COLOR_KEY:
        'Es el principal responsable de la identidad visual. Cambia los colores de títulos, fondos de imágenes, entre otros.',
      THIRD_COLOR_KEY:
        'Cambia el fondo del botón de inicio de sesión. Al igual que el mfa y el botón de recuperación de contraseña.',
      FOUR_COLOR_KEY:
        'Cambiar el fondo de los banners de pantalla de inicio de sesión, mfa y recuperación de contraseña.',
      FIVE_COLOR_KEY: 'Cambie los mensajes de advertencia del sistema.',
      SIX_COLOR_KEY:
        'Cambie el color del título de las tarjetas en la lista de entornos al pasar el mouse.',
      CUSTOM_FRONT_PARTNER: 'Personalizar front de cuenta',
      CUSTOM_FRONT_PARTNER_NAME: 'Personalizar front de cuenta - {{name}}',
      LOGO_PARTNER_KEY: 'Logotipo de la cuenta (L: 150 x A: 101)',
      IMAGE_LOGIN_BANNER_KEY: 'Banner de inicio de sesión (L: 630 x A: 960)',
      COLORS_BANNER_IMAGE_HELP_TEXT_KEY:
        'Color de la imagen de inicio de sesión',
      BACKGROUND_IMAGE_HELP_TEXT_KEY:
        'Imagen de fondo de la pantalla de inicio de sesión',
      MESSAGES_IMAGE_HELP_TEXT_KEY:
        'Imagen de fondo para las pantallas de notificaciones y mensajes',
      TEXT_HOVER_COLOR_HELP_TEXT_KEY:
        'Color del texto al pasar el ratón por encima de los entornos',
      USE_EXAMPLE_KEY: 'Ejemplo de uso',
      RESET_IMAGES_KEY: 'Restablecer imágenes',
      TEXT_PRINCIPAL_COLOR: 'Color del texto principal',
      PRIMARY_COLOR_KEY: 'Color primario',
      PARTNER_DELETED_KEY: '¡Cuenta eliminada con éxito!',
      LOGIN_BUTTONS_COLORS_KEY: 'Color de los botones de inicio de sesión',
      COLORS_BANNER_IMAGE: 'Iniciar sesión con los colores del banner',
      MSG_COLORS_KEY: 'Colores del texto del mensaje',
      COLOR_HOVER_TEXT_KEY: 'Colores de texto al pasar el mouse',
      TITLE_KEY: 'Título',
      LOGIN_FONT_SIZE_KEY: 'Tamaño de fuente de inicio de sesión',
      DESCRIPTION_FONT_SIZE_KEY: 'Tamaño de fuente de descripción',
      CONNECT_TEXT_TITLE_KEY: 'Prueba de conexión: Active Directory',
      CONNECT_TEXT_MSG_KEY: '¡Conectado correctamente!',
      EDIT_COMPANY_WARNING: 'Edición de compañía',
      CHANGE_COMPANY_KEY: 'Los cambios serán aplicados en la compañía {{name}}',
      ADD_NEW_PARTNER_KEY: 'Añadir cuenta',
      LDAP_SUCCESS_KEY: '¡LDAP guardado con éxito!',
      SEARCH_PARTNER_KEY: 'Introduzca el nombre de la cuenta',
      INIT_INCLUSION_PARTNER_KEY: 'Complete los datos para incluir la cuenta',
      LIST_PARTNER_KEY: 'Lista de cuentas',
      LIST_PARTNER_AVAILABLE_KEY: 'Lista de cuentas disponibles para consulta',
      EDIT_PARTNER_KEY: 'Editar cuenta',
      EDIT_BLOCK_KEY: 'Bloquear cuenta',
      EDIT_UNBLOCK_KEY: 'Desbloquear cuenta',
      REMOVE_PARTNER_KEY: 'Eliminar cuenta',
      REMOVE_PARTNER_DESCRIPTION_KEY: 'La cuenta {{name}} será eliminada.',
      NONE_PARTNER_KEY: 'No se ha encontrado ninguna cuenta.',
      REMOVE_PARTNER_QUESTION_KEY: '¿Desea eliminar la cuenta {{name}}?',
      CLOUD_PROVIDER_PARTNER_KEY: 'Seleccione un proveedor de nube asociado',
      SELECT_LDAP_PARTNER_KEY: 'Seleccione el tipo de LDAP de la cuenta',
      SELECT_INTERFACE_USE_PARTNER_KEY:
        'Seleccione el uso de la interfaz de uso.',
      USER_NEW_FRONT_KEY: '¿Utilizar la nueva interfaz?',
      CUSTOMER_EMAIL_KEY: '¿Utilizar el e-mail personalizado?',
      CUSTOMER_PLUGIN_KEY: '¿Utilizar plugin personalizado?',
      TEMPLATE_EMAIL_PARTNER_KEY: 'Plantilla de e-mail',
      TEMPLATE_AVAILABLE_PARTNER_KEY: '¿Desea activar esta plantilla?',
      SELECT_TEMPLATE_PARTNER_KEY: 'Elija la plantilla',
      SUBJECT_EMAIL_PARTNER_KEY: 'Asunto del e-mail',
      ADD_NEW_PARTNER_QUESTION_KEY:
        '¿Desea crear la cuenta {{name}} en la compañía {{company}}?',
      EDIT_PARTNER_QUESTION_KEY:
        '¿Desea editar la cuenta {{name}} en la compañía {{company}}?',
      EDIT_PARTNER_DATA_KEY: 'Rellene los datos para editar la cuenta',
      USE_NEW_FRONT_KEY: 'Utilizar front nuevo',
      NEW_FRONT_CONFIGURATION_KEY: 'Configuración del Portal 2.0',
      ENABLE_NEW_FRONT_KEY: 'Habilitar Portal 2.0',
      ENABLE_NEW_FRONT_MIGRATION_KEY: 'Habilitar migración al Portal 2.0',
      ENABLE_NEW_FRONT_MIGRATION_CONFIRMATION_KEY:
        'Al habilitar la migración al Portal 2.0, la migración se considerará automáticamente finalizada si todos los usuarios acceden al nuevo portal antes de la fecha de migración. ¿Desea continuar?',
      NEW_FRONT_MIGRATION_DEADLINE_KEY: 'Fecha límite de migración',
      ENABLE_NEW_FRONT_EXPLANATION_KEY:
        'Al activar esta opción, los usuarios de esta cuenta serán redirigidos exclusivamente al Portal 2.0.',
      ENABLE_NEW_FRONT_MIGRATION_EXPLANATION_KEY:
        'Programe la activación del Portal 2.0 para esta cuenta, notificando a los usuarios sobre la migración y proporcionando acceso a la nueva plataforma. Si todos los usuarios acceden al Portal 2.0 antes de la fecha final, la migración se considerará completada.',
      NEW_FRONT_MIGRATION_DEADLINE_EXPLANATION_KEY:
        'Fecha final de la migración; después de esta fecha, la migración se considerará completada.',
      OPERATOR_VIEW_NEW_FRONT_KEY: 'Front nuevo',

      BLOCK_PARTNER_TITLE_KEY: '¿Desea bloquear la cuenta?',
      BLOCK_PARTNER_DESCRIPTION_KEY: 'La cuenta {{name}} será bloqueada.',
      UNBLOCK_PARTNER_TITLE_KEY: '¿Desea desbloquear la cuenta?',
      UNBLOCK_PARTNER_DESCRIPTION_KEY: 'La cuenta {{name}} será desbloqueada.',

      MAINTENANCE_MESSAGES_KEY:
        'Advertencia de mantenimiento (L: 1382 x A: 596)',
      MESSAGE_IMAGES_KEY: 'Mensaje (L: 1382 x A: 596)',
      FAVICON_KEY: 'Favicon (64 x 64)',
      DRAG_AND_DROP_KEY:
        'Arrastra y suelta una imagen aquí o haz clic para seleccionar',
      HIGHLIGHT_COLOR_KEY: 'Color de acento principal',
      ENVIRONMENT_TITLE_COLOR_KEY: 'Color del título de los entornos',
      MESSAGES_BUTTON_COLOR_KEY: 'Color del botón de la pantalla del mensaje',
      MESSAGES_BUTTON_COLOR_HOVER_KEY:
        'Color del botón de la pantalla de mensajes al pasar el ratón',
      SUCCESS_SAVE_KEY: 'Configuración guardada correctamente',
      SUCCESS_PUBLISH_KEY: 'Publicación realizada con éxito',

      SSO_DEACTIVATED_TOGGLE: 'Permite configurar SSO',
      DUO_DEACTIVATED_TOGGLE: 'Permite configurar DUO',
      SSO_KEY: 'SSO',
      DUO_KEY: 'DUO',
      SUCCESS_CREATE_ACCOUNT: 'Cuenta registrada correctamente!',
      SUBDOMAIN_KEY: 'Subdominio',
      USE_CUSTOM_THEME_KEY:
        'Para utilizar esta funcionalidad, es necesario tener registrado un alias único',
      DELETE_CUSTOM_BUTTON_KEY: 'Borrar personalización',
      DELETE_CUSTOM_SUBTEXT_KEY:
        'Al confirmar la eliminación, se borrarán todos los datos de personalización: dirección de página personalizada, subdominio, título, colores, imágenes y tamaños de fuente.',
      DELETE_CUSTOM_TEXT_KEY:
        'Para confirmar la eliminación, introduce tu contraseña de operador en el siguiente campo:',
      DELETE_CUSTOM_MODAL_TITLE_KEY: 'Eliminar personalización de {{name}}',
      DELETE_CUSTOM_SUCCESS_KEY: 'Personalización eliminada correctamente',
      LOGO_BACKGROUND_COLOR_KEY: 'Color de fondo del logotipo',
      NO_TEXT_KEY: 'Sin texto',
      CLONE_PARTNER_KEY: 'Clonar cuenta',
      CLONE_PARTNER_NAME_KEY: 'Nuevo nombre da cuenta',
      CLONE_PARTNER_OBSERVATION_KEY:
        'Al clonar una cuenta, solo se copian las configuraciones. Los entornos, clientes, usuarios, personalizaciones de la interfaz y configuración de alias no se replican en la cuenta clonada.',
      CHANGE_AD_PASSWORD_KEY: 'Cambiar contraseña de usuario AD',
      CHANGE_DUO_CLIENT_SECRET_KEY: 'Cambiar Client Secret',
      CHANGE_AD_PASSWORD_CONFIRMATION_KEY:
        'Para confirmar el cambio de contraseña, ingrese el motivo de la acción y su contraseña en los campos a continuación',
      NEW_AD_PASSWORD_LABEL_FIELD_KEY:
        'Ingrese la nueva contraseña de usuario AD',
      ADMIN_BIND_PASS_KEY: 'Contraseña de usuario de AD',
      ADMIN_DN_KEY: 'Usuario AD',
      AD_DOMAIN_KEY: 'Dominio de usuario de AD',
      DOMAIN_TYPE_KEY: 'Tipo de dominio',
      SUBDOMAIN_OPTION_KEY: 'Subdominio',
      FULL_DOMAIN_OPTION_KEY: 'Dominio completo',
      FULL_DOMAIN_KEY: 'Dominio completo',
    },

    // Environments
    ENVIRONMENT_NAME_KEY: 'Nombre del entorno',
    OPERATOR_VIEW_ENVIRONMENT_NAME_KEY: 'Entorno',
    ENVIRONMENT_ID_KEY: 'ID  del entorno',
    PROJECT_ID_SKY_KEY: 'ID del proyecto Easy.Sky',
    REGION_KEY: 'Región',
    COMPARTMENT_ID_KEY: 'ID del compartimiento',
    MODE_KEY: 'Modo',
    LICENSES_KEY: 'Licencias',
    ACTIVE_BEHAVIOR_KEY: 'Activos',
    STOPPED_BEHAVIOR_KEY: 'Parados',
    ON_DEMAND_BEHAVIOR_KEY: 'Bajo demanda',
    PARTNER_KEY: 'Cuenta',
    MARGIN_KEY: 'Margen',
    MARGIN_PERCENT_KEY: 'Margen (porcentaje)',
    PROVIDER_CLOUD_KEY: 'Proveedor Cloud',
    MODEL_TOOLTIP_KEY: 'Configuración principal utilizada por las instancias.',
    MODEL_TOOLTIP_BACKUP_KEY:
      'Configuración alternativa utilizada cuando hay problemas para asignar máquinas del Modelo primario.',
    MODEL_TOOLTIP_SPOT_KEY:
      'Configuración utilizada por las instancias SPot del proveedor Amazon Web Services.',
    PROVIDER_CLOUD_TOOLTIP_KEY:
      'Estas opciones definen qué configuraciones se aplicarán a las instancias activadas a través del autoescalado, como sabores, zonas de disponibilidad, AMI, entre otros.',
    CONNECTION_TYPE_TOOLTIP: 'Tipo de conexión proveedor público/privado',
    ZONE_DEFAULT_TOOLTIP: 'Zona del servidor por defecto',
    PUBLICATIONS_KEY: 'Publicaciones',
    PUBLICATION_ALREADY_IN_PROGRESS:
      'Ya hay una publicación de imágenes en curso',
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_KEY: 'Bloquear / desbloquear instancias',
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_MSG_KEY:
      'Las instancias seleccionadas serán bloqueadas / desbloqueadas',
    SCHEDULE_PUBLICATIONS_KEY:
      'Programación de bloqueo de instancias con versiones antiguas de modelo',
    SCHEDULE_PUBLICATIONS_TOOLTIP_KEY:
      'La programación afectará solo a las instancias con versiones antiguas de modelo, sin afectar a las instancias con versiones actuales de modelo.',
    PERCENTAGE_SPOT_KEY: 'Porcentaje SPOT',
    TOTAL_LICENSES_KEY: 'Total de licencias',
    FAST_DETAILS_KEY: 'Detalles rápidos',
    REMOVE_ENVIRONMENT_KEY: 'Eliminar entorno',
    ADD_MODEL_KEY: 'Añadir modelo',
    REMOVE_MODELS_SELECTED_KEY: 'Eliminar modelos seleccionados',
    BASE_NAME_KEY: 'Nombre base',
    BACKUP_SECONDARY_KEY: 'Secundario',
    MODEL_PRIMARY_KEY: 'Primario',
    VERSION_KEY: 'Versión',
    ACTIVE_INSTANCES_KEY: 'Instancias activas',
    CONNECTED_USERS_KEY: 'Usuarios conectados',
    CREATE_MODEL_KEY: 'Crear modelo',
    EDIT_MODEL_KEY: 'Editar modelo',
    SECURITY_TAGS_KEY: 'Etiquetas de seguridad',
    TEMPERATURE_REFERENCE_KEY: 'Temperatura de referencia',
    KEY_PAIR_KEY: 'Key pair',
    SECURITY_GROUP_KEY: 'Grupo de seguridad',
    CREDIT_SPECIFICATIONS_KEY: 'Especificaciones de crédito',
    MEMORY_MAX_KEY: 'Máximo de memoria',
    CPU_MAX_KEY: 'Máximo de CPU',
    CONNECTION_MAX_KEY: 'Máximo de conexiones',
    EMPTY_KEY: 'Vacío',
    TURNED_OFF_KEY: 'Apagada',
    OFF_KEY: 'Apagado',
    OPERATIONAL_KEY: 'Operativo',
    TOP_KEY: 'Superior',
    BOOT_TIME_KEY: 'Tiempo de boot',
    ACTIVE_INSTANCE_KEY: 'Activar instancia',
    REGISTER_INSTANCE_KEY: 'Registrar instancia',
    TERMINATE_INSTANCE_KEY: 'Terminar instancia',
    REMOVE_INSTANCE_KEY: 'Eliminar instancia',
    BLOCK_INSTANCE_KEY: 'Bloquear instancia',
    UNBLOCK_INSTANCE_KEY: 'Desbloquear instancia',
    PUBLIC_IP_KEY: 'IP público',
    PRIVATE_IP_KEY: 'IP privado',
    MONITOR_KEY: 'Monitor',
    ALARMS_LOGS_KEY: 'Alarmas / registros',
    ALARMS_KEY: 'Alarmas',
    SEARCH_INSTANCE_KEY: 'Buscar instancia',
    REMOVE_SESSION_KEY: 'Eliminar sesión',
    FINISH_SESSION_KEY: 'Cerca sesión',

    MANUAL_KEY: 'Manual',
    TYPE_MANUAL_KEY: 'Manual - Obsoleto',
    TYPE_ROBOT_PERIOD_KEY: 'Robot - Períodos - Obsoleto',
    TYPE_ROBOT_PERIOD_SPOT_KEY: 'Robot - Períodos (Spot) - Obsoleto',
    TYPE_ROBOT_MICRO_KEY: 'Robot - Micro - Obsoleto',
    TYPE_DEDICATED_KEY: 'Dedicado',
    TYPE_SHARED_KEY: 'Compartido',
    TYPE_HAAS_KEY: 'HaaS - Obsoleto',
    TYPE_CCC_KEY: 'CCC - Obsoleto',
    MICRO_KEY: 'Micro',
    SPOT_KEY: 'Spot',
    MODEL_BACKUP_KEY: 'Modelo secundario',
    MODEL_SPORT_KEY: 'Modelo spot',
    PRIMARY_ZONE_KEY: 'Zona primaria',
    SECONDARY_ZONE_KEY: 'Zona secundaria',
    ZONE_DEFAULT_KEY: 'Zona estándar',
    CONNECTION_TYPE_KEY: 'Tipo de conexión',
    REGION_DEFAULT_KEY: 'Región predeterminada',
    FILE_KEY: 'Archivo',
    QUALITY_KEY: 'Calidad',
    HIGH_KEY: 'Alta',
    DEFAULT_KEY: 'Estándar',
    LOW_KEY: 'Baja',
    ACCESS_PUBLIC_KEY:
      'Acceso público (mediante IP pública a través de internet)',
    PRIVATE_PUBLIC_KEY:
      'Acceso privado (mediante IP privada a través de una VPN o conexión privada)',

    USERS_ADMIN_KEY: 'Usuarios administrativos',
    STATE_OPERATIONAL_KEY: 'Estado operativo',
    AVERAGE_MEMORY_USAGE_KEY: 'Uso medio de memoria',
    AVERAGE_CPU_USAGE_KEY: 'Uso medio de CPU',
    AVERAGE_DISK_USAGE_KEY: 'Uso medio de disco',
    TOTAL_INSTANCES_KEY: 'Total de instancias',
    TOTAL_LICENSES_USAGE_KEY: 'Licencias en uso',
    TOTAL_SESSIONS_KEY: 'Total de sesiones',
    TOTAL_LICENSES_CONTRACT_KEY: 'Licencias contratadas',
    LICENSES_AVAILABLE_KEY: 'Licencias disponibles',
    IMAGE_PUBLICATION_TYPE_KEY: 'Tipo de publicación de imagen',
    MAX_PUBLICATIONS_KEY: 'Límite de publicación mensual',
    MAX_DAILY_PUBLICATIONS_KEY: 'Límite de publicación diaria',
    TOTAL_PUBLICATIONS_KEY: 'Número de publicaciones mensuales ya realizadas',
    TOTAL_DAILY_PUBLICATIONS_KEY:
      'Número de publicaciones diarias ya realizadas',
    PUBLICATIONS_OLD_INSTANCES_KEY:
      '¿Bloquear instancias con versiones de modelos anteriores?',
    BLOCK_TIME_KEY: 'Tiempo de bloqueo',
    REGISTER_THROUGH_KEY: 'Registro a través',
    REGISTER_MODE_KEY: 'Modo de registro',
    BEHAVIOR_KEY: 'Comportamiento',
    PRODUCT_TYPE_KEY: 'Tipo de entorno',
    ADVANCED_KEY: 'Avanzado',
    SECURITY_KEY: 'Seguridad',
    SCHEDULER_KEY: 'Planificador',
    GOVERNANCE_KEY: 'Gobernanza',

    ADD_SERVER_PREPARATION_KEY: 'Añadir el servidor de preparación ',
    ADD_SERVER_PREPARATION_SUBTITLE_KEY:
      'Introduzca los datos de la instancia para añadirla como servidor de preparación del entorno {{environment}}.',
    ADD_SERVER_SUPPORT_KEY: 'Añadir servidor de soporte',
    ADD_SERVER_SUPPORT_SUBTITLE_KEY:
      'Introduzca los datos de la instancia para añadirla como servidor de soporte del entorno {{environment}}.',
    REMOVE_SERVER_SELECTED_KEY: 'Desvincular servidores seleccionados',
    START_INSTANCE_KEY: 'Iniciar instancia',
    INSTANCE_NAME_KEY: 'Nombre de la instancia',
    INSTANCE_ID_KEY: 'ID de la instancia',
    SCHEDULED_STOP_KEY: 'Parada programada',
    SCHEDULED_STOP_DATETIME_KEY: 'Fecha y hora de parada',
    CANCEL_SCHEDULED_STOP_KEY: 'Cancelar parada programada',
    DISABLE_SCHEDULED_STOP_KEY: 'Desactivar parada programada',
    EXTEND_EXECUTION_KEY: 'Extender la ejecución',
    INTERVAL_TIME_KEY: 'Intervalo de tiempo',
    GENERATE_IMAGES_STOP_KEY: 'Generar imágenes sin parar la instancia?',
    NEW_SCHEDULED_STOP_DATETIME_KEY: 'Nueva fecha y hora de parada',
    NEW_SCHEDULED_STOP_KEY: 'Nuevo horario de parada',
    NEW_SCHEDULED_STOP_SUBTITLE_KEY: 'Añadir una nueva parada programada',
    SCHEDULED_BLOCK_INSTANCES_KEY: 'Programar bloqueo de instancias',

    DATA_REFERENCE_LAST_TIME_KEY: 'Datos de la última hora',
    TOTAL_SESSIONS_ACTIVE_KEY: 'Sesiones activas',
    NUMBER_NEW_ACCESSES_KEY: 'Número de nuevos accesos',
    TOTAL_VACANCIES_KEY: 'Total de vacantes',

    WANT_START_SERVER_KEY: '¿Desea iniciar el servidor?',
    WANT_STOP_SERVER_KEY: '¿Desea parar el servidor?',

    WANT_TERMINATE_INSTANCE_KEY: '¿Desea terminar la instancia?',
    WANT_REMOVE_INSTANCE_KEY: '¿Desea eliminar la instancia?',
    WANT_TERMINATE_INSTANCE_DESCRIPTION_KEY:
      'La instancia {nombre}} terminará, esto puede tardar unos minutos.',

    WANT_START_INSTANCE_KEY: '¿Desea iniciar la instancia?',
    WANT_START_INSTANCE_DESCRIPTION_KEY:
      'La instancia I-0000 se iniciará, esto puede tardar unos minutos',
    WANT_REBOOT_INSTANCE_KEY: '¿Desea reiniciar la instancia?',
    WANT_REBOOT_SERVER_KEY: '¿Desea reiniciar el servidor?',
    WANT_STOP_INSTANCE_KEY: '¿Desea parar la instancia?',
    WANT_REBOOT_INSTANCE_DESCRIPTION_KEY:
      'La instancia {{name}} se reiniciará, esto puede tardar unos minutos',

    WANT_DELETE_MODEL_KEY: '¿Desea eliminar el modelo?',
    WANT_DUPLICATE_MODEL_KEY: '¿Desea duplicar el modelo?',
    WANT_DELETE_MODEL_DESCRIPTION_KEY: 'El modelo {{name}} será eliminado',
    WANT_LOGOUT_SESSION_KEY: '¿Desea cerrar la sesión?',
    MODEL_SUCCESSFULLY_REMOVED_KEY: '¡Modelo eliminado con éxito!',
    MODEL_SUCCESSFULLY_REGISTERED_KEY: '¡Modelo añadido con éxito!',
    MODEL_SUCCESSFULLY_EDITED_KEY: '¡Modelo editado con éxito!',

    ADD_MESSAGE_MAINTENANCE_KEY: 'Añadir mensaje de mantenimiento',
    ADD_MESSAGE_REMOVE_SESSION_KEY: 'Añadir mensaje de drenaje',
    START_ALERT_KEY: 'Iniciar mantenimiento',
    END_ALERT_KEY: 'Terminar mantenimiento',
    MANUAL_MAINTENANCE_KEY: 'Mantenimiento manual',
    TERMINATE_INSTANCES_KEY: 'Terminar instancias',
    TERMINATE_SESSIONS_KEY: 'Terminar sesiones',
    START_ENVIRONMENT_AT_KEY: 'Iniciar entorno a las',
    SCALING_KEY: 'Scaling',
    SERVER_SUP_KEY: 'Servidor SUP',
    PERCENTAGE_KEY: 'Porcentaje',
    TURNED_ON_KEY: 'Conectado',
    SUPPORT_SERVER_KEY: 'Servidor de soporte',
    STATUS_ENVIRONMENT_KEY: 'Estado del entorno',
    DISPLAY_TO_LOGGED_USERS_KEY:
      'Mostrar advertencia a los usuarios que han iniciado sesión',

    GOVERNANCE_INFORMATION_KEY: 'Gobernanza de la información',
    PROJECT_CODE_KEY: 'Código del proyecto (Zoho Projects)',
    PROJECT_TYPE_KEY: 'Tipo de proyecto',
    PRODUCTION_KEY: 'Producción',
    DEVELOPMENT_KEY: 'Desarrollo',
    DEPARTMENT_KEY: 'Departamento',
    IMPLEMENTATION_KEY: 'Implementación',
    OPERATION_KEY: 'Operación',
    RESPONSIBLE_TECHNICAL_KEY: 'Responsable técnico',
    TECHNICAL_PHONE_KEY: 'Teléfono Móvil del técnico',
    TECHNICAL_EMAIL_KEY: 'E-mail del técnico',
    TECHNICAL_EMAIL_PLACEHOLDER_KEY: 'ejemplo@email.com',
    RESPONSIBLE_IMPLEMENTATION_KEY: 'Responsable de la implementación.',
    CREATION_DATE_ENVIRONMENT_KEY: 'Fecha de creación del entorno',
    DELIVERY_DATE_ENVIRONMENT_KEY: 'Fecha de entrega del entorno ',
    COMMENTS_KEY: 'Comentarios',

    LICENSE_LIMIT_KEY: 'Limite de licenças',
    INTERFACE_KEY: 'Interfaz',
    SET_INTERFACE_KEY: 'Configurar la interfaz',
    USE_NEW_FRONT_KEY: 'Usar interfaz nueva',
    USE_OLD_FRONT_KEY: 'Usar interfaz antigua',
    USE_PARTNER_TENANCY_KEY: 'Usar tenancy de cuenta',
    USE_IOS_BY_DEFAULT_EXPLANATION_KEY:
      'Habilita el uso de dispositivos iOS solo para nuevos clientes',
    BLOCK_MULTIPLE_SESSIONS_EXPLANATION_KEY:
      'Con esta funcionalidad habilitada en el entorno, se bloquearán los intentos de inicio de sesión con el mismo usuario',
    UNIQUE_USER_SESSION_VALIDATION_EXPLANATION_KEY:
      'Con esta funcionalidad habilitada en el ambiente, los intentos de acceso usando la misma sesión de usuario serán bloqueados',
    USE_REMOTE_DNS_EXPLANATION_KEY:
      'Con esta funcionalidad habilitada, enmascarará la IP pública de las instancias de AutoSky, usando DNS',
    LICENSE_LIMIT_PER_CLIENT_EXPLANATION_KEY:
      'Con esta característica habilitada, será posible restringir la cantidad máxima de licencias que cada cliente puede usar',
    AUTO_INCREASE_LICENSES_EXPLANATION_KEY:
      'Con esta opción activada, el número total de licencias se incrementará temporalmente de forma automática con el valor indicado a continuación cuando se alcance el límite de uso (30 días).',
    AUTO_INCREASE_LICENSES_KEY:
      'Aumentar temporalmente las licencias de forma automática antes de alcanzar el límite',
    ALWAYS_ACTIVE_RESOURCE_KEY: 'Mantener siempre activada esta función',
    ALWAYS_ACTIVE_RESOURCE_TOOLTIP_KEY:
      'Con esta opción seleccionada, el recurso permanecerá siempre activo',
    INCREASE_LICENSES_BY_KEY: 'Aumentar el límite de licencias en:',
    LICENSE_LIMIT_PER_CLIENT_KEY: 'Límitar licencias por cliente',
    USE_REMOTE_DNS_KEY: '¿Usar DNS para la conexión remota?',
    USE_ALLOW_CLIENT_CONNECTION_TYPE_KEY:
      '¿Permitir el tipo de conexión por cliente?',
    USE_ALLOW_CLIENT_CONNECTION_TYPE_TOOLTIP_KEY:
      'Permite a los clientes elegir su propio tipo de conexión con el proveedor (pública o privada)',
    BLOCK_MULTIPLE_SESSIONS_KEY: '¿Bloquear varias sesiones del mismo usuario?',
    UNIQUE_USER_SESSION_VALIDATION_KEY: 'Validación de sesión de usuario',
    USE_IOS_BY_DEFAULT_KEY:
      'Habilitar el uso de dispositivos iOS para nuevos clientes',
    USE_IOS_DEVICES_KEY: '¿Usar dispositivos iOS?',
    LICENSE_LIMIT_MAX_KEY:
      'Este límite debe ser inferior al límite de licencias disponibles',

    DEFINE_PERIODS_TITLE_KEY: 'Establezca los periodos que desea configurar',
    DEFINE_PERIODS_SUBTITLE_KEY:
      'Es obligatorio elegir una de las siguientes opciones',
    DEFINE_PERIODS_SUBTITLE_ONE_KEY: 'Configura al menos uno de los períodos',
    IN_THE_WEEK_KEY: 'Durante la semana',
    ON_THE_SATURDAY_KEY: 'Los sábados',
    ON_THE_SUNDAY_KEY: 'Los domingos',
    ADD_COMMENT_TITLE_KEY: 'Añadir comentario',
    ADD_COMMENT_SUBTITLE_KEY: 'Comentarios sobre la configuración del entorno',
    ADD_COMMENT_KEY: 'Añadir comentario',

    USE_SPECIFIC_PASSWORD_KEY:
      '¿Usar una configuración de contraseña específica?',
    MINIMUM_PASSWORD_LENGTH_KEY:
      'Cantidad mínima de caracteres de la contraseña',
    REQUIRE_UPPERCASE_KEY: '● Requerido al menos una letra mayúscula',
    REQUIRE_LOWERCASE_KEY: '● Requerido al menos una letra minúscula',
    REQUIRE_NUMBER_KEY: '● Requerido al menos un carácter numérico',
    REQUIRE_SPECIAL_CHARACTER_KEY:
      '● Requerido al menos un caractere no alfanumérico',
    EXPIRATION_PASSWORD_KEY: '¿Habilitar la caducidad de la contraseña?',
    EXPIRATION_PASSWORD_DAYS_KEY: 'Expirar las contraseñas cada (días):',
    NUMBER_MAX_LOGIN_TRIES_KEY: 'Límites de intentos de inicio de sesión',
    BEHAVIOR_MESSAGE_KEY: 'Ajustes de comportamiento guardados correctamente',

    FILL_THE_REQUIRED_FIELDS_KEY: '¡Rellene los campos obligatorios!',
    FILL_THE_CORRECTLY_FIELDS_KEY: '¡Rellene los campos correctamente!',

    ENVIRONMENTS_SUCCESS_KEY: '¡Entorno eliminado con éxito!',
    ENVIRONMENT_SUCCESSFULLY_EDITED_KEY: '¡Entorno editado con éxito!',
    ADD_ENVIRONMENT_KEY: 'Añadir entorno',
    NO_ENVIRONMENT_KEY: '¡No se encontró ningún entorno!',

    ENVIRONMENTS_PAGE: {
      LIMIT_MSG_IMAGE_PUBLICATION_KEY:
        'Límite mensual alcanzado: Este entorno ha alcanzado el límite mensual de publicación de imágenes con bloqueo de instancia (manteniendo a los usuarios conectados). La publicación estándar sigue disponible.',
      LIMIT_DAILY_MSG_IMAGE_PUBLICATION_KEY:
        'Límite diario alcanzado: Este entorno ha alcanzado el límite diario de publicación de imágenes con bloqueo de instancia (manteniendo a los usuarios conectados). La publicación estándar sigue disponible.',
      BOTH_LIMIT_MSG_IMAGE_PUBLICATION_KEY:
        'Se han alcanzado los límites diario y mensual: Este entorno ha alcanzado el límite de publicación de imágenes diario y mensual con bloqueo de instancia (manteniendo a los usuarios conectados). La publicación estándar sigue disponible.',
      EXECUTED_MONTHLY_PUBLICATION_KEY: 'Publicaciones restantes (mensuales)',
      EXECUTED_DAILY_PUBLICATION_KEY: 'Publicaciones restantes (diarias)',
      ERROR_CONFIG_SERVER_KEY:
        'Error de configuración: Tu entorno no tiene una instancia configurada como servidor de aplicaciones, esto imposibilitará el funcionamiento del entorno',
      LOGS_PUBLICATION_KEY: 'Publicar registros',
      REMOVE_INSTANCES_WARNING_KEY:
        'Las instancias seleccionadas serán eliminadas',
      REMOVE_NOT_INSTANCES_WARNING_KEY:
        'No ha seleccionado instancias para finalizar',
      TERMINATE_MULTIPLE_INSTANCES_MSG_KEY:
        'Las instancias seleccionadas serán terminadas',
      BLOCK_MULTIPLE_INSTANCES_MSG_KEY:
        'Las instancias seleccionadas se bloquearán',
      UNBLOCK_MULTIPLE_INSTANCES_MSG_KEY:
        'Las instancias seleccionadas se desbloquearán.',
      REMOVE_MULTIPLE_MODELS_KEY: 'Los modelos seleccionados serán eliminados',
      REMOVE_MULTIPLE_MODELS_WARNING_KEY:
        'Ha seleccionado una plantilla primaria. Este elemento se mantendrá, los demás se eliminarán.',
      LOADING_OPTION_KEY: 'Carregando {{optionName}}...',
      NOT_HAVE_OPTION_KEY: 'No hay {{optionName}} disponible',
      TURN_INTO_APPLICATION_SERVER_KEY:
        'Convertirse en servidor de aplicaciones',
      TURN_INTO_APPLICATION_SERVER_MSG_KEY:
        'El servidor de soporte {{instanceId}} se convertirá en un servidor de aplicaciones',
      ALARMS_INSTANCE_NOT_FOUND:
        'No se encontraron alarmas para esta instancia',
      STOPPED_INSTANCE_KEY: 'Parado',
      ON_INSTANCE_KEY: 'Conectada',
      OPERATIONAL_INSTANCE_KEY: 'Operacional',
      BLOCKED_INSTANCE_KEY: 'Bloqueada',
      INACCESSIBLE_INSTANCE_KEY: 'Inaccessible',
      STOPPING_INSTANCE_KEY: 'Parando',
      ENDING_INSTANCE_KEY: 'Finalizando',
      INITIALIZING_INSTANCE_KEY: 'Inicializando',
      ACTIVATING_INSTANCE_KEY: 'Activando',
      INCLUDE_INSTANCE_LIKE_SERVER_APPLICATION:
        '¿Incluir instancia como servidor de aplicaciones?',
      SEARCH_FOR_LOGS: 'Buscar por registros',
      NOT_STOP_TIME_KEY: 'Servidor sin programación programada',
      MODEL_SUCCESSFULLY_DUPLICATE_KEY: 'Modelo duplicado con éxito',
      PUBLICATION_IDENTIFICATION: 'Identificación de publicación',
      PUBLICATION_IMAGE_INIT_KEY: 'Comenzó la publicación de imágenes',
      TYPE_PUBLICATION_KEY: 'Tipo de publicación',
      WANT_EXTEND_SERVER_KEY: '¿Desea ampliar la ejecución del servidor?',
      WANT_EXTEND_SERVER_MSG_KEY:
        'Su servidor se extenderá por 2 horas adicionales a partir del tiempo programado, o, en caso de que no haya un horario establecido, a partir del tiempo actual.',
      CREATE_BOOT_VOLUME: 'Creando boot volume',
      CHECK_BOOT_VOLUME: 'Verificando boot volume',
      CREATE_AMI: 'Creando imagen',
      CHECK_AMI: 'Verificando la imagen',
      REPLACE_INSTANCES: 'Calculando demandas',
      BLOCK_OLD_INSTANCES: 'Bloqueando instancias',
      SEND_MAIL_TASK: 'Enviando e-mail',
      WARN_USERS_AND_BLOCK_INSTANCES:
        'Advirtiendo a los usuarios y bloqueando las instancias.',
      CHECK_FIRST_OPERATIONAL_INSTANCE:
        'Comprobación de la operatividad de la instancia.',
      CHECK_IF_TEMPLATE_SERVER_IS_STOPPED:
        'Comprobando si la instancia de la plantilla está parada.',
      START_MULTIPLE_NEW_INSTANCES: 'Iniciando nuevas instancias',
      CHECK_MULTIPLE_INSTANCES_RESULT:
        'Verificando el inicio de nuevas instancias',
      KEEPUSERSCONNECTED: 'Mantener a los usuarios conectados',
      REQUESTING_USER_RECONNECTION_KEY: 'Solicitando reconexión de usuario',
      STANDARD_KEY: 'Estándar',
      WANT_CREATE_ENVIRONMENTS_KEY: '¿Desea crear este entorno?',
      LOGS_IMAGE_BACK_KEY: 'Volver a la lista de imágenes',
      TIME_DISCONNECT_KEY: 'Tiempo de desconexión de los usuarios en minutos',
      USER_MSG_IMAGE_KEY: 'Mensaje al usuario',
      EMAIL_NOTIFICATION_IMAGE_KEY: 'E-mail de aviso de notificación',
      YOUR_NAME_KEY: 'Su nombre',
      PUBLICATIONS_NEW_VERSION_KEY: 'Publicar nueva versión',
      PUBLICATIONS_KEY: 'Publicar',
      IMAGE_NOT_FOUND: 'No se ha encontrado ninguna imagen',
      NEW_PUBLICATION: '¡Nueva publicación registrada con éxito!',
      DO_NOT_EXIST_SERVER_PREPARATION_KEY: 'No hay servidores de preparación',
      START_KEY_SUPPORT_INSTANCE: 'Iniciar instancia',
      KEEP_USERS_CONNECTED_KEY: 'Mantener a los Usuarios conectados.',
      REQUEST_USER_FEATURE_KEY: 'Solicitar reconexión de usuarios',
      SCHEDULE_PUBLISH_KEY: 'Publicación programada',
      PUBLICATION_SERVER_IMAGE_KEY:
        'Seleccione un servidor para publicar una nueva imagen.',
      CONFIRM_PUBLICATION_NEW_VERSION_KEY:
        'Haga clic en confirmar para publicar una nueva versión',
      KEEP_USER_LOG_MSG_KEY:
        'Este procedimiento publicará una nueva versión de la capa Cliente (acceso de usuario) en el AutoScaling de la plataforma.',
      REQUEST_USER_FEATURE_MSG: {
        TITLE_REQUEST_KEY:
          'Este procedimiento publicará una nueva versión de la capa de aplicación (acceso de usuario) en el AutoScaling de la plataforma y cuando el acceso en esta nueva versión esté disponible para los usuarios, la plataforma Autosky solicitará a todos los usuarios conectados que cierren sus sesiones remotas y accedan nuevamente en la nueva versión publicada.',
        SUBTITLE_REQUEST_KEY:
          'Recomendamos que este procedimiento se realice únicamente en casos de actualizaciones críticas del sistema, en las que todos los usuarios deben acceder a la nueva versión publicada. Puede realizar este procedimiento solo unas pocas veces al mes dentro de los límites de su entorno.',
      },
      START_SERVER_KEY: 'Iniciar servidor',
      STOP_SERVER_KEY: 'Parar el servidor',
      CREATE_ENVIRONMENT_KEY: 'Crear entorno',
      CREATE_ENVIRONMENT_SUBTITLE_KEY: {
        COMPANY_NAME_SUBTITLE_KEY: 'Creación para',
      },
      DETACH_SERVER_KEY: '¿Desea desvincular el servidor?',
      DETACH_SERVER_MSG_KEY:
        'El servidor {{environment}} será desvinculado, ¿estás seguro?',
      START_SERVER_MSG_KEY:
        'La instancia {{environment}} se iniciará, esto puede tardar unos minutos',
      STOP_SERVER_MSG_KEY:
        'La instancia {{environment}} parará, esto puede tardar unos minutos',
      RESTART_SERVER_MSG_KEY:
        'El servidor {{environment}} se reiniciará, esto puede tardar unos minutos',
      LIST_ENVIRONMENTS_TITLE_KEY: 'Lista de entornos',
      LIST_ENVIRONMENTS_SUBTITLE_KEY: 'Lista de entornos disponibles',
      NO_ENVIRONMENT_KEY: 'No se ha encontrado ningún entorno.',

      LIST_INSTANCES_TITLE_KEY: 'Lista de instancias',
      LIST_INSTANCES_SUBTITLE_KEY:
        'Accede a la información y realizar operaciones.',
      LIST_SESSIONS_TITLE_KEY: 'Lista de sesiones',
      LIST_SESSIONS_SUBTITLE_KEY:
        'Accede a la información y realizar operaciones.',
      NO_INSTANCE_KEY: 'No se ha encontrado ninguna instancia.',
      WISH_UNLINK_INSTANCE_KEY: '¿Desea desvincular la instancia?',

      WANT_BLOCK_INSTANCE_KEY: '¿Desea bloquear la instancia?',
      WANT_UNBLOCK_INSTANCE_KEY: '¿Desea desbloquear la instancia?',

      LIST_SERVERS_TITLE_KEY: 'Servidores',
      LIST_SERVERS_SUBTITLE_KEY:
        'Seleccione un servidor para ver sus detalles:',
      UNLINK_WARNING_KEY: 'La instancia {{instance}} se desvinculará.',
      BLOCK_INSTANCE_WARNING_KEY: 'La instancia {{instance}} se bloqueará',
      UNBLOCK_INSTANCE_WARNING_KEY: 'La instancia {{instance}} se desbloqueará',
      LIST_MODELS_TITLE_KEY: 'Modelos',
      DUPLICATE_NAME_KEY: 'Nombre del modelo',
      LIST_MODELS_SUBTITLE_KEY:
        'Configure los modelos que se utilizarán en el entorno',
      NO_MODEL_KEY: 'No se han encontrado modelos',

      LIST_LOGS_TITLE_KEY: 'Registros',
      LIST_LOGS_SUBTITLE_KEY:
        'Vea las informaciónes sobre el entorno utilizando los siguientes filtros',
      NO_LOG_KEY: 'Ningún registro encontrado.',
      NO_LOG_INSTANCE_KEY: 'No se han encontrado registros para la instancia.',

      GENERAL_VISION_TITLE_KEY: 'Visión general',
      GENERAL_VISION_SUBTITLE_KEY: 'Vista rápida de la información del entorno',

      DASHBOARD_TITLE_KEY: 'Dashboard',

      MAINTENANCE_TITLE_KEY: 'Ajustes de mantenimiento',
      MAINTENANCE_SUBTITLE_KEY:
        'Configurar los ajustes de mantenimiento del entorno',

      WANT_REMOVE_SHUTDOWN_TITLE_KEY: '¿Desea eliminar parada programada?',
      WANT_REMOVE_SHUTDOWN_MSG_KEY:
        'La instancia está programada para apagarse en',
      WANT_SCHEDULE_NEW_STOP_TIME_MSG_KEY:
        'La instancia se programará para apagarse a las {{time}}',
      CONFIGURATION_TITLE_KEY: 'Ajustes',
      CONFIGURATION_SUBTITLE_KEY: '> Edición de ajustes',

      BEHAVIOR_TITLE_KEY: 'Modo de comportamiento del entorno',
      BEHAVIOR_SUBTITLE_KEY: 'Establece el modo de comportamiento del entorno',

      SECURITY_DEFAULTS_SUCCESS_KEY:
        '¡Los valores predeterminados de seguridad cambiaron con éxito!',

      ZERO_TRUST_NEW_FRONTEND_KEY:
        'Zero Trust no puede activarse hasta que la cuenta utilice el nuevo frontend',
      INVALID_IP_KEY: 'Dirección o red no válida en Allow List',

      NEW_GOVERNANCE_SUCCESS_KEY: '¡Gobernanza registrada con éxito!',

      GOVERNANCE_DEFAULTS_SUCCESS_KEY: '¡La gobernanza cambió con éxito!',

      REMOVE_DESCRIPTION_KEY: 'La información del entorno se perderá.',

      MODAL_CONNECT_LIKE_TITLE_KEY:
        'Por motivos de seguridad, introduzca su contraseña de acceso al Portal de administración Autosky:',
      MODAL_CONNECT_LIKE_RDP_KEY:
        'Se utilizará el complemento de conexión de Autosky, si no está instalado, haga clic en el botón de abajo para instalarlo.',
      OPEN_DETAILS_KEY: 'Abrir',
      CHECK_BOOT_VOLUME_BACKUP: 'Verificando boot volume backup',
      CREATE_BOOT_VOLUME_BACKUP: 'Creando boot volume backup',

      SYNC_WITH_PROVIDER: 'Forzar actualización con proveedor',
      PREPARATION_SERVER_KEY: 'Servidor de preparácion',
      NO_PREPARATION_SERVER_KEY:
        'No se ha encontrado ningún servidor de preparación.',
      NO_SUPPORT_SERVER_KEY: 'No se ha encontrado ningún servidor de soporte.',
      SERVER_STATUS_KEY: 'Status servidor',
      IMAGE_STATUS_KEY: 'Status imagen',
      APPLICATION_KEY: 'Aplicación',

      STATUS: {
        PENDING_KEY: 'Pendiente',
        RUNNING_KEY: 'Operativo',
        STOPPING_KEY: 'Detener',
        GENERATING_KEY: 'Generando',
        PUBLISHING_KEY: 'Publicando',
        REPLACING_KEY: 'Sustituyendo',
        BLOCKING_KEY: 'Bloqueando',
        DISCONNECTING_KEY: 'Desconectando',
        ERROR_KEY: 'Error',
        STOPPED_KEY: 'Detenido',
        FINISHED_KEY: 'Terminado',
        INITIALIZING_KEY: 'Arrancando',
        NOT_FOUND: 'No encontrado',
        COMPLETED_KEY: 'Completado',
        EXECUTING_KEY: 'En ejecución',
        CANCELLED_KEY: 'Cancelado',
        RETRYING_KEY: 'Intentando de nuevo',
        EXPIRED_KEY: 'Expirado',
      },
    },

    STOPPED_KEY: 'Detenido',
    ENVIRONMENT_STATUS_NOTIFICATION_KEY: 'El entorno no tiene estado definido',
    ENVIRONMENT_STATUS_NOTIFICATION_ACTION_KEY: 'Establecer estado',
    ENVIRONMENT_STATUS: {
      DEMONSTRATION_KEY: 'Demostración',
      DEPLOYMENT_KEY: 'Implementación',
      DEVELOPMENT_KEY: 'Desarrollo',
      HOMOLOGATION_KEY: 'Homologación',
      MIGRATION_KEY: 'Migración',
      PENDING_KEY: 'Pendiente',
      PRODUCTION_KEY: 'Producción',

      DEMONSTRATION_DESCRIPTION_KEY: 'Entorno en fase de demostración',
      DEPLOYMENT_DESCRIPTION_KEY: 'Entorno en fase de implementación',
      DEVELOPMENT_DESCRIPTION_KEY: 'Entorno utilizado para desarrollo',
      HOMOLOGATION_DESCRIPTION_KEY: 'Entorno en fase de homologación',
      MIGRATION_DESCRIPTION_KEY: 'Entorno en fase de migración',
      PENDING_DESCRIPTION_KEY: 'Entorno con estado no definido',
      PRODUCTION_DESCRIPTION_KEY: 'Entorno productivo',
    },

    // Applications
    APPLICATIONS_PAGE: {
      CONNECTED_KEY_SIMULATE_KEY:
        'Si aparece la ventana emergente, haga clic en Abrir AutoSky Plugin',
      EXECUTE_KEY: 'ejecutar aquí',
      FIRST_ACCESS_KEY: 'Si este es su primer acceso al portal',
      EXECUTE_PLUGIN_KEY: 'descargar y ejecutar el complemento',
      DOWNLOAD_FILE_RDP_KEY:
        'Descarga el archivo de conexión, ejecútalo y vuelve a introducir tu contraseña de acceso',
      WAIT_EXECUTE_APP_KEY:
        'Si tu aplicación aún no ha sido abierta, espera unos minutos más',
      DOWNLOAD_FILE_CONNECTION_KEY: 'Descargar archivo de conexión',
      CONNECTION_FILE_KEY: 'Descargar el archivo RDP de conexión',
      RDP_HELP_KEY: '¿Necesita ayuda? Haga clic aquí para más información.',
      ACCESS_TRAINING_APP_KEY:
        '¡El acceso a su entorno de entrenamiento ya está listo!',
      CONNECTED_KEY_SIMULATE_CONTENT_HELP_KEY:
        'Si AutoSky Plugin está instalado y no muestra ninguna ventana emergente',
      TEST_REMOTE_APP_LOADING_KEY: 'Cargando su aplicación. Mantener...',
      TEST_REMOTE_APP_FINISH_KEY: '¡Conexión completada!',
      TEST_REMOTE_APP_MSG_KEY: 'Si su aplicación aún no ha sido abierta',
      TEST_REMOTE_APP_CLICK_HERE_KEY: 'haga clic aquí',
      TEST_REMOTE_APP_INSTALL_PLUGIN_TITLE_KEY:
        'Instalación del plugin de conexión Autosky',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEP1_KEY:
        '1. Haz clic en el botón de descarga del complemento.',
      TEST_REMOTE_APP_INSTALL_PLUGIN_KEY: 'Descargar complemento',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEP2_KEY:
        '2. Continúe con el proceso de instalación del complemento.',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEPS_TITLE_KEY:
        'Siga la instalación paso a paso a continuación:',
      TEST_REMOTE_APP_INSTALL_DOWNLOAD_NOT_INIT_KEY: 'Si falla la descarga',
      TEST_REMOTE_APP_INSTALL_MANUAL_KEY: 'para instalar manualmente',
      TEST_REMOTE_APP_KEEP_GOING_KEY: 'Proseguir >>',
      TEST_REMOTE_APP_CONFIRM_KEY:
        'para confirmar la instalación del complemento.',
      CLIENT_APPLICATIONS_CODE: 'Código',
      APPLICATION_NAME_KEY: 'Nombre de la aplicación',
      SEARCH_APPLICATION_KEY: 'Buscar aplicación',
      APPLICATION_ADDRESS_KEY: 'Dirección de la aplicación',
      YOUR_APPLICATIONS_KEY: 'Sus aplicaciones',
      STARTUP_PARAMETER_KEY: 'Parámetro de inicialización',
      OPEN_APPLICATIONS_TEST_KEY: 'Prueba de apertura de aplicaciones',
      CREDENTIALS_USER_KEY: 'Credenciales de simulación de conexión de usuario',
      SELECT_CLIENT_TO_SIMULATE_APP_KEY:
        'Seleccione el cliente que desea realizar la prueba de apertura de la aplicación:',
      SIMULATE_APP_EXPLANATION_KEY:
        'Esta función le permite probar la configuración del cliente antes de publicarla para los usuarios.',
      ADD_APPLICATIONS_KEY: 'Añadir aplicaciones',
      ADD_APPLICATION_KEY: 'Añadir aplicación',
      APPLICATION_ADDED_SUCCESS_KEY: '¡Aplicación añadida con éxito!',
      APPLICATION_EDITED_SUCCESS_KEY: '¡Aplicación editada con éxito!',
      REMOVED_APPLICATION_KEY: '¡Aplicación eliminada con éxito!',
      SELECT_APPLICATION_KEY: 'Seleccione las aplicaciones que desea incluir',
      DISABLE_SELECT_KEY: 'Desactivar seleccionadas',
      DISABLE_APLICATIONS_KEY: 'Desactivar aplicaciones',
      EDIT_APLICATIONS_KEY: 'Editar aplicaciones',
      APPLICATIONS_WILL_BE_DISABLE_KEY:
        'Las aplicaciones se desactivarán, esto puede tardar unos minutos',
      REMOVE_APPLICATIONS_KEY: '¿Desea eliminar aplicaciones?',
      IRREVERSIBLE_ACTION_APPLICATION_KEY:
        'Esta acción es irreversible, la información no se podrá recuperar',
      DISABLE_APPLICATIONS_KEY: '¿Desea desactivar las aplicaciones?',
      DISABLE_APPLICATIONS_MINUTES_KEY: 'La aplicación se desactivará',
      ENABLE_APPLICATIONS_KEY: '¿Desea activar las aplicaciones?',
      ENABLE_APPLICATIONS_MINUTES_KEY: 'La aplicación se activará',
      NO_APPLICATIONS_FOUND_KEY: 'No se ha encontrado ninguna aplicación.',
      DISPLAY_APPLICATION_NAME_KEY: 'Nombre de exhibición de la aplicación.',
      DISABLE_PLUGIN_KEY: '¿Desactivar el estado de conexión del plugin?',
      KEEP_ALIVE_PARAMETER_KEY: '¿Activar el parámetro KeepAlive?',
      OPEN_APPLICATION_KEY: 'Abrir aplicación',
      OPEN_APPLICATION_WITH_REMOTE_APP_KEY: 'Abrir aplicación con Remote App',
      USE_EXISTING_USER_KEY: 'Usar usuario existente',
      USE_TEMPORARY_USER_KEY: 'Usar usuario temporal',
      DISABLE_APPLICATION_KEY: '¿Desea desactivar esta aplicación?',
      ENABLE_APPLICATION_KEY: '¿Desea activar esta aplicación?',
      REMOVE_APPLICATION_KEY: '¿Desea eliminar esta aplicación?',
      EDIT_APPLICATION_KEY: 'Editar aplicación',
      WEB_CLIENT_APP_KEY: 'Aplicaciones web',
      DEFAULT_APP_KEY: 'Aplicaciones estándar',
    },

    // Users
    USER_NAME_KEY: 'Nombre de usuario',

    // Company
    COMPANY_NAME_KEY: 'Nombre de la compañía',
    OPERATOR_VIEW_COMPANY_NAME_KEY: 'Compañía',
    CORPORATE_NAME_KEY: 'Razón social de la compañía',
    ADD_COMPANY_KEY: 'Añadir compañía',
    EDIT_COMPANY_KEY: 'Editar compañía',
    REMOVE_COMPANY_KEY: 'Eliminar compañía',
    BLOCK_COMPANY_KEY: 'Bloquear compañía',
    UNBLOCK_COMPANY_KEY: 'Desbloquear compañía',
    NO_COMPANY_KEY: 'No se ha encontrado ninguna compañía.',
    COMPANY_UPDATED_SUCCESSFULLY_KEY: '¡Compañía actualizada con éxito!',
    COMPANY_BLOCKED_SUCCESSFULLY_KEY: '¡Compañía bloqueada con éxito!',
    COMPANY_UNBLOCKED_SUCCESSFULLY_KEY: '¡Compañía desbloqueada con éxito!',

    RESPONSIBLE_KEY: 'Responsable',
    RESPONSIBLE_NAME_KEY: 'Nombre del responsable',
    RESPONSIBLE_EMAIL_KEY: 'Correo electrónico de la persona responsable',
    RESPONSIBLE_PHONE_KEY: 'Teléfono de contacto del responsable.',

    COMPANIES_PAGE: {
      LIST_COMPANIES_TITLE_KEY: 'Lista de compañías',
      LIST_COMPANIES_SUBTITLE_KEY: 'Lista de compañías disponibles',
      ADD_COMPANY_TITLE_KEY: 'Añadir compañía',
      ADD_COMPANY_SUBTITLE_KEY:
        'Rellene los datos para iniciar la inclusión de la compañía',
      DETAILS_COMPANY_TITLE_KEY: 'Detalles de la compañía',
      DETAILS_COMPANY_SUBTITLE_KEY: 'Información general de la compañia',
      CONSULT_COMPANY_TITLE_KEY: 'Recursos de la compañía',
      CONSULT_COMPANY_SUBTITLE_KEY: 'Consulte los datos de la {{name}}',

      REMOVE_COMPANY_DESCRIPTION_KEY:
        'Se perderá la información de la compañía.',

      BLOCK_COMPANY_TITLE_KEY: '¿Desea bloquear la compañía?',
      BLOCK_COMPANY_DESCRIPTION_KEY: 'A compañía {{name}} será bloqueada.',
      UNBLOCK_COMPANY_TITLE_KEY: '¿Desea desbloquear  la compañía?',
      UNBLOCK_COMPANY_DESCRIPTION_KEY:
        'La compañía {{name}} será desbloqueada.',
      PORTAL_DELETED_TEXT_KEY:
        'La compañía ya no está activa en el portal. Contacte al administrador',
    },

    // panel
    PANEL_PAGE: {
      TOTAL_ENVIRONMENT_KEY: 'Entornos',
      TOTAL_ENVIRONMENT_INSTANCE_KEY: 'Ent. con instancias',
      PERCENT_ACTIVE_INSTANCE_KEY: 'Entornos activos',
      TOTAL_PARTNER_KEY: 'Cuentas',
      TOTAL_CLIENTS_KEY: 'Clientes',
      TOTAL_USERS_KEY: 'Usuarios',
      TOTAL_SESSIONS_KEY: 'Sesiones',
      PANEL_AUTO_KEY: 'Panel Autosky',
      ADD_OR_EDIT_KEY: 'Añadir o editar',
      LIST_CLIENTS_ACESS_KEY: 'Acceder a la lista de clientes',
      LIST_PARTNER_ACESS_KEY: 'Acceder a la lista de cuentas',
      LIST_ENVIRONMENTS_ACESS_KEY: 'Accede al listado de entornos',
      CLIENTS_AUTO_SKY_KEY: 'Clientes Autosky',
      ENVIRONMENTS_AUTO_SKY_KEY: 'Entornos Autosky',
      ADMINISTRATION_AUTO_SKY_KEY: 'Administración Autosky',
      PIN_VIEW_DEFAULT:
        'Marca una tarjeta como favorita para añadir a tu tablero',
      FAVORITES_CARDS_KEY: 'Tus cartas favoritas se muestran a continuación.',
      QUALITY_ENVIRONMENTS_KEY: 'Entornos',
      ACTIVE_ENVIRONMENTS_KEY: 'Entornos actualmente activos',
      ENVIRONMENTS_PARTNER_KEY: 'Entornos utilizados por las cuentas',
      ACTIVE_USERS_KEY: 'Usuarios activos',
      QUICK_MENU: 'Menú rápido',
      AMOUNT_PARTNER_KEY: 'Número de cuentas',
      COUNT_CLIENTS_KEY: 'Número de clientes',
      ACTIVE_CLIENTS_KEY: 'Número de clientes activos',
      AVERAGE_CLIENTS_KEY: 'Uso medio de los clientes',
      PUSH_PIN_BUTTON_KEY: 'Pin para la visualización estándar',
      AUTO_KEY_DOCUMENTATION: 'Acceder a la documentación Autosky',
      ACCESS_LIST_PARTNER_KEY: 'Acceder a la lista de cuentas',
      MY_PROFILE_AUTO_SKY_KRY: 'Acceder a mi perfil Autosky',
      OPEN_CALL_KEY: 'Abrir un llamado',
      SEND_SUGGESTION: 'Enviar sugerencia',
      SEND_SUGGESTION_DESCRIPTION_KEY:
        '¿Tienes alguna sugerencia para mejorar Autosky? Rellene el siguiente formulario y nos pondremos en contacto con usted en breve."',
    },

    // Operators
    ADD_OPERATOR_KEY: 'Añadir operador al grupo',
    EDIT_OPERATOR_KEY: 'Editar operador',
    REMOVE_OPERATOR_KEY: 'Eliminar operador',
    RESET_PASSWORD_MSG_KEY: 'Se enviará un e-mail a la dirección {{email}}',
    SUCCESS_RESET_PASSWORD:
      '¡Restablecimiento de contraseña solicitado con éxito!',
    BLOCK_FALSE_OPERATOR_KEY: 'Bloquear operador',
    BLOCK_TRUE_OPERATOR_KEY: 'Desbloquear operador',
    NO_OPERATOR_KEY: 'No se ha encontrado ningún operador.',
    OPERATOR_BLOCKED_SUCCESSFULLY_KEY: '¡Operador bloqueado con éxito!',
    OPERATOR_UNBLOCKED_SUCCESSFULLY_KEY: '¡Operador desbloqueado con éxito!',
    OPERATOR_ADDED_SUCCESSFULLY_KEY: '¡Operador registrado con éxito!',
    OPERATOR_UPDATED_SUCCESSFULLY_KEY: '¡Operador actualizado con éxito!',
    OPERATOR_REMOVED_SUCCESSFULLY_KEY: '¡Operador eliminado con éxito!',

    RESET_PASSWORD_OPERATOR_KEY: 'Restablecer contraseña de operador',
    SEND_BY_EMAIL_KEY: 'Enviar por e-mail',
    EMAIL_SENT_KEY: '¡Correo electrónico enviado al operador!',
    INSERT_MANUALLY_KEY: 'Insertar la contraseña manualmente',

    OPERATORS_PAGE: {
      ADD_OPERATOR_TOOLTIP_KEY:
        'La empresa elegida no se verá reflejada en el permiso, se utiliza únicamente con fines organizativos',
      RESET_MFA_OPERATOR_KEY:
        '¿Desea restablecer MFA para el operador {{firstName}} {{lastName}}?',
      LIST_OPERATORS_TITLE_KEY: 'Lista de operadores',
      LIST_OPERATORS_SUBTITLE_KEY: 'Lista de operadores disponibles',
      ADD_OPERATOR_TITLE_KEY: 'Añadir operador',
      ADD_OPERATOR_SUBTITLE_KEY:
        'Rellena los datos para empezar a añadir el operador',
      EDIT_OPERATOR_TITLE_KEY: 'Editar operador',
      EDIT_OPERATOR_SUBTITLE_KEY: 'Cambie los datos para editar el operador',

      REMOVE_OPERATOR_TITLE_KEY: 'Eliminar {{name}}',
      REMOVE_OPERATOR_DESCRIPTION_KEY:
        'La información del operador se perderá.',

      BLOCK_OPERATOR_TITLE_KEY: '¿Desea bloquear el operador?',
      BLOCK_OPERATOR_DESCRIPTION_KEY: 'El operador {{name}} será bloqueado.',
      UNBLOCK_OPERATOR_TITLE_KEY: '¿Desea desbloquear  el operador?',
      UNBLOCK_OPERATOR_DESCRIPTION_KEY:
        'El operador {{name}} será desbloqueado.',
      APIS_OPERATOR_NOT_FOUND: 'Sin datos de integración API',
      REQUIRES_IP_VALIDATION: 'Requiere validación de IP',
      EDIT_TOKEN_KEY: 'Editar token',
      ADD_TOKEN_KEY: 'Añadir token',
      API_INTEGRATION_IPS_KEY: 'Integración de API',
      FILTER_TO_IPS: 'Filtrar por IPs',

      REMOVE_TOKEN_TITLE_KEY: 'Eliminar token',
      REMOVE_TOKEN_DESCRIPTION_KEY:
        'El token {{name}} será eliminado. Esta acción es definitiva.',

      TOKEN_UPDATED_SUCCESSFULLY_KEY: '¡Token actualizado con éxito!',
      CREATED_AT_KEY: 'Creado en',
      CREATED_BY_KEY: 'Creado por',
      TIME_AT_KEY: 'en',

      MANAGE_PERMISSIONS_KEY: 'Gestionar los grupos de permisos',
    },

    // Clients
    CLIENT_NAME_KEY: 'Nombre del cliente',
    ADD_CLIENT_KEY: 'Añadir cliente',
    ADD_CLIENT_DESCRIPTION_KEY: 'Rellena los datos para añadir el cliente',
    REMOVE_CLIENT_KEY: 'Eliminar cliente',
    REMOVE_SESSIONS_KEY: 'Eliminar sesiones',
    REMOVE_SESSIONS_SELECTED_KEY: 'Eliminar sesiones seleccionadas',
    VIEW_LOGS_KEY: 'Ver registros',
    CLIENT_ID_KEY: 'Cliente ID',
    ADMIN_EMAIL_KEY: 'E-mail del administrador',
    CLIENT_EXTERNAL_CODE_KEY: 'Código externo del cliente',
    SORT_ADMIN_EMAIL_KEY: 'E-mail admin',
    LIMIT_LICENSES_KEY: 'Licencias límite',
    ACTIVE_SESSIONS_KEY: 'Sesiones activas',
    PERMANENT_KEY: 'Permanente',
    STATUS_REQUESTED_KEY: 'Solicitado',
    STATUS_FINISHED_KEY: 'Permanente',
    STATUS_STARTED_KEY: 'Clonando',
    REMOTE_PROFILE_KEY: 'Perfil remoto',
    ADDRESS_REMOTE_PROFILE_KEY: 'Dirección de perfil remoto',
    ACTIVE_REMOTE_PROFILE_KEY: 'Activar perfil remoto',
    DISABLE_REMOTE_PROFILE_KEY: 'Deshabilitar perfil remoto',
    ACTIVE_DISABLE_PROFILE_MSG_KEY:
      '¿Desea {{active}} perfil remoto para el usuario {{name}}?',
    VIRTUALIZER_KEY: 'Virtualizador',
    PROFILE_PATH_KEY: 'Ruta de perfil',
    MAIN_PORT_KEY: 'Puerta principal',
    WEB_PORT_KEY: 'Puerto web',
    RESTRICTIONS_KEY: 'Restricciones de acceso',
    BY_TIME_KEY: 'Por tiempo',
    BY_IP_KEY: 'Por dirección IP',
    RELEASED_IP_ADDRESSES_KEY: 'Direcciones IP liberadas',
    START_RESTRICTION_AT_KEY: 'Restricción de inicio a las',
    ERROR_PERIOD_KEY: 'Debes seleccionar al menos un día',
    END_RESTRICTION_AT_KEY: 'Fin de la restricción a las ',
    CONFIGURE_PASSWORD_KEY: 'Configurar contraseña',
    IMPORT_FILE_KEY: 'Importar archivo',
    DELETE_SUCCESS_MESSAGE_KEY: '¡Cliente eliminado con éxito!',
    LICENSES_PER_CLIENTS: 'Límite de licencias por cliente',
    INVALID_PAYLOAD_APPLICATION_MODE_KEY: 'El campo "Modo" no es válido.',
    NO_CLIENT_KEY: 'Ningún cliente encontrado',
    USE_ENVIRONMENT_VIRTUALIZER_KEY:
      'Utilizar la misma virtualización que el entorno',
    USE_PARTNER_NEW_FRONT_KEY:
      'Utilice la misma interfaz que la cuenta del cliente',
    USE_ENVIRONMENT_CONNECTION_TYPE_KEY:
      'Utilizar el mismo tipo de conexión que el entorno',
    ENVIRONMENT_CONNECTION_TYPE_DISABLED_EXPLANATION_KEY:
      'No es posible configurar el tipo de conexión del cliente mientras la opción “Permitir el tipo de conexión por cliente“ esté desactivada en el entorno',

    IMPORT_USER_ALERT_KEY:
      'Al seleccionar configurar contraseña, el sistema utilizará el campo de contraseña en la hoja de cálculo para configurar la contraseña del usuario.   Sin esta opción, el usuario solo estará registrado y el correo de registro será enviado a la dirección configurada.',

    ADD_USER_KEY: 'Añadir usuário',
    ADD_NEW_USER_KEY: 'Añadir nuevo usuario',
    USER_ADDED_SUCCESSFULLY_KEY: '¡Usuario registrado con éxito!',
    USER_DELETE_SUCCESS_MESSAGE_KEY: '¡Usuario eliminado con éxito!',
    USER_DELETE_PERMANENTLY_SUCCESS_MESSAGE_KEY:
      '¡Usuario eliminado permanentemente con éxito!',
    IMPORT_USERS_KEY: 'Importar usuarios',
    IMPORT_USERS_SUCCESS_KEY: '¡Usuarios importados con éxito!',

    ACTIVATE_SELECTED_KEY: 'Activar la selección',
    INACTIVATE_SELECTED_KEY: 'Deshabilitar seleccionado',
    WANT_ACTIVATE_USERS_KEY: '¿Desea activar a los usuarios seleccionados?',
    WANT_INACTIVATE_USERS_KEY:
      '¿Desea desactivar a los usuarios seleccionados?',
    ACTIVATE_SELECTED_DESCRIPTION_KEY:
      'Los usuarios seleccionados han recuperado el acceso a la información del cliente al que están asociados.',
    INACTIVATE_SELECTED_DESCRIPTION_KEY:
      'Los usuarios seleccionados no tendrán acceso a la información del cliente con el que están relacionados.',
    ACTIVE_USER_KEY: 'El usuario {{id}} será activado!',
    ACTIVATE_USERS_SUCCESS_KEY: '¡Usuarios activados con éxito!',

    REMOVE_SELECTED_KEY: 'Eliminar la selección',
    WANT_REMOVE_SELECTED_KEY: '¿Desea eliminar la selección?',
    REMOVE_SELECTED_DESCRIPTION_KEY:
      'Esta acción es irreversible y las informaciónes no podrán ser recuperadas.',
    REMOVE_SELECTED_SUCCESS_KEY: '¡Usuarios eliminados con éxito!',
    ACTIVE_USER_SELECTED_SUCCESS_KEY: '¡Usuarios activados con éxito!',
    INACTIVATE_USERS_SUCCESS_KEY: '¡Usuarios desactivados con éxito!',

    IMPORT_CUSTOM_USERS_KEY: 'Importar usuarios personalizados',
    IMPORT_USUER_CUSTOM_MSG_KEY: 'Usuarios con clientes personalizados',
    CHOOSE_CSV_FILE_KEY:
      'Elija un archivo CSV para importar usuarios. Haga seguro enviar el archivo con codificación UTF-8.',
    IMPORT_CLIENTS_KEY: 'Importar clientes',
    IMPORT_CLIENT_SUCCESS_KEY: 'Cliente importado con éxito',

    INVALID_CSV_FILE:
      'El archivo CSV no es válido, compruebe su archivo CSV y vuelva a intentarlo',

    SCHEDULED_USER_IMPORT_SUCCESSFULLY:
      'Archivo enviado para fila de importación. Un e-mail será enviado con confirmacion para el administrador',
    SCHEDULED_CLIENTS_IMPORT_SUCCESSFULLY:
      'Archivo enviado para importar, un e-mail será enviado con confirmación',

    EXPORT_CSV_KEY: 'Exportar CSV',
    WANT_EXPORT_CSV_KEY: '¿Desea exportar CSV?',
    EXPORT_CSV_DESCRIPTION_KEY:
      'Desea exportar las informaciones en un archivo CSV?',
    EXPORT_CSV_SUCCESS_KEY: '¡Datos exportados con éxito!',

    RESEND_PASSWORD_KEY: 'Reenviar contraseña',
    WANT_RESEND_PASSWORD_KEY: '¿Desea reenviar la contraseña?',
    RESEND_PASSWORD_DESCRIPTION_KEY:
      'La contraseña se reenviará al e-mail {{email}}',
    RESEND_PASSWORD_SUCCESS_KEY: '¡Contraseña reenviada con éxito!',

    RESEND_PASSWORD_WITH_COPY_KEY: 'Reenviar contraseña (c/ Copia)',
    WANT_RESEND_PASSWORD_WITH_COPY_KEY:
      '¿Desea reenviar la contraseña con copia para el administrador?',
    RESEND_PASSWORD_WANT_COPY_DESCRIPTION_KEY:
      'Un correo eletronico para redefinicion de la contrasena sera enviado para el e-mail {{email}}  con copia para el administrador cadastrado para el cliente',
    RESEND_PASSWORD_TO_FICTITIOUS_EMAIL_KEY:
      'Este usuario tiene un e-mail ficticio. La contraseña se enviará al e-mail del administrador que está cadastrado al cliente.',
    WANT_DISABLE_USER_KEY: '¿Desea desactivar el usuario?',
    DISABLE_USER_DESCRIPTION_KEY:
      'El usuario ya no tendrá acceso a informaciónes del Cliente',
    DISABLE_USER_SUCCESS_KEY: '¡Usuario desactivado con éxito!',

    EDIT_USER_KEY: 'Editar usuario',
    EDIT_USER_SUCCESS_KEY: '¡Usuario editado con éxito!',

    WANT_REMOVE_USER_KEY: '¿Desea eliminar el usuario {{name}}?',
    REMOVE_USER_DESCRIPTION_KEY:
      'Esta acción es irreversible y las informaciónes no pueden ser recuperadas',
    REMOVE_USER_SUCCESS_KEY: '¡Usuario eliminado con éxito!',

    WANT_REMOVE_SESSION_KEY: '¿Desea eliminar la sesión?',
    WANT_REMOVE_SESSION_MSG_KEY:
      '¿Desea eliminar la sesión del usuario {{name}}?',
    REMOVE_SESSION_DESCRIPTION_KEY: 'La sesión {{name}} será eliminada',
    REMOVE_SESSION_SUCCESS_KEY: '¡Sesión eliminada con éxito!',
    REMOVE_SESSION_ERROR_KEY:
      'Error al eliminar la sesión. ¡Inténtalo nuevamente más tarde!',

    CLIENTS_PAGE: {
      LOADING_LIST_CLIENTES: 'Cargando lista de clientes',
      REMOVE_MULTIPLE_SESSIONS_TITLE_KEY: 'Eliminar varias sesiones',
      REMOVE_MULTIPLE_SESSIONS_DESCRIPTION_KEY:
        'Las sesiones seleccionadas serán eliminadas.',
      SESSION_REMOVAL_TIMEOUT_KEY:
        'Tiempo de espera de eliminación de sesión excedido',
      EXPIRED_SESSION_HISTORY_KEY: 'Sesión expirada',
      CLOSED_SESSION_HISTORY_KEY: 'Sesión cerrada',
      REMOVE_SESSION_HISTORY_KEY: 'Instancia terminada',
      SESSION_HISTORY_KEY: 'Historial de sesiones',
      NO_SESSION_HISTORY_KEY: 'Sin registro de historial de sesión',
      ENABLED_MFA_ALL_USERS_TITLE_KEY:
        'Habilitar o MFA para todos los usuarios',
      DISABLED_MFA_ALL_USERS_TITLE_KEY:
        'Deshabilitar MFA para todos los usuarios',
      ENABLED_MFA_ALL_USERS_MSG_KEY:
        'MFA estará habilitado para todos los usuarios del cliente {{name}}',
      DISABLED_MFA_ALL_USERS_MSG_KEY:
        'MFA se desactivará para todos los usuarios del cliente {{name}}',
      MFA_USER_RESET_TITLE_KEY: '¿Desea restablecer MFA?',
      MFA_USER_RESET_MSG_KEY: '¡MFA se restablecerá al usuario {{name}}!',
      USER_NO_LINKED_INSTANCE_KEY: 'Usuario sin instancia vinculada',
      NEW_CLONE_CLIENT_KEY: 'Nombre del nuevo cliente',
      CLONE_CLIENT_KEY: 'Clonar cliente',
      LIST_CLIENTS_TITLE_KEY: 'Lista de clientes',
      NO_CLIENTS_KEY: 'No se ha encontrado ningún cliente.',
      WANT_REMOVE_CLIENT_KEY: '¿Desea eliminar el cliente?',
      REMOVE_CLIENT_WARNING_MSG_KEY:
        'El cliente {{name}} será eliminado y sus informaciónes no podrán ser recuperadas.',
      CREATED_CLIENT: '¡Cliente creado con éxito!',

      LIST_LOGS_TITLE_KEY: 'Registros',
      LIST_LOGS_SUBTITLE_KEY:
        'Vea la información sobre el entorno utilizando los siguientes filtros',
      NO_LOGS_KEY: 'No se ha encontrado ningún registro.',

      LIST_SESSIONS_TITLE_KEY: 'Sesiones',
      NO_SESSIONS_KEY: 'No se ha encontrado ninguna sesión.',

      RESTRICTIONS_TITLE_KEY: 'Restricciones de acceso',
      RESTRICTIONS_SUBTITLE_KEY: 'Restricciones de acceso',

      LIST_USERS_TITLE_KEY: 'Usuarios',
      LIST_USERS_SUBTITLE_KEY: 'Administrar todos los usuarios registrados',
      NO_USERS_KEY: 'No se ha encontrado ningún usuario.',

      EDIT_CLIENT_KEY: 'Editar cliente',
      UPDATED_SUCCESSFULLY_KEY: '¡Cliente actualizado con éxito!',

      REMOVE_CLIENT_KEY: 'Eliminar cliente',
      REMOVE_CLIENT_DESCRIPTION_KEY: 'El cliente {{name}} será eliminado.',

      // Form
      ALWAYS_COPY_ADMIN_KEY:
        'Copiar siempre al administrador en las comunicaciones por correo electrónico',
      SORT_ALWAYS_COPY_ADMIN_KEY: 'Copiar siempre al administrador',
      BLOCK_MULTIPLE_SESSIONS_KEY:
        '¿Bloquear varias sesiones del mismo usuario?',
      USE_IOS_DEVICES_KEY: '¿Usar dispositivos iOS?',

      FIELD_INVALID_IP_ADDRESS_KEY: 'El campo tiene direcciones IP inválidas',
      ALLOWED_IPS_UPDATED_KEY: '¡Direcciones IP actualizados con éxito!',

      ACCESS_CONTROL_UPDATED_KEY: '¡Control de acceso actualizado con éxito!',
    },
    LICENSE_LIMIT: 'Límite de licencia superado',

    // groups
    ADD_GROUP_KEY: 'Agregar grupo',
    EDIT_GROUP_KEY: 'Editar grupo',
    EDIT_INFO_KEY: 'Editar información',
    REMOVE_SELECTED_GROUPS_KEY: 'Eliminar grupos seleccionados',
    GROUP_KEY: 'Nombre del grupo',
    CREATED_BY_KEY: 'Creado por',
    CREATED_AT_KEY: 'Fecha de creación',
    UPDATED_AT_KEY: 'Fecha de actualización',
    UPDATED_BY_KEY: 'Modificado por',
    ACTIVATED_KEY: 'Activado',
    RESTRICTED_OPERATORS_KEY: 'Operadores restringidos',
    ITEMS_TO_ADD_KEY: 'Elementos que deben añadirse',
    NO_ADDED_COMPANY_KEY: 'Ninguna empresa añadidaa',
    NO_ADDED_PARTNER_KEY: 'No se han añadido cuentas',
    NO_ADDED_ENVIRONMENT_KEY: 'Sin entorno añadido',
    NO_ADDED_CLIENT_KEY: 'No se han añadido clientes',
    NO_ADDED_OPERATOR_KEY: 'No se ha añadido ningún operador',
    ACTIVATE_USER: 'Activar usuario',
    CLIENT_ACCESS_CONTROL: 'Control de acceso para clientes',
    CREATE_NEW_USER: 'Crear nuevo usuario',
    DELETE_USER: 'Borrar usuario',
    DELETE_USER_PERMANENTLY: 'Eliminar usuario de forma permanente',
    INACTIVATE_USER: 'Desactivar usuario',
    LIST_AVAILABLE_APPLICATIONS: 'Listar aplicaciones disponibles',
    LIST_SESSION_HISTORY: 'Ver historial de sesiones',
    RESET_USER_MFA: 'Restablecer MFA',
    CAN_IMPORT_USERS_IN_ALL_CLIENTS: 'Importar usuarios en todos los clientes',
    CLONE_CLIENT: 'Clonar cliente',
    DELETE_APPLICATION: 'Eliminar aplicación',
    EDIT_APPLICATION: 'Editar aplicación',
    EDIT_CLIENT_SCHEDULED_WARNINGS: 'Editar alertas programadas para clientes',
    INCLUDE_APPLICATION: 'Incluir aplicación',
    LIST_CLIENT: 'Listar clientes',
    LIST_CLIENT_SCHEDULED_WARNINGS: 'Listar alertas programadas para clientes',
    LIST_CLIENT_INSTANCE_SESSIONS: 'Listar sesiones',
    DELETE_CLIENT_INSTANCE_SESSIONS: 'Finalizar sesiones',
    LIST_USERS: 'Listar usuarios',
    RESET_USER_PASSWORD: 'Restablecer contraseña del usuario',
    CAN_SIMULATE_APPLICATIONS: 'Prueba de apertura de aplicación',
    CREATE_NEW_APPLICATION: 'Crear aplicación',
    DELETE_CLIENT: 'Eliminar cliente',
    EDIT_CLIENT: 'Editar cliente',
    EDIT_USER_DETAILS: 'Editar usuario',
    LIST_APPLICATIONS: 'Lista de aplicaciones',
    LIST_APPLICATIONS_ENVIRONMENT: 'Listar aplicaciones por entorno',
    CREATE_APPLICATIONS_ENVIRONMENT:
      'Agregar aplicaciones de clientes al ambiente - modo Autosky',
    CHANGE_APPLICATIONS_NAME_ENVIRONMENT:
      'Cambiar el nombre de las aplicaciones de clientes en el ambiente - modo Autosky',
    REMOVE_APPLICATIONS_ENVIRONMENT:
      'Eliminar aplicaciones de clientes del ambiente - modo Autosky',
    CHANGE_APPLICATIONS_STATE_ENVIRONMENT:
      'Activar/inactivar aplicaciones de clientes en el ambiente - modo Autosky',
    CHANGE_APPLICATIONS_ATTACHMENT_ENVIRONMENT:
      'Vincular/desvincular aplicaciones de clientes en el ambiente - modo Platform',
    LIST_INCLUDED_APPLICATIONS: 'Listar aplicaciones incluidas',
    REMOVE_INCLUDED_APPLICATION: 'Eliminar aplicaciones',
    ATTACH_PREPARATION_SERVER: 'Añadir servidor de preparácion',
    CAN_BLOCK_ENVIRONMENT_INSTANCES: 'Bloquear instancia scaling',
    DELETE_USER_THEME_CONFIG: 'Borrar datos frontales personalizados',
    CAN_LIST_ENV_SCHEDULED_WARNINGS_DETAILS:
      'Listar detalles de avisos de mantenimiento programado',
    CAN_REGISTER_ENVIRONMENT_INSTANCES: 'Registrar nueva instancia',
    CAN_UNBLOCK_ENVIRONMENT_INSTANCES: 'Desbloquear instancia scaling',
    CREATE_NEW_CLIENT: 'Crear cliente',
    DELETE_MODELS: 'Eliminar modelo',
    EDIT_BEHAVIOR: 'Editar la configuración de comportamiento',
    EDIT_MODELS: 'Editar modelos',
    LIST_ENVIRONMENT_DASHBOARD: 'Exhibir panel de control del entorno',
    LIST_ENVIRONMENT_INSTANCES: 'Listar instancias de entorno',
    LIST_PROVIDER_RESOURCES: 'Lista de recursos del proveedor',
    START_PREPARATION_SERVER: 'Iniciar servidor de preparácion',
    STOP_SUPPORT_SERVER: 'Apagar el servidor de soporte',
    ATTACH_SUPPORT_SERVER: 'Añadir servidor de soporte',
    CAN_CONNECT_INSTANCE: 'Conectar como',
    CAN_EDIT_ENV_SCHEDULED_WARNINGS: 'Administrar programación de advertencias',
    CAN_RESTART_ENVIRONMENT_INSTANCES: 'Reiniciar instancia',
    CAN_UNREGISTER_ENVIRONMENT_INSTANCES: 'Desvincular instancias',
    UNREGISTER_INSTANCES: 'Desvincular instancia',
    DELETE_ENVIRONMENT: 'Eliminar entorno',
    DETACH_PREPARATION_SERVER: 'Desvincular servidor de preparácion',
    EDIT_ENVIRONMENT: 'Editar entorno',
    EDIT_PASSWORD_REQS: 'Administrar políticas de contraseña',
    LIST_ENVIRONMENT_DETAILS: 'Listar detalles del entorno',
    LIST_MODELS: 'Listar modelos',
    LIST_SUPPORT_SERVERS: 'Listar servidores de soporte',
    EDIT_SCALING_ADVISOR: 'Editar Scaling Advisor',
    LIST_SCALING_ADVISORS: 'Listar Scaling Advisors',
    LIST_SCALING_ADVISOR_DETAILS: 'Listar detalles de Scaling Advisor',
    LIST_SCALING_ADVISOR: 'Listar Scaling Advisor',
    DELETE_SELF_OPERATOR: 'Borrar su operador propio',
    CREATE_SELF_API_TOKEN: 'Crear su propio token API',
    LIST_SELF_OPERATOR_TOKEN: 'Listar su token API propio',
    LIST_SELF_OPERATOR: 'Listar su operador propio',
    DELETE_SELF_API_TOKEN: 'Eliminar su token API propio',
    EDIT_SELF_OPERATOR_DETAILS: 'Editar detalles de su propio operador',
    LIST_SELF_OPERATOR_DETAILS: 'Listar detalles de su propio operador',
    RESET_SELF_OPERATOR_MFA: 'Restablecer su propio MFA',
    EDIT_SELF_API_TOKEN: 'Editar su token API propio',
    START_SUPPORT_SERVER: 'Activar servidor de soporte',
    CAN_ACTIVATE_ENVIRONMENT_INSTANCES: 'Iniciar instancia scaling',
    CAN_IMPORT_CLIENTS: 'Importación de clientes',
    CAN_TERMINATE_ENVIRONMENT_INSTANCES: 'Terminar instancia scaling',
    CREATE_MODELS: 'Crear modelo',
    DELETE_ENVIRONMENT_INSTANCE_SESSIONS: 'Finalizar sesión',
    DETACH_SUPPORT_SERVER: 'Desvincular servidor de soporte',
    EDIT_GOVERNANCE: 'Editar información de gobierno',
    LIST_ENVIRONMENT: 'Listar entornos',
    LIST_ENVIRONMENT_INSTANCE_SESSIONS: 'Listar sesiones de instancias',
    LIST_PREPARATION_SERVERS: 'Listar servidores de preparácion',
    PUBLISH_IMAGE: 'Publicar imagen',
    PUBLISH_IMAGE_V2: 'Publicar imagen (optimizada)',
    PUBLISH_IMAGE_PARTNER_SERVERS:
      'Publicar imagen en servidores de la cuenta (optimizado)',
    STOP_PREPARATION_SERVER: 'Apagar el servidor de preparácion',
    CREATE_NEW_PARTNER: 'Crear cuenta',
    LIST_ALL_COMPANIES: 'Listar todas las compañias',
    LIST_COMPANY_USERS: 'Ver usuarios de la compañía',
    DELETE_COMPANY: 'Eliminar compañía',
    LIST_COMPANY_DASHBOARD: 'Panel de la compañía',
    EDIT_COMPANY_DETAILS: 'Editar compañía',
    LIST_COMPANY_DETAILS: 'Ver detalles de la compañía',
    CAN_TEST_LDAP: 'Probar LDAP',
    CAN_CHANGE_EXTERNAL_AD_PASSWORD:
      'Cambiar la contraseña del usuario administrativo de AD',
    EDIT_PARTNER_DETAILS: 'Editar cuenta',
    LIST_PARTNER_DETAILS: 'Listar detalles de la cuenta',
    LIST_USER_THEME_CONFIG: 'Listar personalización del frontend para cuentas',
    CREATE_USER_THEME_CONFIG: 'Crear personalización del frontend para cuentas',
    EDIT_USER_THEME_CONFIG: 'Editar personalización del frontend para cuentas',
    DELETE_USER_THEME_IMAGE: 'Borrar personalización del frontend para cuentas',
    PUBLISH_USER_THEME_CONFIG:
      'Publicar personalización del frontend para cuentas',
    CREATE_NEW_ENVIRONMENT: 'Crear nuevo entorno',
    LIST_ALL_PARTNERS: 'Listar cuentas',
    LIST_ALL_USERS: 'Enumerar todos los usuarios',
    USERS_RECOVERY: 'Recuperación de usuarios',
    DELETE_PARTNER: 'Eliminar cuenta',
    LIST_PARTNER_DASHBOARD: 'Dashboard',
    LIST_ENVIRONMENT_INCIDENTS: 'Dashboard de control',
    CREATE_ALL_ROLES: 'Crear grupo de permisos',
    CREATE_NEW_OPERATOR: 'Crear operador',
    DELETE_OPERATOR: 'Borrar operador',
    EDIT_OPERATOR_DETAILS: 'Editar operador',
    LIST_ALL_ROLES: 'Listar grupo de permisos',
    CREATE_API_TOKEN: 'Crear token API',
    DELETE_ALL_ROLES: 'Borrar permiso',
    EDIT_ALL_ROLES: 'Editar grupo de permisos',
    CAN_CLONE_ROLE: 'Clonar grupo de permisos',
    LIST_ALL_OPERATOR_TOKEN: 'Listar token del operador',
    LIST_ALL_OPERATORS_AUDIT_LOGS: 'Listar auditoría de registros',
    EDIT_IFRAME_MAX_LENGTH:
      'Editar el tamaño máximo de la string de conexión con Autosky Plugin',
    LIST_IFRAME_MAX_LENGTH:
      'Ver el tamaño máximo de la string de conexión con Autosky Plugin',
    LIST_OPERATOR_DETAILS: 'Listar detalles del operador',
    CREATE_NEW_COMPANY: 'Crear compañía',
    DELETE_API_TOKEN: 'Eliminar token API',
    EDIT_API_TOKEN: 'Editar token API',
    LIST_ALL_OPERATORS: 'Listar operadores',
    RESET_OPERATOR_MFA: 'Restablecer MFA',
    DOWNLOAD_CSV_TOKEN_KEY: 'Descargar token CSV',
    CREATED_TOKEN_TITLE_KEY: 'Token de operador',
    LIST_ENVIRONMENT_COST: 'Listar el costo del entorno',
    CAN_VIEW_ENVIRONMENT_LICENSES: 'Mostrar la cantidad de licencias.',
    MIGRATE_ENVIRONMENT: 'Migrar entorno',
    INACTIVATE_USER_RESET_PASSWORD_AT_LOGIN:
      'Desactivar redefinición de contraseña en el inicio de sesión',
    ACTIVATE_USER_RESET_PASSWORD_AT_LOGIN:
      'Activar redefinición de contraseña en el inicio de sesión',
    DISABLE_USER_DEVICES: 'Desactivar dispositivos del usuario',
    LIST_USER_DEVICES: 'Listar dispositivos del usuario',
    ENABLE_DEVICE_VALIDATION_BYPASS:
      'Habilitar omisión de validación del dispositivo',
    DISABLE_DEVICE_VALIDATION_BYPASS:
      'Desactivar omisión de validación del dispositivo',

    EDIT_ENV_AUTO_REMOVE_USER_SESSION_MAINTENANCE:
      'Editar los detalles de eliminación de la sesión de usuario',
    LIST_ENV_REMOVE_SESSION_DETAILS:
      'Ver los detalles de la eliminación de la sesión de usuario',
    EDIT_OPERATOR_ROLE: 'Editar permiso de operador',

    ADMIN_KEY: 'Administrador',
    SUPERADMIN_KEY: 'SuperAdmin',
    EMAIL_ADMIN_KEY: 'E-mail del administrador',

    SEARCH_ENVIRONMENT_KEY: 'Buscar entorno',
    SEARCH_CLIENT_KEY: 'Buscar cliente',
    SEARCH_OPERATOR_KEY: 'Buscar operador',

    PERMISSIONS_KEY: 'Permisos',
    PERMISSION_ROLES_KEY: 'Grupos de permisos',
    DO_NOT_HAVE_PERMISSION_KEY: 'Acción restringida',
    DO_NOT_HAVE_PERMISSION_MSG_KEY:
      'No tienes permiso para realizar esta acción.',
    REMOVE_SELECTED_COMPANIES_KEY: 'Eliminar compañías seleccionadas',
    REMOVE_SELECTED_PARTNERS_KEY: 'Eliminar cuentas seleccionados',
    REMOVE_SELECTED_ENVIRONMENTS_KEY: 'Eliminar entornos seleccionados',
    REMOVE_SELECTED_CLIENTS_KEY: 'Eliminar clientes seleccionados',
    REMOVE_SELECTED_OPERATORS_KEY: 'Eliminar operadores seleccionados',
    INFO_AUTOMATICALLY_ADDED_KEY:
      '¡Atencion! La opción habilitada agrega automáticamente nuevos elementos al grupo',
    NEW_COMPANIES_KEY: 'nuevas compañías',
    NEW_PARTNERS_KEY: 'nuevas cuentas',
    NEW_ENVIRONMENTS_KEY: 'nuevos entornos',
    NEW_CLIENTS_KEY: 'nuevos clientes',

    SELECT_ALL_COMPANIES_KEY: 'Seleccionar todas las empresas para este grupo',
    SELECT_ALL_PARTNERS_KEY: 'Seleccionar todos los cuentas para este grupo',
    SELECT_ALL_ENVIRONMENTS_KEY:
      'Seleccionar todos los entornos para este grupo',
    SELECT_ALL_CLIENTS_KEY: 'Seleccionar todos los clientes para este grupo',

    MONITOR: {
      INCIDENTS_PANEL_TITLE: 'Dashboard general de control',
      INCIDENTS_PANEL_FOLLOW_UP: 'Seguimiento',
      INCIDENTS_PANEL_SUBTITLE:
        'Listado de entornos con posibles problemas para el análisis',
      PARTNER_NAME: 'Cuenta',
      ENVIRONMENT_NAME: 'Entorno',
      PROVIDER: 'Proveedor',
      SEC_PROCESSED: 'Segundos procesamiento',
      BLOCKED_ENVIRONMENTS_TITLE: 'Entornos bloqueados',
      NO_BLOCKED_ENVIRONMENTS: 'Ningún entorno bloquado',
      ROBO_TYPE: 'Tipo robo',
      STATUS: 'Status',
      INSTANCES: 'Instancias',
      TEMPERATURE: 'Temperatura',
      CONNECTED: 'Conectado',
      LICENSES_TOTAL: 'Total de licencias',
      VACANCIES: 'Vacantes',
      ENVIRONMENT_HEALTH_TITLE:
        'Comprobar si hay entornos con posible falta de máquina a analizar',
      NO_RESULTS_ENVIRONMENT_HEALTH: 'No hay entorno para analizar',
      FLAVOR: 'Flavor',
      ZONE: 'Zone',
      COUNT: 'Cantidad',
      INSTANCES_STATUS_TITLE:
        'Instancias con problemas de activación en la última hora para análisis',
      INSTANCES_WITH_SESSION_TIMEOUT_TITLE:
        'Instancias con múltiples sesiones expiradas',
      NO_RESULTS_INSTANCES: 'No hay resultados',
      CARD_ENVIRONMENT_HEALTH: 'Entornos para análisis',
      CARD_BLOCKED_ENVIRONMENTS: 'Entornos bloqueados',
      CARD_INSTANCES: 'Instancias para análisis',
      RELOAD: 'Recargar',

      ENVIRONMENTS_TOTAL: 'Total de entornos',
      INSTANCES_TOTAL: 'Total de instancias',
      SESSIONS_TOTAL: 'Total de sesiones',
      BLOCKED_QUEUES: 'Colas bloqueadas',
      ENVIRONMENTS_WITH_FAILED_ZERO_TRUST: 'Entornos fallidos de Zero Trust',
      BLOCKED_QUEUES_LIST_TITLE: 'Listado de colas bloqueadas',
      BLOCKED_QUEUES_DESCRIPTION: 'Colas bloqueadas:',
      ANY_QUEUE_BLOCKED: 'Todas las colas están operativas',

      ANALYZE_STATUS_KEY: 'Analizar',
      NORMAL_STATUS_KEY: 'Normal',
      TOTAL_FAILED_SESSIONS_KEY: 'Sesiones fallidas',
      TOTAL_FAILED_SESSIONS_PERCENTAGE_KEY: 'Porcentaje fallido',
    },

    GROUPS_PAGE: {
      REMOVE_WARNING_MSG_KEY:
        '{{name}} será eliminado y su información no podrá recuperarse.',
      ACTION_IS_IRREVERSIBLE_KEY:
        'Esta acción es irreversible, la información no se puede recuperar',

      LIST_GROUPS_TITLE_KEY: 'Grupos de permisos',
      LIST_GROUPS_SUBTITLE_KEY: 'Lista de grupos de permisos',
      LIST_GROUPS_CONTENT_TITLE_KEY: 'Tus grupos',
      LIST_GROUPS_CONTENT_SUBTITLE_KEY:
        'Añadir grupos para administrar sus permisos',
      WANT_REMOVE_GROUP_KEY: '¿Desea eliminar el grupo?',
      WANT_REMOVE_SELECTED_GROUPS_KEY:
        '¿Desea eliminar los grupos seleccionados?',
      NO_GROUPS_KEY: 'No se encontraron grupos.',
      ADDED_GROUP_KEY: '¡Grupo agregado exitosamente!',
      REMOVED_GROUP_KEY: '¡Grupo eliminado con éxito!',
      UPDATED_GROUP_KEY: '¡Grupo actualizado con éxito!',

      REMOVED_ITEMS_KEY: '¡Elementos eliminados con éxito!',

      LIST_COMPANIES_TITLE_KEY: 'Lista de compañías',
      LIST_COMPANIES_SUBTITLE_KEY: 'Gestiona tus compañías',
      ADD_COMPANIES_KEY: 'Añadir compañías',
      ADD_COMPANIES_SUBTITLE_KEY: 'Seleccione y haga clic en añadir',
      WANT_REMOVE_COMPANY_KEY: '¿Desea eliminar la compañía?',
      WANT_REMOVE_SELECTED_COMPANIES_KEY:
        '¿Desea eliminar las compañías seleccionadas?',
      LIST_COMPANY_PERMISSIONS_KEY: 'Administrar permisos de compañía',
      ADDED_COMPANIES_KEY: '¡Compañías añadidas con éxito!',
      REMOVED_COMPANIES_KEY: '¡Compañías eliminadas con éxito!',
      UPDATED_COMPANIES_KEY: '¡Compañías actualizadas con éxito!',

      LIST_PARTNERS_TITLE_KEY: 'Lista de cuentas',
      LIST_PARTNERS_SUBTITLE_KEY: 'Gestionar a sus cuentas',
      ADD_PARTNERS_KEY: 'Añadir cuentas',
      ADD_PARTNERS_SUBTITLE_KEY: 'Seleccione y haga clic en añadir',
      WANT_REMOVE_PARTNER_KEY: '¿Desea eliminar la cuenta?',
      WANT_REMOVE_SELECTED_PARTNERS_KEY:
        '¿Desea eliminar las cuentas seleccionadas?',
      LIST_PARTNER_PERMISSIONS_KEY: 'Administrar permisos de cuentas',
      ADDED_PARTNERS_KEY: '¡Cuentas agregadas con éxito!',
      REMOVED_PARTNERS_KEY: '¡Cuentas eliminadas con éxito!',
      UPDATED_PARTNERS_KEY: '¡Cuentas actualizadas con éxito!',

      LIST_ENVIRONMENTS_TITLE_KEY: 'Lista de entornos',
      LIST_ENVIRONMENTS_SUBTITLE_KEY: 'Gestiona tus entornos',
      ADD_ENVIRONMENTS_KEY: 'Añadir entornos',
      ADD_ENVIRONMENTS_SUBTITLE_KEY: 'Seleccione y haga clic en añadir',
      WANT_REMOVE_ENVIRONMENT_KEY: '¿Desea eliminar el entorno?',
      WANT_REMOVE_SELECTED_ENVIRONMENTS_KEY:
        '¿Desea eliminar los entornos seleccionados?',
      LIST_ENVIRONMENT_PERMISSIONS_KEY: 'Administrar permisos de entorno',
      ADDED_ENVIRONMENTS_KEY: '¡Entornos agregados con éxito!',
      REMOVED_ENVIRONMENTS_KEY: '¡Entornos eliminados con éxito!',
      UPDATED_ENVIRONMENTS_KEY: '¡Entornos actualizados con éxito!',

      LIST_CLIENTS_TITLE_KEY: 'Lista de clientes',
      LIST_CLIENTS_SUBTITLE_KEY: 'Gestionar sus clientes',
      ADD_CLIENTS_KEY: 'Añadir clientes',
      ADD_CLIENTS_SUBTITLE_KEY: 'Seleccione y haga clic en añadir',
      WANT_REMOVE_CLIENT_KEY: '¿Desea eliminar el cliente?',
      WANT_REMOVE_SELECTED_CLIENTS_KEY:
        '¿Desea eliminar los clientes seleccionados?',
      LIST_CLIENT_PERMISSIONS_KEY: 'Administrar permisos de clientes',
      ADDED_CLIENTS_KEY: '¡Clientes agregados con éxito!',
      REMOVED_CLIENTS_KEY: '¡Clientes eliminados con éxito!',
      UPDATED_CLIENTS_KEY: '¡Clientes actualizados con éxito!',

      LIST_OPERATORS_TITLE_KEY: 'Lista de operadores',
      LIST_OPERATORS_SUBTITLE_KEY: 'Gestionar sus operadores',
      ADD_OPERATORS_KEY: 'Añadir operadores',
      ADD_OPERATORS_SUBTITLE_KEY: 'Seleccione y haga clic en añadir',
      WANT_REMOVE_OPERATOR_KEY: '¿Desea eliminar el operador?',
      WANT_REMOVE_SELECTED_OPERATORS_KEY:
        '¿Desea eliminar los operadores seleccionados?',
      LIST_OPERATOR_PERMISSIONS_KEY: 'Administrar permisos de operador',
      ADDED_OPERATORS_KEY: '¡Operadores agregados con éxito!',
      REMOVED_OPERATORS_KEY: '¡Operadores eliminados con éxito!',
      UPDATED_OPERATORS_KEY: '¡Operadores actualizados con éxito!',
      SELECT_ALL_KEY: 'Seleccionar todos',
      FRONTEND_CUSTOMIZATION_KEY: 'Personalización de front end',
      PREPARATION_SERVERS_KEY: 'Servidores de preparación',
      SUPPORT_SERVERS_KEY: 'Servidores de asistencia',
      ALERTS_KEY: 'Alertas',
      MONITORS_KEY: 'Monitores',
      ASSOCIATE_KEY: 'Asociado',
      NOT_ASSOCIATE_KEY: 'No asociado',

      CLONE_GROUP_KEY: 'Clonar grupo',
      CLONE_GROUP_NAME_KEY: 'Nombre del nuevo grupo',
      CLONE_GROUP_TO_CLONE_KEY: 'Grupo a clonar',
      GROUP_CLONE_MESSAGE_KEY: 'El grupo fue clonado con éxito',
    },
    LIST_ALL_MONITORS: 'Listar todos los monitores',
    CAN_APPLY_SCALING_ADVISOR: 'Aplicar al Scaling Advisor',
    CAN_IGNORE_SCALING_ADVISOR: 'Ignorar al Scaling Advisor',
    CAN_REVERT_SCALING_ADVISOR: 'Invertir al Scaling Advisor',

    PENDING_ADVISORS_KEY: 'Optimizaciones pendientes',
    SUGGESTED_ADVISORS_KEY: 'Optimizaciones sugeridas',
    APPLIED_ADVISORS_KEY: 'Optimizaciones aplicadas',
    NEW_PENDING_ADVISORS_KEY: 'Nuevas optimizaciones pendientes',
    HISTORY_APPLIED_ADVISORS_KEY: 'Historial de optimizaciones aplicadas',
    HISTORY_NOT_APPLIED_ADVISORS_KEY:
      'Historial de optimizaciones No aplicadas',
    NO_ADVISOR_KEY: 'No se encontró optimización.',
    EMPTY_INSTANCES_SUNDAY_KEY: 'Domingo',
    EMPTY_INSTANCES_SATURDAY_KEY: 'Sábado',
    EMPTY_INSTANCES_WEEKDAY_NIGHT_KEY: 'Semanal (noche)',
    EMPTY_INSTANCES_WEEKDAY_KEY: 'Semanal',
    EMPTY_INSTANCES_ANY_DAY_KEY: 'Quincenalmente',
    PENDING_KEY: 'Pendiente',
    IGNORED_KEY: 'Ignorado',
    APPLIED_KEY: 'Aplicado',
    REVERTED_KEY: 'Invertido',
    NOT_APPLIED_KEY: 'No aplicado',
    DEPRECIATED_KEY: 'Depreciado',
    EXPIRED_KEY: 'Expirado',
    SUGGESTED_KEY: 'Sugerido',
    DEACTIVATED_KEY: 'Desactivado',
    ON_DEMAND_KEY: 'A pedido',
    SUPPORT_SERVERS_KEY: 'Servidores de soporte',
    ENVIRONMENT_STATUS_KEY: 'Status del entorno',
    ENVIRONMENTS_STATUS_KEY: 'Status del entornos',
    APPLIED_BY_KEY: 'Aplicado por',
    APPLIED_AT_KEY: 'Aplicado en',
    IGNORED_BY_KEY: 'Ignorado por',
    IGNORED_AT_KEY: 'Ignorado en',
    REVERTED_BY_KEY: 'Invertido por',
    REVERTED_AT_KEY: 'Invertido en',

    ADVISOR_PAGE: {
      LIST_ADVISORS_TITLE_KEY: 'Lista de optimizaciónes',
      LIST_ADVISORS_SUBTITLE_KEY: 'Gestiona tus optimizaciones',

      DASHBOARD_TITLE_KEY: 'Optimizaciones de entornos',
      DASHBOARD_SUBTITLE_KEY:
        'Gestiona la optimización de entornos en un único lugar',

      ENVIRONMENTS_WITH_PENDING_ADVISORS_KEY:
        'Entornos con optimizaciones pendientes',
      TOTAL_ADVISORS_SUGGESTED_KEY: 'Total de optimizaciones',
      TOTAL_ADVISORS_APPLIED_KEY: 'Total de optimizaciones aplicadas (30 días)',
      ESTIMATED_SAVINGS_FROM_SUGGESTED_KEY:
        'Ahorros estimados a partir de las optimizaciones sugeridas',

      WANT_APPLY_ADVISOR_KEY: '¿Desea aplicar la optimización?',
      CONFIRM_APPLY_ADVISOR_KEY:
        'Confirme a continuación para aplicar la optimización seleccionada.',
      WANT_IGNORE_ADVISOR_KEY: '¿Desea ignorar la optimización?',
      CONFIRM_IGNORE_ADVISOR_KEY: 'Informe el motivo abajo:',
      WANT_REVERT_ADVISOR_KEY: '¿Desea invertir la optimización?',
      CONFIRM_REVERT_ADVISOR_KEY:
        'Confirme a continuación para invertir la optimización seleccionada.',
      ADVISOR_TYPE_DETAILS_KEY: 'Tipo de optimización',
      OPERATION_MODE_DETAILS_KEY: 'Modo de operación do entorno',
      PERIOD_KEY: 'Periodos',
      MANUAL_KEY: 'Manual',
      MICRO_KEY: 'Micro',
      SPOT_PERIOD_KEY: 'Periodos (Spot)',
      OPTIMIZATION_DETAILS_KEY: 'Detalles de optimización',
      ESTIMATED_COST_SAVINGS_KEY: 'Ahorro estimado',
      ADVISOR_TYPE_EXPLANATION_BUTTON_KEY:
        'Comprende los tipos de optimizaciones',
      ADVISOR_TYPE_EXPLANATION_KEY:
        'Verifica si hay instancias en ejecución sin sesiones de usuarios durante los siguientes períodos para cada tipo de optimización:',
      ADVISOR_WEEKDAY_KEY: 'Optimización semanal:',
      ADVISOR_WEEKDAY_EXPLANATION_KEY:
        'Durante la noche en los últimos 15 días hábiles (lunes a viernes), de 22:00 a 06:00.',
      ADVISOR_SATURDAY_KEY: 'Optimización de sábado:',
      ADVISOR_SATURDAY_EXPLANATION_KEY:
        'Durante los últimos 4 sábados, de 06:00 a 06:00 del domingo.',
      ADVISOR_SUNDAY_KEY: 'Optimización de domingo:',
      ADVISOR_SUNDAY_EXPLANATION_KEY:
        'Durante los últimos 4 domingos, de 06:00 a 06:00 del lunes.',
      ADVISOR_ANYDAY_KEY: 'Optimización quincenalmente:',
      ADVISOR_ANYDAY_EXPLANATION_KEY:
        'Durante los últimos 15 días, de 00:00 a 23:59.',
      ADVISOR_COST_EXPLANATION_KEY:
        'Costo asociado con no implementar las optimizaciones pendientes',
      ADVISOR_MONTHLY_SAVINGS_KEY: 'Ahorro mensual estimado',
      ENVIRONMENTS_COST_TITLE_KEY: 'Costo total de los entornos',
      MONTHLY_ENVIRONMENTS_COST_TITLE_KEY: 'Costo acumulado de los entornos',
    },

    // API Advisor
    ADVISOR_APPLIED: 'Optimización aplicada con éxito!',
    ADVISOR_IGNORED: 'Optimización ignorada con éxito!',
    ADVISOR_REVERTED: 'Optimización invertida con éxito!',
    SCALING_ADVISOR_APPLY_INCONSISTENT_PERIODS:
      'Este entorno tiene períodos incoherentes en la base de datos.',
    SCALING_ADVISOR_APPLY_INVALID_STATUS:
      'Status inválido para el advisor, no es posible aplicar la optimizacíon. El status debe ser "pendiente"',
    SCALING_ADVISOR_APPLY_UNKNOWN_ENVIRONMENT:
      'Entorno desconocido para aplicaciones de optimización',
    SCALING_ADVISOR_APPLY_INVALID_ENVIRONMENT_OPERATION_MODE:
      'Modo de operación del entorno no válido para la aplicación de optimización',
    SCALING_ADVISOR_APPLY_UNKNOWN_BEHAVIOR_CALENDAR:
      'Calendario de comportamiento desconocido para aplicación de optimización',

    // API partner
    CANNOT_DELETE_PARTNER_WITH_ENVIRONMENT_ASSOCIATED:
      'No es posible eliminar una cuenta asociada a un entorno',

    // API companies
    CANNOT_DELETE_COMPANY_WITH_PARTNER_ASSOCIATED:
      'No es posible eliminar la compañía asociada a una cuenta',
    ADD_COMPANY_SUCCESS_KEY: '¡Compañía registrada con éxito!',
    REMOVE_COMPANY_SUCCESS_KEY: '¡Compañía eliminada con éxito!',

    // API clients
    OPERATOR_PASSWORD_TOO_WEAK: 'La contraseña elegida es débil.',
    OPERATOR_ALREADY_EXISTS: 'Operador ya existe',
    REMOVE_MULTIPLE_SESSIONS_KEY:
      '¡Las sesiones seleccionadas fueron eliminadas!',
    ENABLE_OR_DISABLE_SUCCESS_KEY: '¡Perfil remoto {{activate}} con éxito!',
    MFA_OPERATOR_ENABLE_KEY: '¡El MFA se ha activado con éxito!',
    MFA_OPERATOR_DISABLE_KEY: '¡El MFA ha sido desactivado con éxito!',
    MFA_OPERATOR_RESET: '¡MFA se ha restablecido con éxito!',
    CANNOT_EDIT_USER_FIELDS: '¡Usuario ya registrado!',
    FICTITIOUS_USER_ADMINS_EMAILED:
      '¡Se envió un e-mail de restablecimiento de contraseña a los administradores del cliente porque el usuario es ficticio!',
    INVALID_USER: 'Usuario invalido',
    ENVIRONMENT_WITHOUT_VALID_VIRTUALIZER:
      'Entorno sin un virtualizador válido',
    MISSING_FILTER_PARAMETER: 'Parámetro de filtro faltante',
    TEST_CONNECT_SUCCES_KEY: '¡Prueba de conexión exitosa!',
    ERROR_ON_VALIDATE_USER:
      'Error al validar usuario. Consulte el administrador de la cuenta',
    ENVIRONMENT_WITHOUT_VALID_INSTANCE:
      'El entorno no tiene un servidor de preparación registrado o el servidor de preparación no está operativo. No es posible simular la aplicación. Compruebe los servidores de ensayo del entorno',
    USER_NOT_FOUND:
      'Usuario no encontrado, verifique si el e-mail proporcionado es correcto',
    USER_DISABLED: 'Este usuario está desactivado',
    LICENSES_LIMIT_KEY: 'El límite de licencias del cliente há excedido',
    CLIENT_CLONE_MESSAGE_KEY: 'El cliente solicitado se ha clonado con éxito',
    PARTNER_CLONE_MESSAGE_KEY: 'La cuenta se ha clonada con éxito',
    CHANGE_AD_PASSWORD_MESSAGE_KEY:
      'La contraseña del usuario AD se ha cambiado correctamente',
    CLIENT_REMOVED_KEY: '¡El cliente ha sido eliminado con éxito!',
    WRONG_PARAMETERS:
      'Error en la solicitud. Póngase en contacto con el administrador.',
    CLIENT_WITH_USER_CANNOT_BE_DELETED:
      'No es posible eliminar un cliente con usuarios asociados. Elimine usuarios de este cliente antes de solicitar la eliminación del cliente.',
    AD_GROUP_NOT_CREATED_KEY:
      'No se pudo crear un grupo de Active Directory (AD) para este cliente.',
    INVALID_PAYLOAD_APPLICATION_MODE:
      'Esta aplicación de cliente está configurada en modo "simple" y solo puede aceptar argumentos de nombre y estado. Si necesita usar una configuración avanzada, primero cambie el modo de aplicación del entorno del cliente a "avanzado".',
    CLIENT_REALM_ID_ALREADY_EXISTS:
      'El ID de dominio ya está asociado a un cliente',

    // API Authenticate
    PASSWORD_CHANGE_KEY:
      '¡Contraseña alterada con éxito! Redirigiéndole a la página de inicio de sesión…',
    INVALID_TOKEN_KEY: 'Token no válido o caducado',
    EMAIL_RECOVER_KEY:
      'Si su e-mail está registrado en nuestra base de datos, recibirá un correo electrónico para recuperar su contraseña.',

    // API environment
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_SUCCESS_KEY:
      '¡Las instancias se bloquearon / desbloquearon con éxito!',
    INSTANCE_IS_NOT_RUNNING: '¡Una instancia no está en ejecución!',
    TERMINATE_MULTIPLE_INSTANCES_KEY:
      '¡Las instancias seleccionadas fueron terminadas con éxito!',
    BLOCK_MULTIPLE_INSTANCES_KEY:
      '¡Las instancias seleccionadas se bloquearon con éxito!',
    UNBLOCK_MULTIPLE_INSTANCES_KEY:
      '¡Las instancias seleccionadas se desbloquearon con éxito!',
    SUCCESS_REMOVE_MULTIPLE_MODELS_KEY:
      '¡Los modelos seleccionados se fueron eliminados con éxito!',
    ENVIRONMENT_WITHOUT_GOVERNANCE: 'Environment without governance',
    TURNED_SERVER_MSG_KEY: '¡Servidor transformado con éxito!',
    ENABLE_MFA_TO_ALL_USERS_SUCCESS_KEY:
      '¡El MFA de todos los usuarios fue activado correctamente!',
    DISABLE_MFA_TO_ALL_USERS_SUCCESS_KEY:
      '¡MFA para todos los usuarios se ha desactivado correctamente!',
    FORBIDDEN_PROVIDER:
      'El proveedor no tiene permiso para realizar esta acción',
    SET_NEW_STOP_TIME_PREPARATION_SERVER:
      '¡Hora de parada configurada con éxito!',
    CANCELED_SCHEDULED_STOP_PREPARATION_SERVER:
      'Cancelar parada programada del servidor de preparácion',
    PREPARATION_SERVER_WITHOUT_STOP_TIME:
      'Servidor de preparación sin tiempo de parada definido',
    CANNOT_DELETE_ENVIRONMENT_WITH_CLIENTS_ASSOCIATED:
      'No es posible eliminar un entorno con clientes asociados a el. Por favor elimina los clientes del entorno antes de solicitar la exclucion del entorno',
    ENVIRONMENT_ALREADY_WITH_PREPARATION_SERVER:
      'El entorno ya tiene un servidor de preparación',
    CREATED_ENVIRONMENT: '¡Entorno creado con éxito!',
    PROVIDER_RESOURCE_NOT_AVAILABLE_IN_PROVIDER:
      'Las funciones del proveedor no están disponibles en el proveedor de este entorno',
    OPERATION_UNSUPPORTED: 'Operación no admitida',
    INSTANCE_OPERATION_ERROR: 'Error de operación de la instancia',
    INIT_INSTANCE_MSG_SINGULAR_KEY: 'Iniciando {{numInstances}} instancia...',
    INIT_INSTANCE_MSG_PLURAL_KEY: 'Iniciando {{numInstances}} instancias...',
    CREATED_PREPARATION_SERVER: '¡Servidor de preparación creado con éxito!',
    CREATED_SUPPORT_SERVER: '¡Servidor de soporte creado con éxito!',
    ATTACHED_SERVER: '¡Servidor vinculado con éxito!',
    DETACHED_SERVER: '¡Servidor desvinculado con éxito!',
    ENVIRONMENTS_NOT_FOUND: 'Entorno no encontrado para este operador',
    INVALID_TIME_RANGE:
      'La fecha de finalización debe ser posterior a la fecha de inicio',
    INVALID_PERIOD_ERROR:
      'Periodo inválido, introduzca un periodo inferior a 6 horas.',
    ELASTICSEARCH_CONNECTION_ERROR: 'Error al conectarse a Elasticsearch.',

    INSTANCE_ACTIVATE_NOT_ALLOWED:
      'Error al activar la instancia. ¡Inténtelo más tarde!',

    INSTANCE_ACTIVATE_REQUESTED:
      '¡Solicitación para activacion de instancia enviada con éxito!',

    INSTANCE_ACTIVATE_ENVIRONMENT_BLOCKED:
      'El entorno está ocupado por otra tarea',
    UNREGISTER_INSTANCE_REQUESTED: '¡Instancia desvinculada con éxito!',
    UNLINK_ERROR_KEY:
      'Error al desvincular una instancia. ¡Inténtalo nuevamente más tarde!',
    SENT_WRONG_PARAMETERS:
      'Información incorrecta. ¡Revise la información y inténtalo nuevamente más tarde!',

    INSTANCE_NOT_FOUND: 'Instancia no encontrada',
    ENVIRONMENT_NOT_FOUND: 'Entorno no encontrado',

    INSTANCE_REBOOT_REQUESTED:
      '¡Solicitacion de reinicio de la instancia enviada con éxito!',
    INSTANCE_REBOOT_NOT_ALLOWED:
      'El entorno no permite reiniciar la instancia de esta manera.',
    DISPLAY_ENV_WARNING:
      '¡Mostrar aviso de mantenimiento {{active}} con éxito!',
    MANUAL_ENV_WARNING:
      '¡Exhibición del aviso de mantenimiento manual fue {{active}} con éxito!',
    SCHEDULE_ENV_WARNING:
      '¡Exhibición del aviso de mantenimiento programado {{active}} con éxito!',
    CANCELED_SCHEDULED_STOP: '¡Parada programada cancelada con éxito!',
    SET_NEW_STOP_TIME: '¡Nueva hora de parada programada creada con éxito!',

    SECURITY_DEFAULTS_ERROR_KEY:
      'Error al registrar los estándares de seguridad. ¡Revise las informaciones y inténtalo nuevamente más tarde!',
    NEW_GOVERNANCE_ERROR_KEY:
      'Error al registrar la gobernanza. ¡Inténtalo nuevamente más tarde!',
    GOVERNANCE_DEFAULTS_ERROR_KEY:
      'Error al editar la gobernanza. ¡Inténtalo nuevamente más tarde!',

    SERVER_START_REQUESTED: '¡Inicio del servidor solicitado con éxito!',
    SERVER_STOP_REQUESTED: '¡Detención del servidor solicitada con éxito!',
    SERVER_RESTART_REQUESTED: '¡Reinicio del servidor solicitado con éxito!',
    EXTENDED_PREPARATION_SERVER: '¡Tiempo de parada ampliado con éxito!',
    SERVER_NOT_FOUND:
      'Servidor no encontrado. Sincronize los datos con el proveedor para garantizar la integridad y actualidad de la información.',
    SERVER_NOT_FOUND_ON_PROVIDER:
      'Servidor no encontrado en el proveedor. Desvincule el servidor o créelo en el proveedor.',
    SERVERS_NOT_FOUND_ON_PROVIDER:
      'Servidor(es) no encontrado(s) en el proveedor. Desvincule el servidor o créelo en el proveedor.',
    SERVER_IS_NOT_STOPPED: 'Servidor no está detenido',
    SERVER_IS_NOT_RUNNING: 'Servidor no está operativo',
    SERVER_PROVIDER_TAG_CONFLICT:
      'La etiqueta "{{tag}}" del servidor en el proveedor es incorrecta o no existe',
    SERVER_TYPE_NOT_ALLOWED:
      'No tienes permiso para realizar esta acción en este tipo de proveedor (soporte o preparación), o esta acción no puede ser ejecutada en el proveedor.',
    SERVER_BELONGS_TO_OTHER_ENVIRONMENT:
      'Este servidor ya está vinculado a otro ambiente ({{environment_uuid}}). Desvinculelo antes de continuar.',
    MODEL_NOT_FOUND_AT_SERVER_START:
      'Publique una imagen antes de iniciar el servidor.',
    INVALID_SERVER_STOP_TIME:
      'La hora de parada debe ser mayor que la hora actual.',
    INVALID_PROVIDER_FOR_MODEL_TYPE_PUBLICATION:
      'Proveedor inválido para el tipo de modelo de publicación.',
    CUSTOM_IMAGE_NOT_FOUND: 'Imagen personalizada no encontrada',
    INVALID_ENVIRONMENT_MODEL: 'El modelo duplicado no es válido',
    CANNOT_DELETE_ENVIRONMENT_WITH_INSTANCES_ASSOCIATED:
      'No es posible eliminar un entorno con instancias asociadas. Por favor, elimine las instancias del entorno antes de solicitar la eliminación del entorno',
    INVALID_OPERATOR_PASSWORD: 'La contraseña de operador es inválida',
    OPERATOR_WITHOUT_PERMISSION:
      'Su operador no forma parte de ningún grupo de permisos. Póngase en contacto con el administrador de la cuenta.',

    API_TOKEN_CREATED: '¡Token de API creado con éxito: {{token}}',
    TOKEN_REMOVE_SUCCESS_KEY: '¡Token eliminado con éxito!',
    INVALID_PARTNER: 'Cuenta inválida',
    INVALID_IPS_ADDRESS: 'Dirección de IP inválida',
    OPERATOR_PASSWORD_DOES_NOT_MATCH: 'La contraseña de operador no coincide',
    CLIENT_APPLICATIONS_TYPE_IS_NOT_PLATFORM:
      'El tipo de aplicación del cliente no es plataforma',

    // API group
    AD_GROUP_NOT_CREATED: 'No se pudo añadir el grupo en AD',
    SALT: {
      SALT_TOGGLE_KEY: 'Ignorar Salt',
      FALSE_ACTIVATE_SALT_KEY: 'Activar Salt en usuarios',
      WARNING_FALSE_ACTIVATE_SALT_KEY:
        'Al activar Salt, las contraseñas de los usuarios recibirán un complemento que aumentará el nivel de seguridad mitigando el riesgo de intrusiones.',
      TRUE_ACTIVATE_SALT_KEY: 'Desactivar Salt en usuarios',
      WARNING_TRUE_ACTIVATE_SALT_KEY:
        'Deshabilitando Salt, Salt dejará de ser considerado durante las autenticaciones de acceso a las instancias por parte de los usuarios, aumentando el riesgo de intrusión.',
      REASON_SALT_KEY: 'Razón',
      SHORT_WARNING_TRUE_ACTIVATE_SALT_KEY:
        'Deshabilitando Salt, Salt dejará de ser considerado durante las autenticaciones de acceso a las instancias.',
      REASON_TO_SKIP_KEY: 'Razón para ignorar Salt',
    },
    INVALID_PASSWORD: 'Contraseña no válida',
    ACCESS_KEY: 'Acceso',

    // AdminView
    SEARCH_ALL_KEY: 'Buscar',
    LIST_ALL_KEY: 'Listar todos',

    ENVIRONMENT_DASHBOARD: {
      LAST_1D: 'Últimas 24 horas',
      LAST_2D: 'Últimas 48 horas',
      LAST_7D: 'Últimos 7 días',
      LAST_15D: 'Últimos 15 días',
      LAST_30D: 'Últimos 30 días',
      LAST_60D: 'Últimos 60 días',
      LAST_90D: 'Últimos 90 días',
      LAST_180D: 'Últimos 180 días',

      SESSIONS_AVG_KEY: 'Sesiones (media)',
      VACANCIES_AVG_KEY: 'Vacantes (media)',
      SESSIONS_MAX_KEY: 'Sesiones',
      VACANCIES_MAX_KEY: 'Vacantes',

      ENVIRONMENT_USE_KEY: 'Detalles de uso del entorno',

      ENVIRONMENT_COST_TITLE_KEY: 'Costo de lo entorno',
      ENVIRONMENT_COST_DETAILS_KEY: 'Detalles del costo de lo entorno',
      ENVIRONMENT_COST_TOTAL_KEY: 'Costo total',

      SESSION_HISTORY_TITLE_KEY: 'Historial de sesiones',
    },
    ERROR_AD_GROUP_NOT_DELETED:
      'Error al eliminar el grupo relacionado con Active Directory. Póngase en contacto con el administrador.',
    USERS_PAGE: {
      LIST_ALL_USERS_KEY: 'Lista de usuarios',
      LIST_ALL_USERS_SUBTITLE_KEY:
        'Lista de todos los usuarios de todos los clientes disponibles',
      USERS_MANAGEMENT_TITLE_KEY: 'Gestión de usuarios',
      USERS_MANAGEMENT_SUBTITLE_KEY:
        'Gestiona los usuarios inactivos o recupera los eliminados',
      SELECTED_USERS_KEY: 'Usuarios seleccionados',
      NO_USERS_KEY: 'No se han encontrado usuarios',
      MANAGE_USERS_KEY: 'Administrar usuarios',
      DELETE_ALL_BUTTON_KEY: 'Eliminar usuario en todos los clientes',
      DELETE_BUTTON_KEY: 'Eliminar usuario en este cliente',
      DELETE_ALL_MODAL_TITLE_KEY: '¿Eliminar usuario en todos los clientes?',
      DELETE_ALL_MODAL_CONTENT_KEY:
        'Este usuario se eliminará de todos los clientes en los que tenga permiso de administración.',
      DELETE_MULTIPLE_USERS_ACTION_KEY: 'Eliminar usuarios seleccionados',
      DELETE_MULTIPLE_USERS_PERMANENTLY_ACTION_KEY:
        'Eliminar permanentemente los seleccionados',
      DELETE_MULTIPLE_USERS_MODAL_TITLE_KEY:
        'Eliminación de usuarios en los clientes',
      DELETE_MULTIPLE_USERS_MODAL_CONTENT_KEY:
        '¿Desea eliminar los {{ count }} usuarios seleccionados en los clientes?',
      DELETION_REQUESTED_KEY: 'Las eliminaciones se solicitaron con éxito.',
      LIST_USER_RECOVERIES_KEY: 'Listar recuperaciones de usuarios',
      DELETED_USERS_TITLE_KEY: 'Listar usuarios eliminados',
      DELETED_USERS_SUBTITLE_KEY:
        'Lista de usuarios eliminados en los clientes',
      RECOVER_USER_ACTION_KEY: 'Recuperar usuario en el cliente',
      RECOVER_USER_MODAL_TITLE_KEY: 'Recuperación del usuario en el cliente',
      RECOVER_USER_MODAL_CONTENT_KEY:
        '¿Desea recuperar el usuario seleccionado en el cliente?',
      RECOVER_MULTIPLE_USERS_ACTION_KEY: 'Recuperar los seleccionados',
      RECOVER_MULTIPLE_USERS_MODAL_TITLE_KEY:
        'Recuperación de los usuarios en los clientes',
      RECOVER_MULTIPLE_USERS_MODAL_CONTENT_KEY:
        '¿Desea recuperar los {{ count }} usuarios seleccionados en los clientes?',
      RECOVER_USER_BY_REQUEST_ACTION_KEY:
        'Recuperar todos los usuarios de la solicitud',
      RECOVER_USER_BY_REQUEST_MODAL_TITLE_KEY:
        'Recuperación de los usuarios eliminados en la solicitud',
      RECOVER_USER_BY_REQUEST_MODAL_CONTENT_KEY:
        'La solicitud {{ requestUuid }} tiene {{ count }} recuperaciones disponibles. ¿Desea continuar?',
      SELECTED_REGISTERS_KEY: 'Registros seleccionados',
      RECOVERY_REQUESTED_KEY: 'Las recuperaciones se solicitaron con éxito.',
      REMOVE_USER_PERMANENTLY_KEY: 'Eliminar usuario de forma permanente',
      REMOVE_USER_PERMANENTLY_MODAL_TITLE_KEY:
        'Eliminación permanente del usuario',
      REMOVE_USER_PERMANENTLY_DESCRIPTION_KEY:
        'Esta acción es irreversible y las informaciónes no pueden ser recuperadas',
      REMOVE_MULTIPLE_USERS_PERMANENTLY_DESCRIPTION_KEY:
        'Está a punto de eliminar permanentemente a {{ counter }} usuarios únicos asociados a los registros seleccionados. ¿Desea continuar?',
    },

    LIST_ALL_MENU: {
      LIST_ALL_ENVIRONMENTS_KEY: 'Enumerar entornos',
      LIST_ALL_COMPANIES_KEY: 'Enumerar empresas',
      LIST_ALL_PARTNERS_KEY: 'Enumerar cuentas',
      LIST_ALL_CLIENTS_KEY: 'Enumerar clientes',
      LIST_ALL_USERS_KEY: 'Enumerar usuarios',
    },

    ACTIVE_SSO_DESCRIPTION: 'Inicio de sesión mediante SSO (Single Sign On)',
    SSO_KEY_LONG: 'Single Sign On',

    SSO: {
      FEDERATION_TYPE: 'Tipo de federación',
      CLIENT_REALM_ID: 'ID de dominio del cliente',

      SAML_URL_SECTION_TITLE:
        'SAML - Configuración de redirección del sitio para inicio de sesión externo (URL)',
      IDP_ENTITY_IDP: 'Id. de entidad del (IdP)',
      SAML_IDP_SINGLE_SIGN_ON_URL: 'URL de inicio de sesión del (IdP)',
      SAML_IDP_SINGLE_LOGOUT_URL: 'URL de cierre de sesión del (IdP)',
      SAML_X509_CERTIFIED: 'Certificado público x509 de (IdP)',

      SAML_ACCESS_TITLE: 'SAML - Configuración de restricciones de acceso',
      RESTRICT_ACCESS_BY_GROUPS:
        '¿Restringir el acceso sólo a los usuarios de un grupo específico?',
      ALLOW_USERS_FROM_GROUP: 'UUID del grupo de usuarios permitido',

      SAML_CLAIM_TYPES_TITLE:
        'SAML - Configuración de los atributos de usuario (Claim types)',
      SAML_IDP_CLAIM_NAME_ID: 'URL del atributo [Name ID] (IdP)',
      SAML_IDP_CLAIM_NAME_GIVEN_NAME: 'URL del atributo [Given name] (IdP)',
      SAML_IDP_CLAIM_SURNAME: 'URL del atributo [Surname] (IdP)',
      SAML_IDP_CLAIM_EMAIL_ADDRESS: 'URL del atributo [Email] (IdP)',
      SAML_IDP_CLAIM_GROUPS: 'URL del atributo [Groups] (IdP)',
    },

    WEIGHT_KEY: 'Peso',

    // USER THEME ERRORS

    CANNOT_DELETE_PARTNER_WITH_PARTNER_ENVIRONMENT_ASSOCIATED:
      'No se puede eliminar un interlocutor con entorno asociado',
    USER_THEME_CONFIG_NOT_FOUND:
      'No se ha encontrado la configuración del tema de usuario',
    SUBDOMAIN_NOT_AVAILABLE: 'Subdominio no disponible',
    SUBDOMAIN_DNS_NOT_CREATED: 'Subdominio DNS no creado',
    SUBDOMAIN_ALTERNATE_DOMAIN_NOT_CREATED:
      'No se ha creado el dominio alternativo del subdominio',
    SUBDOMAIN_DNS_NOT_REMOVED: 'Subdominio DNS no eliminado',
    SUBDOMAIN_ALTERNATE_DOMAIN_NOT_REMOVED:
      'No se ha eliminado el dominio alternativo del subdominio',
    EMAIL_KEY_WARNING_APPLICATION:
      'Correos electrónicos de aviso de finalización',
    INSTANCES_HISTORY_GRAPH_KEY: 'Historial de instancias',
    CREATED_CLIENTS_BY_PERIOD_KEY:
      'Crecimiento durante el periodo: {{percentage}}',
    CREATED_CLIENTS_KEY: 'Clientes creados:',
    CREATED_USERS_KEY: 'Usuarios criados:',
    HISTORY_SOP_KEY: 'Historia',

    INVALID_CAPTCHA_TOKEN:
      'Error de inicio de sesión. Por favor, inténtelo de nuevo',

    INVALID_PERIODS: 'Periodo inválido. Vuelva a intentarlo',
    ACCOUNT_INFORMATION_KEY: 'Informaciones de la cuenta',

    NO_PERMISSIONS_IN_GROUP_KEY:
      'Esta plantilla no está autorizada para gestionar permisos',

    ACTIVATE_MFA_KEY: 'Activar MFA',
    MFA_ACTIVATED_SUCCESSFULLY_KEY: '¡MFA activado!',
    MFA_INACTIVATED_SUCCESSFULLY_KEY: '¡MFA desactivado!',
    ACTIVATE_MFA_MODAL_MESSAGE_KEY:
      '¿Quiere activar el AMF del operador {{firstName}} {{lastName}}?',

    REMOVE_USER_SESSION_KEY: 'Eliminar sesiones de usuario',

    MINIMUM_SESSION_AGE_KEY: 'Duración mínima de la sesión (horas)',
    RUN_TIME_KEY: 'Hora de ejecución',

    AUDIT_SESSION: {
      AUDIT_KEY: 'Auditoría',
      OS_KEY: 'SO',
      BROWSER_KEY: 'Navegador',
      UPDATED_BY_KEY: 'Actualizado por',
      TIME_AT_KEY: 'a las',
      AT_KEY: 'a las',
      ON_KEY: 'el',
    },
    MANAGE_PERMISSIONS_OPERATOR_KEY:
      'Seleccione un rol para poder seleccionar el grupo de permisos correspondiente',

    OPERATOR_HAS_UPPER_ROLE_PERMISSION:
      'Este operador está presente en un grupo con una plantilla de permisos superior a la del rol seleccionado. Elimine primero el grupo seleccionado.',
    SELECT_PARTNER_DASHBOARD:
      'Seleccione una cuenta para ver los datos del dashboard',
    CLIENT_DATA_KEY: 'Datos de lo cliente',
    CLIENT_DATA_SUMMARY_KEY: 'Resumen',
    GENERATE_PDF: 'Generar PDF',
    EXPORT_PDF_KEY: 'Exportar PDF',

    LOGS_PAGE: {
      LIST_LOGS_KEY: 'Auditoría',
      LIST_LOGS_TITLE_KEY: 'Auditoría',
      LIST_LOGS_SUBTITLE_KEY: 'Detalles de acciones sobre los recursos',
      NO_LOGS_KEY: 'No se ha encontrado ningún registro',
      RESOURCE_KEY: 'Recurso',
      RESOURCE_TYPE_KEY: 'Tipo de recurso',
      FILTERS_KEY: 'Filtros',
      DETAILS_KEY: 'Detalles',
      MODAL_DETAILS_TITLE_KEY: 'Detalles del registro',
      CHANGES_KEY: 'Modificaciones',
      CHANGED_FIELD_KEY: 'Campo modificado',
      PUBLISHED_SETTINGS_KEY: 'Ajustes publicados',
      OLD_VALUE_KEY: 'Valor anterior',
      NEW_VALUE_KEY: 'Nuevo valor',
      ACTIVE_KEY: 'Activo',
      INACTIVE_KEY: 'Inactivo',
      VALUE_KEY: 'Valor',
      LIST_LOGS_ENVIRONMENT_KEY: 'Detalles de las acciones en el entorno',
      LIST_LOGS_CLIENTS_KEY: 'Detalles de las acciones en el cliente',
      EVERY_USER_ALREADY_USING_REASON_KEY:
        'Todos los usuarios están accediendo al Portal 2.0',

      RESOURCES: {
        CLIENT_KEY: 'Cliente',
        COMPANY_KEY: 'Compañía',
        ENVIRONMENT_KEY: 'Entorno',
        OPERATOR_KEY: 'Operador',
        PARTNER_KEY: 'Cuenta',
        USER_KEY: 'Usuario',
        MODEL_KEY: 'Modelo',
        ENVIRONMENT_APPLICATION_KEY: 'Entorno aplicación',
        CLIENT_APPLICATION_KEY: 'Aplicaciónes del cliente',
        USER_SESSION_KEY: 'Sesiones del usuario',
        PARTNER_USER_THEME_CONFIG_KEY: 'Personalización de front de cuenta',
        OPERATOR_ROLE_KEY: 'Grupo',
        OPERATOR_ROLE_OBJECTS_KEY: 'Contexto de grupo',
        OPERATOR_ROLE_PERMISSION_KEY: 'Permiso de grupo',
      },

      ACTIONS: {
        CREATE_RESOURCE_KEY: 'Creación',
        UPDATE_RESOURCE_KEY: 'Edición',
        DELETE_RESOURCE_KEY: 'Exclusión',
        PUBLISH_RESOURCE_KEY: 'Publicar',
        MIGRATE_RESOURCE_KEY: 'Migración del entorno',
      },

      FIELDS: {
        CODES_ADDED_KEY: 'Permiso añadido',
        CODES_REMOVED_KEY: 'Permiso eliminado',
        COMPANY_UUID_KEY: 'ID de la compañía',
        CLOUD_PROVIDERS_KEY: 'Proveedor de nube',
        PLUGIN_KEY: '¿Usar plugin personalizado?',
        FRONTEND_KEY: '¿Usar nueva interfaz?',
        ALLOW_SSO_CONFIGURATION_KEY: 'Permitir configuración de SSO',
        SCALE_INSTANCES_KEY: 'Modelo',
        TRUSTED_USERS_KEY: 'Usuarios administrativos',
        ZERO_TRUST_KEY: 'Zero Trust',
        EXTERNAL_CLIENT_CODE_KEY: 'Código externo del cliente',
        COPY_ADMIN_KEY:
          'Siempre copiar al administrador registrado al cliente en las comunicaciones por correo electrónico',
        AUDITING_KEY: '¿Bloquear múltiples instancias del mismo usuario?',
        AD_PASSWORD_SALT_KEY: 'Ignorar Salt',
        USE_PROFILE_KEY: 'Perfil Remoto',
        BLOCKED_KEY: 'Bloquear operador',
        UPDATED_DATE_KEY: 'Fecha de última actualización',
        MFA_REQUIRED_KEY: 'Habilitar MFA',
        FAVICON_IMAGE_KEY: 'Favicon',
        MESSAGES_IMAGE_KEY: 'Mensaje',
        USE_BROWSER_LANGUAGE_KEY: 'Usar idioma del navegador',
        REGISTRATION_SOURCE_KEY: 'Registrado a través de',
        REGISTRATION_MODE_KEY: 'Modo de registro',
        UPDATED_BY_OPERATOR_KEY: 'Actualizado por',
        OPERATOR_UUID_KEY: 'UUID del operador',
        CLIENT_UUID_KEY: 'ID del cliente',
        PARTNER_UUID_KEY: 'ID de la cuenta',
        ENVIRONMENT_UUID_KEY: 'ID del entorno',
        LOGO_IMAGE_KEY: 'Logo de la cuenta',
        SECONDARY_COLOR_KEY: 'Color secundario',
        SECONDARY_DARK_COLOR_KEY: 'Color secundario oscuro',
        SECONDARY_LIGHT_COLOR_KEY: 'Color secundario claro',
        BACKGROUND_IMAGE_KEY: 'Banner de inicio de sesión',
        MAINTENANCE_IMAGE_KEY: 'Imagen de mantenimiento',
        PRIMARY_DARK_COLOR_KEY: 'Color primario oscuro',
        PRIMARY_LIGHT_COLOR_KEY: 'Color primario claro',
        SECONDARY_CONTRAST_TEXT_COLOR_KEY:
          'Color secundario del título de los entornos',
      },
    },

    ACTIVE_DNS_WARN_KEY:
      'La opción DNS está activada y el virtualizador seleccionado es {{virtualizer}}. ¿Desea continuar?',
    PERMISSION_KEY: 'Permiso',
    CANT_DELETE_MODEL_KEY:
      'No puedes borrar lo modelo primaria. Cámbiela en la configuración del entorno.',
    MFA_RESET_SUCCESS_KEY: '¡MFA restablecido con éxito!',

    COSTS_PAGE: {
      DASHBOARD_TITLE_KEY: 'Dashboard de costos',
      ENVIRONMENTS_COST_TITLE_KEY: 'Costo de los entornos',
      FLAVORS_COST_TITLE_KEY: 'Costo de los flavors',
      NO_RESULTS: 'No hay resultados',
      COST_KEY: 'Costo',
      COSTS_KEY: 'Costos',
      COST_PERCENTAGE_KEY: 'Porcentaje do costo',
      FLAVOR_DETAILS_KEY: 'Detalles de flavor',
      SELECTED_FLAVOR_KEY: 'Flavor seleccionado',
    },
    INSTANCE_SECONDS_KEY: '{{seconds}} segundos',
    INSTANCE_DATE_STATUS_KEY: 'Datos temporales de la instancia',
    DATE_TIME_START_KEY: 'Fecha de inicialización',
    DATE_TIME_OPERATIONAL_KEY: 'Fecha de operacionalización',
    TIME_TO_START_OPERATIONAL_KEY: 'Tiempo para la operacionalización',
    TIME_OPERATIONAL_KEY: 'Tiempo operativo',

    INSTANCE_DAY_KEY: 'día',
    INSTANCE_HOUR_KEY: 'hora',
    INSTANCE_MINUTE_KEY: 'minuto',
    INSTANCE_SECOND_KEY: 'segundo',

    SELECT_KEY: 'Seleccionar',

    APPLY_DATE_FILTERS_KEY: 'Aplicar filtro de fechas',

    APPLICATIONS_CLIENTS_COUNT_KEY: 'Número de clientes',
    APPLICATIONS_CLIENTS_MODAL_TITLE_KEY: 'Lista de clientes de {{app_name}}',
    APPLICATIONS_NAME_KEY: 'Aplicación',
    PDF_GENERATED_AT_KEY: 'PDF generado en',
    PDF_GENERATED_SUCCESSFULLY_KEY: '¡PDF generado con éxito!',
    RENAME_KEY: 'Cambiar nombre',
    RENAME_APP_KEY: 'Cambiar el nombre de la aplicación {{app_name}}',
    CURRENT_NAME_KEY: 'Nombre actual',
    NEW_NAME_KEY: 'Nuevo nombre',
    RENAME_APP_SUCCESSFULLY_KEY: '¡Aplicación renombrada con éxito!',
    ENVIRONMENT_APPS_LISTING_KEY: 'Aplicaciones de entorno',
    ENVIRONMENT_APPS_LISTING_SUBTITLE_KEY:
      'Listado de todas las aplicaciones de todos los clientes de este entorno',
    REMOVE_APP_KEY: 'Eliminar',
    REMOVE_APP_NAME_KEY: 'Eliminar aplicación',
    REMOVE_APP_CONFIRMATION_KEY:
      '¿Está seguro de que desea eliminar la aplicación {{app_name}}?',
    REMOVE_APP_SUCCESSFULLY_KEY: '¡Aplicación eliminada con éxito!',
    ACTIVATE_INACTIVATE_KEY: 'Activar/Inactivar',
    INACTIVATE_KEY: 'Inactivar',
    ACTIVATE_IN_ALL_CLIENTS_KEY:
      '¿Activar la aplicación en todos los clientes?',
    INACTIVATE_IN_ALL_CLIENTS_KEY:
      '¿Inctivar la aplicación en todos los clientes?',
    ACTIVATED_SUCCESSFULLY_KEY: '¡Activación correcta!',
    INACTIVATED_SUCCESSFULLY_KEY: '¡Inactivación correcta!',
    APPLICATIONS_CLIENTS_CHANGE_STATE_MODAL_TITLE_KEY:
      'Lista de clientes de {{app_name}} para cambiar de estado',
    INCLUDE_CLIENT_KEY: 'Incluir cliente',
    INCLUDE_CLIENT_ACTIVE_KEY: 'Incluir activo',
    INCLUDE_CLIENT_INACTIVE_KEY: 'Incluir inactivo',
    INCLUDE_IN_ALL_CLIENTS_KEY: 'Incluir aplicación en todos los clientes',
    INCLUDE_SUCCESSFULLY_KEY: '¡Incluir con éxito!',
    INCLUDE_KEY: 'Incluir',
    APPLICATIONS_CLIENTS_INCLUDE_MODAL_TITLE_KEY:
      'Lista de clientes disponibles para incluir en {{app_name}}',
    SUBDOMAIN_REGEX_RULE_KEY:
      'El subdominio acepta solo letras minúsculas, números y guiones, y debe comenzar con una letra, terminar con una letra o número y no contener guiones consecutivos.',
    DOMAIN_REGEX_RULE_KEY:
      'El dominio acepta solo letras minúsculas, números, guiones y puntos, y debe comenzar con una letra, terminar con una letra o número, no contener guiones consecutivos y tener al menos dos caracteres después del último punto.',
    APPLICATIONS_CLIENTS_REMOVE_CONFIRMATION_TITLE_KEY:
      'Confirmar eliminación de {{app_name}}',
    APPLICATIONS_CLIENTS_REMOVE_CONFIRMATION_KEY:
      '¿Está seguro de que desea eliminar la aplicación {{app_name}}?',
    CONFIRM_REMOVE_KEY: 'Confirmar eliminación',
    APPLICATIONS_CLIENTS_RENAME_CONFIRMATION_TITLE_KEY:
      'Confirmar cambio de nombre de {{app_name}}',
    APPLICATIONS_CLIENTS_RENAME_CONFIRMATION_KEY:
      '¿Está seguro de que desea cambiar el nombre de la aplicación {{app_name}} a {{new_app_name}}?',
    CONFIRM_RENAME_KEY: 'Confirmar cambio de nombre',
    APPLICATIONS_CLIENTS_ACTIVE_CONFIRMATION_TITLE_KEY:
      'Confirmar activación en {{app_name}}',
    APPLICATIONS_CLIENTS_INACTIVE_CONFIRMATION_TITLE_KEY:
      'Confirmar inactivación en {{app_name}}',
    APPLICATIONS_CLIENTS_ACTIVE_CONFIRMATION_KEY:
      '¿Está seguro de que desea activar {{app_name}} para estos clientes?',
    APPLICATIONS_CLIENTS_INACTIVE_CONFIRMATION_KEY:
      '¿Está seguro de que desea desactivar {{app_name}} para estos clientes?',
    CONFIRM_ACTIVE_KEY: 'Confirme la activación',
    CONFIRM_INACTIVE_KEY: 'Confirmar inactivación',
    APPLICATIONS_CLIENTS_INCLUDE_CONFIRMATION_TITLE_KEY:
      'Confirmar inclusión en {{app_name}}',
    APPLICATIONS_CLIENTS_INCLUDE_CONFIRMATION_KEY:
      '¿Está seguro de que desea incluir estos clientes en la aplicación {{app_name}}?',
    CONFIRM_INCLUDE_KEY: 'Confirmar inclusión',
    INCLUDE_NEW_APP_KEY: 'Incluir nueva aplicación',
    APP_TO_BE_INCLUDED_KEY: 'Nombre de la aplicación que se va a incluir',
    CONFIRM_INCLUSION_OF_TITLE_KEY: 'Confirmar inclusión de {{app_name}}',
    CONFIRM_INCLUSION_OF_KEY:
      '¿Está seguro de que desea incluir la aplicación {{app_name}}?',
    ATTACHED_KEY: 'Vinculado',
    DETACHED_KEY: 'Desvinculado',
    ATTACH_SUCCESSFULLY_KEY: '¡Enlazado con éxito!',
    DETACH_SUCCESSFULLY_KEY: '¡Desvinculado correctamente!',

    ENVIRONMENT_ADMIN_TITLE_KEY: 'Administración del medio ambiente',
    CURRENT_ACCOUNT_KEY: 'Cuenta de origen:',
    NEW_ACCOUNT_KEY: 'Cuenta de destino:',
    MIGRATE_ENVIRONMENT_BUTTON_KEY: 'Cambiar cuenta de entorno',
    MIGRATE_ENVIRONMENT_KEY: 'Migración del entorno',
    MIGRATION_OF_ENVIRONMENT_KEY: 'Migración del entorno {{nombre_entorno}}',
    MIGRATION_MODAL_TEXT_KEY: '¿Está seguro de que desea migrar el entorno: ',
    MIGRATION_ORIGIN_KEY: 'Origen',
    MIGRATION_DESTINATION_KEY: 'Destino',
    MIGRATION_PARTNER_KEY: 'Cuenta:',
    MIGRATION_COMPANY_KEY: 'Compañia:',
    MIGRATION_TO_CONFIRM_KEY:
      'Para confirmar la migración, introduzca el motivo de la acción en el campo siguiente:',
    CONFIRM_MIGRATION_KEY: 'Confirmar migración',
    MIGRATION_HISTORY_SUBTITLE_KEY: 'Historial de migración del entorno',
    MIGRATION_DATE_KEY: 'Fecha de migración',
    ORIGIN_COMPANY_KEY: 'Compañia de origen',
    DESTINATION_COMPANY_KEY: 'Compañia de destino',
    ORIGIN_PARTNER_KEY: 'Cuenta de origen',
    DESTINATION_PARTNER_KEY: 'Cuenta de destino',
    MIGRATE_ENVIRONMENT_BUTTON_BELLOW_KEY:
      'Haz clic en el botón de abajo para configurar la migración de este entorno',
    UNEQUAL_PARTNER_SETTINGS:
      'La configuración de la cuenta de destino no coinciden con la de la cuenta actual',
    PROVIDER_AWS_SETTINGS_KEY:
      'Regla 1: La configuración del proveedor de la nube de AWS: rol arn, ID de propietario de AWS, ID externo',
    PROVIDER_OCI_SETTINGS_KEY:
      'Regla 2: Configuración del proveedor de la nube OCI: ID de compartimento',
    ACTIVE_DIRECTORY_SETTINGS_KEY:
      'Regla 3: Tipo de cuenta LDAP y configuración LDAP (Active Directory): Servidor LDAP, Admin bind pass, Admin DN, LDAP Server Backup, Base DN, Domain',
    SALT_SETTINGS_KEY:
      'Regla 4: La configuración de Salt: Habilitar Salt en usuarios',
    SSO_SETTINGS_KEY: 'Regla 5: El ajuste SSO: Permite configurar SSO.',
    NEW_FRONT_SETTINGS_KEY:
      'Regla 6: El ajuste Use new interface: Permite utilizar un nuevo frente.',
    ENVIRONMENT_SUCCESSFULLY_MIGRATED_KEY: 'Entorno migrado correctamente',
    MIGRATION_REASON_KEY: 'Motivo de la migración',
    WARN_MIGRATION_RULES_KEY:
      'Los siguientes ajustes, presentes en la pantalla de edición de la cuenta, deben ser idénticos entre la cuenta de origen y la de destino:',
    RULE_MIGRATION_ONE_KEY:
      'La configuración del proveedor de la nube de AWS: arn de rol, ID de propietario de AWS, ID externo',
    RULE_MIGRATION_TWO_KEY:
      'Configuración del proveedor de la nube OCI: ID de compartimento',
    RULE_MIGRATION_THREE_KEY:
      'El tipo de cuenta LDAP y la configuración LDAP (Active Directory): servidor LDAP, contraseña de enlace de administrador, DN de administrador, copia de seguridad del servidor LDAP, DN base, dominio,',
    RULE_MIGRATION_FOUR_KEY:
      'La configuración de Salt: Activar Salt en usuarios',
    RULE_MIGRATION_FIVE_KEY: 'El ajuste SSO: Permite configurar SSO',
    RULE_MIGRATION_SIX_KEY:
      'El ajuste Use new interface: Permite utilizar un nuevo frente',
    RULE_ONE_KEY: 'Regla 1: ',
    RULE_TWO_KEY: 'Regla 2: ',
    RULE_THREE_KEY: 'Regla 3: ',
    RULE_FOUR_KEY: 'Regla 4: ',
    RULE_FIVE_KEY: 'Regla 5: ',
    RULE_SIX_KEY: 'Regla 6: ',
    ERROR_MIGRATION_RULES_KEY:
      'No fue posible migrar este entorno a la cuenta seleccionada debido a que la siguiente configuración difiere de la cuenta actual:',
    ERROR_MIGRATION_RULES_SOLUTION_KEY:
      'Por favor, configure la cuenta de destino para que cumpla los mismos ajustes que la cuenta actual e inténtelo de nuevo.',
    CHOOSE_ANOTHER_PARTNER: 'Elija otra cuenta',
    DISMISS_KEY: 'Descartar',
    ORIGIN_AND_DESTINATION_PARTNER_CANT_BE_EQUAL:
      'Las cuentas de origen y destino no pueden ser iguales.',
    CURRENT_PARTNER_CONFIG_KEY: 'Configuración de la cuenta corriente',

    DYNAMIC_FILTER: {
      CLEAN_FILTERS_KEY: 'Limpiar filtros',
      CLEAN_ALL_KEY: 'Limpiar todo',
      SELECT_ALL_KEY: 'Seleccionar todo',
      FILTER_BUTTON_KEY: 'Filtros dinámicos',
      USER_UUID_KEY: 'ID de usuario',
      AD_USERNAME_KEY: 'Usuario AD',
      SALT_CONFIGURED_KEY: 'Sal configurada',
      YES_KEY: 'Sí',
      NO_KEY: 'No',
      PARTNER_UUID_KEY: 'ID de cuenta',
      PARTNER_NAME_KEY: 'Nombre de la cuenta',
      MFA_CONFIGURED_KEY: 'MFA configurado',
      FIRST_NAME_KEY: 'Nombre',
      LAST_NAME_KEY: 'Apellidos',
      ENVIRONMENT_NAME_KEY: 'Nombre del entorno',
      ENVIRONMENT_UUID_KEY: 'ID del entorno',
      EMAIL_KEY: 'Correo electrónico',
      COMPANY_UUID_KEY: 'ID de empresa',
      COMPANY_NAME_KEY: 'Nombre de la empresa',
      CLIENT_UUID_KEY: 'ID de cliente',
      CLIENT_NAME_KEY: 'Nombre del cliente',
      STATUS_KEY: 'Estado',
      ACTIVE_KEY: 'Activo',
      INACTIVE_KEY: 'Inactivo',
      ALLOW_SSO_CONFIG_KEY: 'Permite configurar SSO',
      CUSTOM_FRONTEND_KEY: 'Tiene frontend personalizado',
      LDAP_SERVER_KEY: 'Servidor LDAP',
      LDAP_TYPE_KEY: 'Tipo LDAP',
      OCI_COMPARTMENT_ID_KEY: 'OCI - Compartment ID',
      PARTNER_NEW_FRONT_ENABLED_KEY: 'Utilizar nuevo frontend',
      ROLE_AWS_KEY: 'AWS - Role ARN',
      INTERNAL_KEY: 'Interno',
      EXTERNAL_KEY: 'Externo',
      MANAGED_KEY: 'Gestionado',
      PARTNER_ALIAS_KEY: 'Alias',
      COMPANY_TYPE_KEY: 'Tipo de empresa',
      COMPANY_STATUS_KEY: 'Estado de la empresa',
      RESPONSIBLE_EMAIL_KEY: 'Correo electrónico de la persona responsable',
      RESPONSIBLE_NAME_KEY: 'Nombre de la persona responsable',
      RESPONSIBLE_PHONE_KEY: 'Número de teléfono de la persona responsable',
      TRADING_NAME_KEY: 'Nombre comercial',
      ZOHO_ID_KEY: 'ID Zoho',
      CLIENT_KEY: 'Cliente',
      PARTNER_KEY: 'Cuenta',
      EXTERNAL_CLIENT_CODE_KEY: 'Código de cliente externo',
      IDENTIFICATION_KEY: 'Client ID',
      APPLICATIONS_REGISTRATION_MODE_KEY: 'Modo de registro',
      BACKUP_MODEL_ID_KEY: 'ID de modelo secundario',
      BEHAVIOR_TYPE_KEY: 'Tipo de comportamiento',
      BLOCK_MULTIPLE_SESSION_KEY: 'Bloqueo de sesiones múltiples',
      CONNECTION_TYPE_KEY: 'Tipo de conexión',
      IN_MAINTENANCE_KEY: 'En mantenimiento',
      LICENSE_LIMIT_KEY: 'Límite de licencia',
      LICENSE_LIMIT_PER_CLIENT_KEY: 'Tiene límite de licencias por cliente',
      MAIN_MODEL_ID_KEY: 'ID principal del modelo',
      NUM_CLIENTS_KEY: 'Número de clientes',
      NUM_USERS_KEY: 'Número de usuarios',
      PROVIDER_TYPE_KEY: 'Tipo de proveedor',
      PUBLICATION_TYPE_KEY: 'Tipo de publicación',
      REGION_KEY: 'Región',
      USE_DNS_KEY: 'Utiliza DNS para la conexión remota',
      VIRTUALIZER_KEY: 'Virtualizador',
      ZERO_TRUST_ENABLED_KEY: 'Zero Trust',
      SIMPLE_KEY: 'Simple',
      ADVANCED_KEY: 'Avanzado',
      MANUAL_KEY: 'Manual',
      PERIOD_KEY: 'Periodos',
      MICRO_KEY: 'Micro',
      SPOT_PERIOD_KEY: 'Periodos (Puntuales)',
      HAAS_KEY: 'HaaS',
      CCC_KEY: 'CCC',
      PUBLIC_KEY: 'Público',
      PRIVATE_KEY: 'Privado',
      AWS_KEY: 'AWS',
      OCI_KEY: 'OCI',
      MULTICLOUD_KEY: 'Multicloud',
      CUSTOM_IMAGE_KEY: 'Imagen personalizada',
      BOOT_VOLUME_KEY: 'Volumen de boot',
      BOOT_VOLUME_BACKUP_KEY: 'Copia de seguridad del volumen de boot',
      CONNECT_KEY: 'ConnectSky',
      CONNECT_DIRECT_KEY: 'ConnectSky (Direct Connect)',
      RDP_KEY: 'Microsoft Remote Desktop (Archivo)',
      RDP_DIRECT_KEY: 'Microsoft Remote Desktop (Direct Connect)',
      RDP_APP_KEY: 'Microsoft Remote Desktop (RemoteApp)',
      TSPLUS_KEY: 'TSPlus (WebBrowser HTML5)',
      TSPLUS_REMOTE_APP_KEY: 'TSPlus (RemoteApp)',
      TSPLUS_ALL_KEY: 'TSPlus (WebBrowser HTML and RemoteApp)',
      SERVER_TYPE_KEY: 'Tipo de servidor',
      INSTANCE_STATE_KEY: 'Estado de lo servidor',
      INSTANCE_ID_KEY: 'ID de instancia',
      IMAGE_PUBLICATION_STATUS_KEY: 'Estado de la imagen',
      FLAVOR_KEY: 'Sabor',
      NAME_KEY: 'Nombre',
      OPERATING_TIME_KEY: 'Tiempo de operatividad de la instancia',
      MONITORING_TYPE_KEY: 'Tipo de supervisión',
      CLIENT_USE_NEW_FRONT_KEY: 'Utiliza nueva interfaz',
      NO_ACCESS_KEY: 'Sin acceso',
      GREATER_THAN_OR_EQUAL_TO_30_DAYS_KEY: 'Mayor o igual a 1 mes',
      GREATER_THAN_OR_EQUAL_TO_60_DAYS_KEY: 'Mayor o igual a 2 meses',
      GREATER_THAN_OR_EQUAL_TO_90_DAYS_KEY: 'Mayor o igual a 3 meses',
      GREATER_THAN_OR_EQUAL_TO_180_DAYS_KEY: 'Mayor o igual a 6 meses',
    },
    LIST_PARTNER_SERVERS: 'Lista de servidores de cuentas',
    START_PARTNER_SERVERS: 'Iniciar servidores de cuentas',
    STOP_PARTNER_SERVERS: 'Detener servidores de cuentas',
    PUBLISH_NEW_IMAGE_PARTNER_SERVERS:
      'Publicar imagen en los servidores de la cuenta',
    LIST_IMAGE_PUBLICATION_SCHEDULE:
      'Listar horarios de publicación de imágenes',
    CREATE_IMAGE_PUBLICATION_SCHEDULE:
      'Crear calendario de publicación de imágenes',
    CANCEL_IMAGE_PUBLICATION_SCHEDULE:
      'Cancelar calendario de publicación de imágenes',
    START_SERVERS_KEY: 'Iniciar servidores',
    START_SERVERS_CONFIRM_KEY: '¿Desea iniciar los servidores seleccionados?',
    STOP_SERVERS_KEY: 'Detener servidores',
    STOP_SERVERS_CONFIRM_KEY: '¿Desea detener los servidores seleccionados?',
    LIST_ALL_PARTNER_SERVERS_KEY:
      'Lista de todos los servidores de preparación de la cuenta',
    SERVERS_START_REQUESTED: '¡Inicio del servidores solicitado con éxito!',
    SERVERS_STOP_REQUESTED: '¡Detención del servidores solicitada con éxito!',
    LIST_DASHBOARD_PERFORMANCE: 'Ver panel de rendimiento',
    CAN_MANAGE_ENVIRONMENT_STATUS: 'Gestionar estado del entorno',
    PERFORMANCE_PAGE: {
      PERFORMANCE_KEY: 'Rendimiento',
      PERFORMANCE_TITLE_KEY: 'Datos de rendimiento para este entorno',
      CPU_USE_KEY: 'Uso de la CPU',
      MEMORY_USE_KEY: 'Uso de memoria',
      AVG_KEY: 'Media',
      MAX_KEY: 'Máximo',
      OPERATIONAL_TIME_DETAILS_KEY:
        'Detalles de tiempo de operacionalización de la instancia',
      CPU_USE_DETAILS_KEY: 'Detalles de uso de CPU',
      MEMORY_USE_DETAILS_KEY: 'Detalles de uso de memoria',
      COSTS_DETAILS_KEY: 'Detalles de los costes',
      ENVIRONMENT_COSTS_DETAILS_KEY: 'Detalles de los costes de entorno',
      CPU_MEMORY_USE_KEY: 'Uso de CPU y memoria',
      SESSIONS_VACANCIES_OPERATIONAL_KEY:
        'Sesiones, vacantes y tiempo de operacionalización',
      SESSIONS_AND_VACANCIES_KEY: 'Sesiones y vacantes',
      SESSIONS_AND_VACANCIES_DETAILS_KEY: 'Detalles de sesiones y vacantes',
      FILTERS_KEY: 'Filtros',
    },
    ACCESS_ENVIRONMENT_KEY: 'Acceso al entorno',

    CAN_EDIT_ENVIRONMENT_MONITORING_SETTINGS:
      'Editar monitorización de entorno',

    MONITORING_PAGE: {
      SUBTITLE_KEY:
        'Active la opción de abajo para gestionar la monitorización del entorno',
      SWITCH_TEXT_KEY: 'Activar la monitorización del entorno',
      EMAILS_TO_ALERT_KEY:
        'Correos electrónicos para recibir el resumen diario',
      OPERATING_TIME_KEY: 'Tiempo de operatividad de las instancias',
      OPERATING_TIME_IN_MINUTES_KEY:
        'Tiempo máximo de operacionalización (en minutos):',
      HISTORY_SUBTITLE_KEY: 'Historial de alertas de monitorización',
      TYPE_KEY: 'Tipo',
      DATE_TIME_KEY: 'Fecha y hora',
      INSTANCES_KEY: 'Instancias',
      VACANCIES_KEY: 'Vacantes',
      LICENSES_KEY: 'Licencias',
      SESSIONS_KEY: 'Sesiones',
      DETAILS_KEY: 'Detalles',
      MONITORING_SUCCESSFULLY_SET_KEY:
        '¡Entorno de monitorización configurado con éxito!',
      CONFIGURED_OPERATING_TIME_KEY: 'Tiempo de funcionamiento configurado',
      AVERAGE_OPERATING_TIME_KEY: 'Tiempo de funcionamiento',
      ALERTED_INSTANCES_KEY: 'Instancias alertadas',
      MINUTES_KEY: 'minutos',
      AVERAGE_OPERATING_TIME_IN_MINUTES_KEY:
        'Tiempo medio de funcionamiento (en minutos):',
    },
    INVALID_SCHEDULE_DATETIME:
      'La fecha y hora del calendario de publicación de imágenes debe ser mayor que la fecha y hora actuales.',
    SERVER_HAS_SCHEDULE_PUBLICATION_KEY:
      'Este servidor tiene una publicación programada',
    SCHEDULE_PUBLICATION_MODAL_TITLE_KEY: 'Calendario de publicación estándar',
    IDENTIFIER_KEY: 'Identificador',
    REQUESTER_KEY: 'Solicitante',
    SCHEDULE_DATETIME_KEY: 'Fecha y hora de programación',
    TIMEZONE_KEY: 'Zona horaria',
    EMAILS_TO_NOTIFY_CONCLUSION_KEY:
      'Correos electrónicos para notificar la finalización de la publicación',
    DATETIME_TO_SCHEDULE_KEY: 'Hora de la programación',
    CANCEL_PUBLICATION_SCHEDULE_TITLE_KEY:
      'Cancelar programación de publicación de imágenes',
    CONFIRM_PUBLICATION_SCHEDULE_CONTENT_KEY:
      '¿Está seguro de que desea confirmar la programación para {{datetime}}?',
    CONFIRM_SCHEDULE_KEY: 'Confirmar programación',
    CONFIRM_PUBLICATION_SCHEDULE_TITLE_KEY:
      'Confirmar horario de publicación de imágenes',
    CANCEL_PUBLICATION_SCHEDULE_CONTENT_KEY:
      '¿Está seguro de que desea cancelar la programación de {{datetime}}?',
    CANCEL_SCHEDULE_KEY: 'Cancelar planificación',
    NO_SCHEDULE_FOUND: 'No se ha encontrado ninguna programación',
    PUBLICATION_SCHEDULE_CANCEL_SUCCESSFULLY_KEY:
      '¡Horario de publicación cancelado con éxito!',
    PUBLICATION_SCHEDULE_SUCCESSFULLY_KEY: '¡Publicación programada con éxito!',
    BULK_CREATE_KEY: 'Creación masiva',
    BULK_REMOVE_KEY: 'Eliminación masiva',
    TIME_SET_KEY: 'Hora',
    APP_UUID_KEY: 'ID de aplicación',
    APP_NAME_KEY: 'Nombre de la aplicación',
    BULK_UPDATE_KEY: 'Edición masiva',
    CAN_EDIT_CLIENTS_IN_BULK: 'Gestionar clientes en masa',
    REPLACE_KEY: 'Reemplazar',
    OR_KEY: 'O',
    BULK_CLIENTS: {
      CLIENTS_KEY: 'Clientes',
      CLIENTS_TITLE_KEY: 'Clientes del entorno',
      CLIENTS_SUBTITLE_KEY:
        'Gestiona clientes del entorno, configurando recursos en masa para todos los clientes del entorno o seleccionándolos individualmente',
      NO_RESOURCE_FOUND_KEY: 'No se encontraron recursos',
      ENVIRONMENT_KEY: 'Entorno',
      EDIT_KEY: 'Editar',
      DETAILS_KEY: 'Detalles',
      EMAIL_ADMIN_KEY: 'Email de administrador',
      COPY_EMAIL_ADMIN_KEY: 'Copiar email de administrador',
      BLOCK_MULTIPLE_SESSIONS_KEY: 'Bloquear múltiples sesiones',
      IOS_DEVICES_KEY: 'Utilizar dispositivo iOS',
      ACTIVATE_MFA_KEY: 'Activar MFA',
      LIMIT_LICENSES_KEY: 'Limitar licencias',
      LIMIT_CONFIG_KEY: 'Configurar límite de licencia',
      ENABLE_DISABLE_KEY: 'Activar/Desactivar',
      VIRTUALIZER_KEY: 'Virtualizador',
      CONNECTION_TYPE_KEY: 'Tipo de conexión',
      CHANGE_CONNECTION_TYPE_KEY: 'Configurar tipo de conexión',
      CONFIG_CONNECTION_TYPE_KEY: 'Configurar estado del tipo de conexión',
      PORT_ONE_KEY: 'Puerto 01 (Primario)',
      PORT_TWO_KEY: 'Puerto 02 (Secundario)',
      QUALITY_KEY: 'Calidad',
      ACTIVE_KEY: 'Activo',
      TYPE_KEY: 'Tipo',
      PUBLIC_KEY: 'Público',
      PRIVATE_KEY: 'Privado',
      QUANTITY_KEY: 'Cantidad',
      LIMIT_LICENSES_STATUS_KEY: 'Estado del límite de licencias',
      ACTIVATE_IN_ALL_CLIENTS_KEY:
        '¿Activar límite de licencias en todos los clientes?',
      INACTIVATE_IN_ALL_CLIENTS_KEY:
        '¿Desactivar límite de licencias en todos los clientes?',
      CONFIRM_ACTIVATE_IN_CLIENTS_KEY:
        '¿Está seguro de que desea configurar el límite de licencias en estos clientes?',
      CONFIRM_INACTIVATE_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar el límite de licencias en estos clientes?',
      CONFIRM_ACTIVATE_KEY: 'Confirmar ajustes de límite de licencias',
      CONFIRM_INACTIVATE_KEY: 'Confirmar desactivación de límite de licencias',
      CONFIRM_ACTIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar el límite de licencias en todos los clientes?',
      CONFIRM_INACTIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar el límite de licencias en todos los clientes?',
      ACTIVATE_LIMIT_TO_CONFIRM_KEY:
        'Para confirmar la activación, proporciona el motivo de la acción en el campo a continuación:',
      INACTIVATE_LIMIT_TO_CONFIRM_KEY:
        'Para confirmar la desactivación, proporciona el motivo de la acción en el campo a continuación:',
      EDIT_SUCCESSFULLY_KEY: '¡Edición realizada con éxito!',
      SET_PUBLIC_IN_ALL_CLIENTS_KEY:
        '¿Configurar tipo de conexión como público en todos los clientes?',
      SET_PRIVATE_IN_ALL_CLIENTS_KEY:
        '¿Configurar tipo de conexión como privado en todos los clientes?',
      SET_PRIVATE_KEY: 'Hacer privado',
      SET_PUBLIC_KEY: 'Hacer público',
      CONFIRM_SET_PUBLIC_KEY: 'Confirmar cambio de tipo de conexión a público',
      CONFIRM_SET_PRIVATE_KEY: 'Confirmar cambio de tipo de conexión a privado',
      CONFIRM_SET_CONNECTION_TYPE_KEY: 'Confirmar cambio de tipo de conexión',
      SET_CONNECTION_TYPE_TO_CONFIRM_KEY:
        'Para confirmar el cambio, proporciona el motivo de la acción en el campo a continuación:',
      CONFIRM_CHANGE_KEY: 'Confirmar cambio',
      CONFIRM_SET_PUBLIC_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas cambiar el tipo de conexión a público en todos los clientes?',
      CONFIRM_SET_PRIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas cambiar el tipo de conexión a privado en todos los clientes?',
      CURRENT_ENVIRONMENT_KEY: 'Entorno actual',
      DESTINATION_ENVIRONMENT_KEY: 'Entorno de destino',
      CONFIRM_MIGRATION_BETWEEN_ENVIRONMENTS_KEY:
        'Confirmar migración de clientes entre entornos',
      CLIENTS_TO_MIGRATE_KEY: 'Clientes a migrar',
      CONFIRMATION_KEY: 'Confirmación',
      CONFIRM_CLIENTS_MIGRATION_TO_ENVIRONMENT_KEY:
        '¿Estás seguro de que deseas migrar los siguientes clientes al entorno ',
      CHOOSE_ENVIRONMENT_KEY: 'Elige un entorno',
      CONFIRM_CHANGE_VIRTUALIZER_KEY: 'Confirmar cambio de virtualizador',
      CONFIRM_CHANGE_VIRTUALIZER_IN_CLIENTS_KEY:
        '¿Confirmar cambio de virtualizador en estos clientes?',
      CONFIRM_CHANGE_VIRTUALIZER_IN_ALL_CLIENTS_KEY:
        '¿Confirmar cambio de virtualizador en todos los clientes?',
      CONFIG_VIRTUALIZER_IN_ALL_CLIENTS_KEY:
        '¿Configurar este virtualizador y puertos para todos los clientes?',
      ACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_KEY:
        '¿Activar copiar email de administrador en todos los clientes?',
      INACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_KEY:
        '¿Desactivar copiar email de administrador en todos los clientes?',
      CONFIRM_ACTIVATE_COPY_ADMIN_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar copiar email de administrador en estos clientes?',
      CONFIRM_INACTIVATE_COPY_ADMIN_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar copiar email de administrador en estos clientes?',
      CONFIRM_ACTIVATE_COPY_ADMIN_KEY:
        'Confirmar activación de copiar email de administrador',
      CONFIRM_INACTIVATE_COPY_ADMIN_KEY:
        'Confirmar desactivación de copiar email de administrador',
      CONFIRM_ACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar copiar email de administrador en todos los clientes?',
      CONFIRM_INACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar copiar email de administrador en todos los clientes?',
      ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_KEY:
        '¿Activar bloqueo de múltiples sesiones en todos los clientes?',
      INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_KEY:
        '¿Desactivar bloqueo de múltiples sesiones en todos los clientes?',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar bloqueo de múltiples sesiones en estos clientes?',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar bloqueo de múltiples sesiones en estos clientes?',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_KEY:
        'Confirmar activación de bloqueo de múltiples sesiones',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_KEY:
        'Confirmar desactivación de bloqueo de múltiples sesiones',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar bloqueo de múltiples sesiones en todos los clientes?',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar bloqueo de múltiples sesiones en todos los clientes?',
      ACTIVATE_USE_IOS_IN_ALL_CLIENTS_KEY:
        '¿Activar uso de dispositivos iOS en todos los clientes?',
      INACTIVATE_USE_IOS_IN_ALL_CLIENTS_KEY:
        '¿Desactivar uso de dispositivos iOS en todos los clientes?',
      CONFIRM_ACTIVATE_USE_IOS_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar uso de dispositivos iOS en estos clientes?',
      CONFIRM_INACTIVATE_USE_IOS_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar uso de dispositivos iOS en estos clientes?',
      CONFIRM_ACTIVATE_USE_IOS_KEY:
        'Confirmar activación de uso de dispositivos iOS',
      CONFIRM_INACTIVATE_USE_IOS_KEY:
        'Confirmar desactivación de uso de dispositivos iOS',
      CONFIRM_ACTIVATE_USE_IOS_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar uso de dispositivos iOS en todos los clientes?',
      CONFIRM_INACTIVATE_USE_IOS_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar uso de dispositivos iOS en todos los clientes?',
      ACTIVATE_MFA_IN_ALL_CLIENTS_KEY:
        '¿Activar uso de MFA en todos los clientes?',
      INACTIVATE_MFA_IN_ALL_CLIENTS_KEY:
        '¿Desactivar uso de MFA en todos los clientes?',
      CONFIRM_ACTIVATE_MFA_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar uso de MFA en estos clientes?',
      CONFIRM_INACTIVATE_MFA_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar uso de MFA en estos clientes?',
      CONFIRM_ACTIVATE_MFA_KEY: 'Confirmar activación de uso de MFA',
      CONFIRM_INACTIVATE_MFA_KEY: 'Confirmar desactivación de uso de MFA',
      CONFIRM_ACTIVATE_MFA_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar uso de MFA en todos los clientes?',
      CONFIRM_INACTIVATE_MFA_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar uso de MFA en todos los clientes?',
      ACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_KEY:
        '¿Activar uso de tipo de conexión en todos los clientes?',
      INACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_KEY:
        '¿Desactivar uso de tipo de conexión en todos los clientes?',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_IN_CLIENTS_KEY:
        '¿Seguro que quieres configurar el uso de tipo de conexión en estos clientes?',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_IN_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar uso de tipo de conexión en estos clientes?',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_KEY:
        'Confirmar la configuración del uso del tipo de conexión',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_KEY:
        'Confirmar desactivación de uso de tipo de conexión',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas activar uso de tipo de conexión en todos los clientes?',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_CLIENTS_KEY:
        '¿Estás seguro de que deseas desactivar uso de tipo de conexión en todos los clientes?',
      MIGRATE_CLIENTS_BETWEEN_ENVIRONMENTS_KEY:
        'Migrar clientes entre entornos',
      CONFIRM_CHANGE_EMAIL_ADMIN_KEY:
        'Confirmar cambio de email del administrador',
      CONFIRM_CHANGE_EMAIL_ADMIN_IN_CLIENTS_KEY:
        'Confirmar cambio de email del administrador en estos clientes?',
      CONFIRM_CHANGE_EMAIL_ADMIN_IN_ALL_CLIENTS_KEY:
        'Confirmar cambio de email del administrador en todos los clientes?',
      CONFIG_EMAIL_ADMIN_IN_ALL_CLIENTS_KEY:
        '¿Configurar este email del administrador para todos los clientes?',
      EMAILS_TO_ADD_KEY: 'Emails para añadir:',
      EMAILS_TO_REPLACE_KEY: 'Emails para reemplazar:',
      ENVIRONMENTS_TOTAL_LICENSES_KEY: 'Total de licencias del entorno',
      CONFIG_LIMIT_LICENSES_PASSWORD_AND_REASON_KEY:
        'Para activar la edición de la cantidad de licencias en la tabla, completa los campos a continuación con el motivo de la acción y tu contraseña de operador:',
      SELECT_CLIENTS_TO_MIGRATE_KEY: 'Selecciona los clientes para migrar:',
      UPDATE_KEY: 'Actualizar datos',
      ENVIRONMENT_DEFAULT_KEY: 'Default del entorno',
      LICENSES_QUANTITY_KEY: 'Número de licencias',
    },
    COMPLETION_DATE_KEY: 'Dados da conclusão',
    MAKE_ENVIRONMENT_PRODUCTIVE_KEY: 'Hacer productivo',
    CONFIRM_MAKE_ENVIRONMENT_PRODUCTIVE_KEY:
      '¿Está seguro de que desea establecer el estado de este entorno en «Producción»?',
    COMPLETION_DATE_STATUS_KEY: 'Fecha de finalización del estado',
    PENDING_COMPLETION_DATE_KEY:
      'Este entorno tiene pendiente una solicitud de ampliación de fecha de finalización para el día: {{completion_date_proposed}}. Cuando se acepte, esta fecha será la nueva fecha de finalización para este estado',
    PENDING_COMPLETION_DATE_NO_DATE_KEY:
      'Este entorno tiene una solicitud de ampliación de fecha de finalización pendiente. Cuando se acepte, la fecha solicitada sustituirá a la fecha actual',
    EXTEND_REQUEST_KEY: 'Solicitud de ampliación',
    EXTEND_REASON_KEY: 'Motivo de la ampliación',
    VALIDATE_PENDENCIES_KEY: 'Evaluar asuntos pendientes',
    COMPLETION_DATE_SOLICITATION_KEY:
      'Solicitud de nueva fecha de finalización',
    APPROVE_KEY: 'Aprobar',
    REQUEST_EXTEND_KEY: 'Solicitar prórroga',
    EXTEND_COMPLETION_DATE_KEY: 'Ampliar fecha de fin de estado',
    SELECT_NEW_COMPLETION_DATE_KEY: 'Seleccionar nueva fecha final',
    APPROVE_EXTEND_DATE_KEY: 'Aprobar fecha de ampliación',
    NEW_COMPLETION_DATE_WILL_BE_KEY:
      'La nueva fecha final para este estado será',
    EXTEND_REQUESTED_BY_KEY: 'Esta solicitud fue realizada por',
    DAYS_TO_EXPIRE_KEY: 'Días para caducar',
    ENVIRONMENTS_STATUS_TO_EXPIRE_KEY:
      'Entornos con estado a caducar en los próximos 7 días',
    ENVIRONMENTS_STATUS_TO_EXPIRE_SHORT_KEY: 'Entornos con estado a caducar',
    CAN_EDIT_COMPANY_ALIAS: 'Editar nombre de cuenta',
    CONFIRM_COMPANY_ALIAS_KEY:
      '¿Está seguro de que desea establecer el nombre para mostrar {{alias}} para esta empresa?',
    CONFIRM_COMPANY_ALIAS_TITLE_KEY:
      'Guardar nombre para mostrar de la empresa',
    ALIAS_CREATED_SUCCESSFULLY_KEY: 'Nombre cambiado con éxito',
    ALIAS_NAME_KEY: 'Nombre para mostrar',
    CREATE_ALIAS_NAME_KEY: 'Crear nombre para mostrar',
    LEGAL_NAME_KEY: 'Nombre comercial',
    COMPANY_NAME_CRM_KEY: 'Nombre de la empresa (CRM)',
    APPROVED_REQUEST_KEY: '¡Solicitud aprobada!',
    CAN_ACCEPT_PENDING_EXTENSION: 'Aprobar ampliación de fecha final',
    CLICK_TO_FILTER_ENV_STATUS_KEY:
      'Haz clic para filtrar los entornos con este estado en la tabla',
    CLICK_TO_FILTER_PROVIDER_KEY:
      'Haz clic para filtrar los entornos con este proveedor en la tabla',
    CLICK_TO_FILTER_ENV_DNS_KEY:
      'Haz clic para filtrar los entornos con este estado de DNS en la tabla',
    CLICK_TO_FILTER_ENV_CONNECTION_TYPE_KEY:
      'Haga clic para filtrar entornos con este tipo de conexión en la tabla',
    CLICK_TO_FILTER_ENV_BEHAVIOR_KEY:
      'Haz clic para filtrar los entornos con este comportamiento en la tabla',
    CLICK_TO_FILTER_ENV_VIRTUALIZER_KEY:
      'Haga clic para filtrar los entornos con este virtualizador en la tabla',
    CLICK_TO_FILTER_ENV_PRODUCT_KEY:
      'Haz clic para filtrar los entornos de este producto en la tabla',
    CLICK_TO_FILTER_ENV_ZERO_TRUST_KEY:
      'Haga clic para filtrar los entornos de este estado de Cero Confianza en la tabla',
    CLICK_TO_FILTER_ENV_PRODUCT_TYPE_KEY:
      'Haga clic para filtrar los entornos con este tipo de producto en la tabla',
    CLICK_TO_FILTER_ENV_REGION_KEY:
      'Haz clic para filtrar los entornos de esta regione en la tabla',
    ENV_STATUS_GRAPHS_KEY: 'Gráficos de estado del entorno',
    ENV_REGION_GRAPHS_KEY: 'Gráficos de regiones del entorno',
    ENV_MAINTENANCE_GRAPHS_KEY:
      'Gráficos de mantenimiento y visualización de avisos de entornos',
    ENV_PRODUCT_GRAPHS_KEY: 'Gráficos de producto del entorno',
    ENV_ZERO_TRUST_GRAPHS_KEY:
      'Gráficos de uso de confianza cero para entornos',
    ENV_BEHAVIOR_GRAPHS_KEY: 'Gráficos de comportamiento del entorno',
    ENV_PRODUCT_TYPE_GRAPHS_KEY: 'Gráficos de tipo de producto de entorno',
    ENV_VIRTUALIZER_GRAPHS_KEY: 'Gráficos de virtualizador de entorno',
    ENV_PROVIDER_GRAPHS_KEY: 'Gráficos de proveedor de entorno',
    ENV_DNS_GRAPHS_KEY: 'Gráficos de DNS de entorno',
    ENV_CONNECTION_TYPE_GRAPHS_KEY: 'Gráficos de tipo de conexión de entorno',
    POLAR_GRAPH_KEY: 'Gráfico Polar',
    DONUT_GRAPH_KEY: 'Gráfico de Donuts',
    BAR_GRAPH_KEY: 'Gráfico de Barras',
    CURRENT_TIMEZONE_TIME_KEY: 'Hora actual de la zona horaria seleccionada',
    AVAILABLE_LICENSES_REACHED_KEY:
      'Se ha superado el número de licencias disponibles',
    GET_ENVIRONMENT_MAINTENANCE: 'Ver detalles del mantenimiento del entorno',
    EDIT_ENVIRONMENT_MAINTENANCE: 'Configurar el mantenimiento del entorno',
    ENVIRONMENT_MAINTENANCE_HISTORY:
      'Ver historial de mantenimiento del entorno',
    GET_CLIENT_MAINTENANCE: 'Ver detalles de mantenimiento del cliente',
    EDIT_CLIENT_MAINTENANCE: 'Configurar el mantenimiento del cliente',
    CLIENT_MAINTENANCE_HISTORY: 'Ver historial de mantenimiento del cliente',
    REQUEST_NEW_COMPLETION_DATE_KEY:
      'Para solicitar una nueva fecha de finalización, seleccione la fecha que desee en el siguiente campo e indique el motivo de la solicitud.',
    CURRENT_COMPLETION_DATE_KEY: 'Fecha de finalización actual',
    NEW_COMPLETION_DATE_KEY: 'Nueva fecha final',
    CONFIRM_REQUEST_KEY: 'Confirmar solicitud',
    COMPLETION_DATE_PROPOSE_RULE_KEY:
      'La nueva fecha de finalización no puede ser inferior o igual a la fecha actual',
    COMPLETION_DATE_EXTEND_REQUESTED_SUCCESSFULLY_KEY:
      '¡Nueva fecha de fin solicitada con éxito!',
    REFUSE_KEY: 'Desecho',
    REFUSE_EXTEND_DATE_KEY: 'Fecha de prórroga de la recogida',
    REFUSE_EXTEND_DATE_DETAILS_KEY:
      'Se rechazará la fecha de finalización solicitada ({{completion_date_proposed}}) y se mantendrá la fecha actual ({{completion_date}}).',
    MAINTENANCE_SET_SUCCESSFULLY_KEY: 'Mantenimiento configurado con éxito',
    CONFIRM_MAINTENANCE_CONFIG_KEY:
      'Para confirmar la configuración de mantenimiento, introduzca el motivo de la acción en el campo siguiente',
    MAINTENANCE_CONFIG_KEY: 'Configuración de mantenimiento',
    COMPLETION_DATE_EXPIRED_KEY: 'Fecha de finalización expirada',
    USE_LIMIT_DAILY: 'Utilizar límite de publicación diario',
    MAINTENANCE_HISTORY_KEY: 'Historial de mantenimiento',
    DETAILS_MAINTENANCE_HISTORY_KEY: 'Detalles del historial de mantenimiento',
    MAINTENANCE_UPDATED_AT_KEY:
      "'Actualizado el' d 'de' MMMM 'de' aaaa 'a' HH:mm",
    MAINTENANCE_CHANGED_BY_KEY: 'Por {{first_name}} {{last_name}} ({{email}})',
    MAINTENANCE_REASON_KEY: 'Motivo: {{motivo}}',
    UPDATED_BY_SCHEDULE_MAINTENANCE_KEY:
      'Cambio automático realizado por mantenimiento programado',
    MODIFIED_BY_CUSTOMER_PORTAL_KEY:
      'Cambio realizado a través del Portal del Cliente',
    MODIFIED_BY_API_V2_KEY:
      'Cambio realizado a través de la API de la Plataforma Autosky',
    MODIFIED_BY_SKYINONE_KEY: 'Cambio realizado a través de Admin V1',
    NOT_ENOUGH_MAINTENANCE_HISTORY_DATA_KEY:
      'No hay suficientes datos de historial de mantenimiento',
    FIELD_KEY: 'Campo',
    OLD_VALUE_KEY: 'Valor anterior',
    NEW_VALUE_KEY: 'Nuevo valor',
    PUBLICATION_WITH_BLOCKING_NOT_ENABLED:
      'La publicación mientras se mantiene la sesión iniciada no está permitida en este entorno',
    PUBLICATION_WITH_BLOCKING_MONTHLY_LIMIT_EXCEEDED:
      '¡Límite de publicación mensual alcanzado!',
    PUBLICATION_WITH_BLOCKING_DAILY_LIMIT_EXCEEDED:
      '¡Límite de publicaciones diarias alcanzado!',
    EDIT_ENV_AUTO_BLOCK_INSTANCES_MAINTENANCE:
      'Configurar el bloqueo diario de instancias',
    LIST_ENV_AUTO_BLOCK_INSTANCES_DETAILS:
      'Ver detalles del bloqueo diario de instancias',
    AUTO_BLOCK_INSTANCES_KEY: 'Bloqueo diario de instancias',
    AUTO_BLOCK_INSTANCES_TIME_KEY: 'Tiempo de ejecución del bloqueo',
    AVAILABLE_CLIENTS_LIST_KEY: 'Lista de clientes disponibles',
    TEMPLATE_KEY: 'Template',
    CANNOT_CHANGE_MODE_FROM_MICRO_WITH_APPLICATION_SERVER_ATTACHED:
      'No se puede cambiar el modo de un entorno Micro con servidor de aplicaciones conectado',
    DUPLICATED_ROLE_NAME: 'El nombre del grupo de permisos ya existe',
    REGIONS_KEY: 'Regiones',
    MAINTENANCE_AND_WARNING_KEY: 'Mantenimiento y Advertencia',
    ZERO_TRUST_ENABLED_KEY: 'Zero Trust activa',
    ZERO_TRUST_FAILED_KEY: 'Zero Trust fallida',
    ZERO_TRUST_GRACE_PERIOD_KEY:
      'Zero Trust en espera de inicialización. Este proceso puede tardar hasta 5 minutos',
    ZERO_TRUST_STARTING_KEY: 'Zero Trust inicializando',
    ZERO_TRUST_WRONG_VERSION_KEY: 'Estado del Zero Trust no disponible',
    CONFIG_ENV_DASHBOARD_MODAL_KEY:
      'Configuración del cuadro de mandos del entorno',
    CONFIG_DASHBOARD_KEY: 'Configurar cuadro de mandos',
    EXPAND_DASHBOARD_KEY: 'Expandir cuadro de mandos',
    HIDE_DASHBOARD_KEY: 'Ocultar panel',
    HIDE_SESSIONS_GRAPH_KEY: 'Ocultar gráfico de sesión',
    EXPAND_SESSIONS_GRAPH_KEY: 'Expandir gráfico de sesión',
    ENV_DASHBOARD_KEY: 'Cuadro de mandos del entorno',
    CLEAR_SELECTION_KEY: 'Borrar seleccionados',
    EXPAND_CARDS_KEY: 'Expandir tarjetas',
    MINIMIZE_CARDS_KEY: 'Minimizar tarjetas',
    SELECT_CARDS_TITLE_CARDS_KEY:
      'Elegir hasta 3 tarjetas que se mostrarán en el dashboard',
    DONT_USE_ENV_DASHBOARD_KEY: 'No utilizar cuadros de mando de entorno',
    SUCCESSFULLY_CONFIG_DASHBOARD_KEY: 'Cuadro de mandos configurado con éxito',
    ZERO_TRUST_DISABLED_KEY: 'Zero Trust desactivado',
    NO_DASHBOARD_KEY: 'Sin dashboard',
    FILTERED_TOTAL_KEY: 'Total con filtros',
    MAINTENANCE_STATUS_KEY: 'Estado de mantenimiento',
    RESTORE_DEFAULT_GRAPHS_KEY: 'Restaurar gráficos por defecto',
    WANT_DEACTIVATE_ZERO_TRUST_KEY: '¿Desea desactivar Zero Trust?',
    WANT_ACTIVATE_ZERO_TRUST_KEY: '¿Desea activar Zero Trust?',
    ACTIVATE_ZERO_TRUST_DESCRIPTION_KEY:
      'Al habilitar Zero Trust, los usuarios conectados a la instancia pueden ser desconectados.',
    DEACTIVATE_ZERO_TRUST_DESCRIPTION_KEY:
      'La actualización de Zero Trust puede tardar hasta 5 minutos en surtir efecto. Durante este período, los usuarios que cambien de dispositivo o accedan a la instancia pueden ser bloqueados. ¿Desea continuar?',
    REMOVED_IPS_ZERO_TRUST_EXPLANATION_KEY:
      'Las IPs eliminadas de la lista de permitidos solo se eliminarán efectivamente después de un período de 30 días.',
    ALLOWED_SKYONE_IPS_ZERO_TRUST_KEY:
      'Las IPs de Skyone están permitidas por defecto.',
    CONFIG_CLIENTS_DASHBOARD_MODAL_KEY:
      'Configuración del cuadro de mandos del cliente',
    CLIENTS_DASHBOARD_KEY: 'Cuadro de mandos del cliente',
    CLICK_TO_FILTER_CLIENTS_STATUS_KEY:
      'Haz clic para filtrar los clientes con este estado en la tabla',
    CLICK_TO_FILTER_CLIENTS_VIRTUALIZER_KEY:
      'Haga clic para filtrar los clientes con este virtualizador en la tabla',
    CLICK_TO_FILTER_CLIENTS_CONNECTION_TYPE_KEY:
      'Haga clic para filtrar los clientes con este tipo de conexión en la tabla',
    CLIENTS_BLOCK_MULTIPLE_SESSION_GRAPHS_KEY:
      'Gráficos de clientes que bloquean múltiples sesiones',
    CLIENTS_CONNECTION_TYPE_GRAPHS_KEY:
      'Gráficos de tipo de conexión de clientes',
    CLIENTS_MFA_GRAPHS_KEY: 'Gráficos de MFA de clientes',
    CLIENTS_USE_PROFILE_GRAPHS_KEY: 'Gráficos de perfiles remotos de clientes',
    CLIENTS_VIRTUALIZER_GRAPHS_KEY: 'Gráficos del virtualizador del cliente',
    DONT_USE_CLIENTS_DASHBOARD_KEY:
      'No utilizar el cuadro de mandos de clientes',
    MANAGE_ENV_LICENSE_LIMIT_KEY:
      'Permitir la gestión de licencias de cliente por entorno',
    MANAGE_CHANGE_PASSWORD_KEY: 'Permitir cambio de contraseña para AD externo',
    LICENSE_MANAGEMENT_KEY: 'Gestión de licencias',
    PASSWORD_MANAGEMENT_KEY: 'Gestión de contraseñas',
    ACTIVE_DUO_DESCRIPTION_KEY: 'DUO authentication',
    DUO_CLIENT_ID: 'Client ID',
    DUO_CLIENT_SECRET: 'Client Secret',
    HOST_KEY: 'Host',
    BYPASS_IF_UNAVAILABLE_KEY: 'Allow login in case of unavailability',
    BYPASS_IF_UNAVAILABLE_DESCRIPTION_KEY:
      'By enabling this option, if the DUO service becomes unavailable, user login will be performed normally',
    OBSERVATIONS_KEY: 'Observaciones',
    AUTOSKY_ROUTINE: 'Rutina de Autosky',
    FILTERS_APPLIED_KEY: 'Filtros aplicados',
    CONFIG_PARTNERS_DASHBOARD_MODAL_KEY:
      'Configuración del panel de control de la cuenta',
    PARTNERS_DASHBOARD_KEY: 'Cuadro de mandos de la cuenta',
    DONT_USE_PARTNERS_DASHBOARD_KEY:
      'No utilizar el panel de control de la cuenta',
    CLICK_TO_FILTER_PARTNERS_STATUS_KEY:
      'Haga clic para filtrar las cuentas con este estado en la tabla',
    CLICK_TO_FILTER_PARTNERS_CONFIG_KEY:
      'Haga clic para filtrar las cuentas con esta configuración en la tabla',
    CLICK_TO_FILTER_PARTNERS_PROVIDER_KEY:
      'Haga clic para filtrar las cuentas con este proveedor en la tabla',
    CLICK_TO_FILTER_PARTNERS_LDAP_KEY:
      'Haga clic para filtrar las cuentas con este LDAP en la tabla',
    PARTNERS_LDAP_GRAPHS_KEY: 'Tablas de tipo LDAP de las cuentas',
    PARTNERS_SSO_GRAPHS_KEY: 'Gráficos de configuración SSO de las cuentas',
    PARTNERS_PROVIDER_TYPE_GRAPHS_KEY:
      'Gráficos del tipo de proveedor de las cuentas',
    PARTNERS_NEW_FRONT_GRAPHS_KEY: 'Gráficos de uso del Portal 2.0',
    CONFIG_USERS_DASHBOARD_MODAL_KEY:
      'Configuración del panel de control de usuario',
    USERS_DASHBOARD_KEY: 'Cuadro de mandos de usuario',
    DONT_USE_USERS_DASHBOARD_KEY: 'No utilizar el panel de control de usuario',
    CLICK_TO_FILTER_USERS_STATUS_KEY:
      'Haga clic para filtrar los usuarios con este estado en la tabla',
    CLICK_TO_FILTER_USERS_CONFIG_KEY:
      'Haz clic para filtrar usuarios con esta configuración en la tabla',
    USERS_MFA_GRAPHS_KEY: 'Gráficos de configuración MFA de los usuarios',
    USERS_SALT_GRAPHS_KEY: 'Gráficos de configuración Salt de los usuarios',
    USERS_ACTIVE_GRAPHS_KEY: 'Gráficos de estado de los usuarios',
    CHOOSE_DEFAULT_IMAGE_KEY: 'Elegir imagen de banner por defecto',
    USE_NEW_PORTAL_KEY: 'Utiliza Portal 2.0',
    CLIENTS_TOTAL_KEY: 'Total de clientes',
    USERS_TOTAL_KEY: 'Total de usuarios',
    PARTNERS_TOTAL_KEY: 'Total de socios',
    TEST_ZERO_TRUST_KEY: 'Validar Zero Trust',
    VALIDATE_INSTANCE_ZERO_TRUST: 'Validar Zero Trust por instancia',
    ZERO_TRUST_CONFIG_AT_ENV_KEY: 'Entorno de Zero Trust habilitado',
    ZERO_TRUST_CONFIG_WHITELIST_CLEANUP_INTERVAL_KEY:
      'Intervalo de limpieza de la whitelist (en días)',
    INTEGRATION_TEST_KEY: 'Prueba de liberación de IP en la instancia',
    PROVIDER_RULE_KEY:
      'Confirmación de la regla de seguridad para Zero Trust en el proveedor',
    PLATFORM_VERSION_KEY: 'Confirmación de la versión de la plataforma',
    MINIMUM_VERSION_KEY: 'Versión mínima recomendada',
    CURRENT_VERSION_KEY: 'Versión actual',
    VALID_KEY: 'Válido',
    INVALID_KEY: 'No válida',
    INCONSISTENT_ZERO_TRUST_KEY: 'Zero Trust con inconsistencia',
    VALID_ZERO_TRUST_KEY: 'Zero Trust válida',
    INVALID_ZERO_TRUST_KEY: 'Zero Trust inválida',
    INFO_NOT_AVAILABLE_KEY: 'Información no disponible',
    VALIDATE_AGAIN_KEY: 'Validar de nuevo',
    CLICK_ON_INSTANCE_KEY: 'Haga clic en una instancia para ver más detalles',
    PLATFORM_VERSION_NUMBER_KEY: 'Platform versión',
    EXPAND_ACTIONS_KEY: 'Expandir acciones',
    CLICK_HERE_TO_DETAILS_KEY: 'Haga clic para ver más detalles',
    REQUEST_ID_KEY: 'ID de solicitud',
    RECOVERY_ID_KEY: 'ID de recuperación',
    CAN_EXPORT_PARTNER_SUMMARY_LIST: 'Exportar lista de cuentas en CSV o PDF',
    CAN_EXPORT_ENVIRONMENT_SUMMARY_LIST:
      'Exportar listado de entornos en CSV o PDF',
    CAN_EXPORT_CLIENT_SUMMARY_LIST: 'Exportar listado de clientes en CSV o PDF',
    CAN_EXPORT_USER_SUMMARY_LIST: 'Exportar listado de usuarios en CSV o PDF',
    PUBLISHING_STARTED_SUCCESSFULLY_KEY: '¡Publicación iniciada con éxito!',
    OPTIMIZED_KEY: 'Optimizado',
    PUBLICATIONS_PAGE_TITLE_KEY:
      'Publicación y programación de nuevas versiones',
    SELECT_PUBLICATION_MODE_KEY:
      'Seleccione a continuación el modo de publicación deseado',
    EMAILS_TO_NOTIFY_KEY: 'Correos electrónicos a notificar',
    BLOCK_INSTANCES_KEY: 'Bloquear instancias',
    BLOCK_USERS_KEY: 'Finalizar sesiones',
    STOP_SERVER_KEY: 'Detener servidor de preparación al crear imagen',
    NEW_KEY: 'NUEVO',
    HOW_TO_OPTIMIZE_KEY: '¿Cómo funciona la publicación optimizada?',
    RULE_TO_PUBLISH_KEY:
      'Para realizar una nueva publicación, debe haber un servidor de puesta en escena',
    OPTIMIZED_PUBLICATION_DEFINITION_KEY:
      'El modo de publicación optimizada unifica los modos de publicación existentes en un único enfoque. Las publicaciones estándar, manteniendo a los usuarios conectados o solicitando a los usuarios que se vuelvan a conectar, se pueden realizar en modo optimizado de la siguiente manera',
    HOW_TO_OPTIMIZE_DEFAULT_KEY:
      'El modo de publicación por defecto equivale a no marcar las opciones de bloquear instancias o finalizar sesiones.',
    HOW_TO_OPTIMIZE_KEEP_KEY:
      'El modo de publicación que mantiene a los usuarios conectados equivale a marcar la opción de bloquear instancias pero no la de finalizar sesiones.',
    HOW_TO_OPTIMIZE_RECONNECTION_KEY:
      'El modo de publicación que pide a los usuarios que se vuelvan a conectar equivale a marcar las opciones de bloquear instancias y finalizar sesiones. No es posible finalizar sesiones sin bloquear las instancias',
    HOW_TO_OPTIMIZE_STOP_SERVER_KEY:
      'Esta opción permite definir si, al crear la imagen, es necesario detener el servidor de staging. Si no la marcas, el servidor seguirá estando disponible durante la creación',
    SEE_EXAMPLE_KEY: 'Ver ejemplo',
    OPTIMIZED_PUBLICATION_KEY: 'Publicación optimizada',
    OPTIMISED_PUBLICATION_CONFIRM_KEY:
      '¿Desea confirmar la publicación de una nueva imagen en modo optimizado?',
    DEFAULT_PUBLICATION_KEY: 'Publicación por defecto',
    DEFAULT_PUBLICATION_CONFIRM_KEY:
      '¿Desea confirmar la publicación de una nueva imagen en modo predeterminado?',
    KEEP_PUBLICATION_KEY: 'Publicación mientras los usuarios están conectados',
    KEEP_PUBLICATION_CONFIRM_KEY:
      '¿Desea confirmar la publicación de una nueva imagen en modo mantener usuarios conectados?',
    RECONNECTION_PUBLICATION_KEY:
      'Publicación solicitando reconexión de usuarios',
    RECONNECTION_PUBLICATION_CONFIRM_KEY:
      '¿Desea confirmar la publicación de una nueva imagen en el modo solicitando reconexión de usuarios?',
    SCHEDULE_KEY: 'Programación',
    UNAVAILABLE_VERSION_KEY: 'Versión no disponible',
    SEE_GENERATED_MODELS_KEY: 'Ver plantillas generadas',
    LOGS_PUBLICATION_SUBSCRIPTION_KEY:
      'Registros y detalles de las publicaciones realizadas',
    SCHEDULES_KEY: 'Reservas',
    SCHEDULES_LISTING_KEY: 'Lista de publicaciones programadas',
    PUBLISH_NEW_IMAGE_OPTIMIZED_KEY: 'Publicar nueva versión (Optimizada)',
    HISTORY_LOGS_PUBLISH_OPTIMIZED_KEY:
      'Historial y seguimiento de publicaciones',
    HISTORY_LOGS_PUBLISH_OPTMISED_DESCRIPTION_KEY:
      'Publicaciones realizadas y en curso',
    AVERAGE_STEP_TIME_KEY: 'Tiempo medio de cada etapa',
    AVERAGE_TOTAL_TIME_KEY: 'Promedio del proceso',
    STAGE_FAILED_KEY: 'Fallida',
    IN_PROGRESS_KEY: 'En curso...',
    PUBLICATION_DETAILS_KEY: 'Detalles de la publicación',
    SUCCESSFUL_PUBLICATION_KEY: '¡Publicación finalizada con éxito!',
    FAILED_PUBLICATION_KEY: 'Publicación fallida',
    WARNING_PUBLICATION_KEY: 'Inconsistencias al publicar',
    MADE_BY_KEY: 'Realizado por',
    START_END_KEY: 'Inicio/Fin',
    MODEL_VERSION_KEY: 'Versión del modelo',
    DURATION_KEY: 'Duración',
    PUBLICATION_IN_PROGRESS_KEY:
      'Publicación en curso. Espere a que finalice antes de publicar otra versión.',
    PUBLISH_SUCCESS_KEY: 'Éxito',
    PUBLISH_FAILED_KEY: 'Fallo',
    PUBLISH_TIMEOUT_KEY: 'Tiempo de espera',
    PUBLISH_WARNING_KEY: 'Inconsistencia',
    PUBLISH_RUNNING_KEY: 'En curso',
    PUBLISH_SKIPPED_KEY: 'No aplicable',
    PUBLICATION_STEP_DETAILS_KEY: 'Detalles del paso',
    WAIT_PROGRESS_PUBLISH_KEY:
      'Etapa en curso. Espere a la finalización para ver más detalles',
    GENERATED_MODEL_KEY: 'Vérsion del modelo',
    UNAVAILABLE_MODEL_KEY: 'Modelo no disponible',
    BLOQUEAR_INSTANCIAS_TOOLTIP_KEY:
      'Tras completar la creación de las plantillas, se iniciarán las instancias con las versiones actualizadas y se bloquearán las instancias que utilicen las versiones anteriores.',
    BLOCK_USERS_TOOLTIP_KEY:
      'Después de arrancar las instancias con las versiones actualizadas, envía un mensaje de desconexión a los usuarios conectados a las instancias que utilizan las versiones anteriores.',
    PUBLISH_IN_BULK_SUCCESS_KEY:
      "¡Publicación iniciada con éxito! Puede ver el progreso y el historial de publicación de cada servidor haciendo clic en 'Historial y seguimiento de publicaciones' en las acciones del servidor.",
    NOT_ENOUGH_DATA_PUBLISH_LOGS_KEY:
      'Datos insuficientes. Realice una publicación optimizada para obtener más detalles',
    MULTIPLE_EXPIRED_SESSIONS: 'Múltiples sesiones expiradas',
    USER_ALREADY_HAS_EXTERNAL_AD: 'El usuario ya tiene una cuenta AD externa',
    LIST_WEB_APPLICATIONS: 'Listar aplicaciones web',
    CREATE_NEW_WEB_APPLICATION: 'Añadir aplicaciones web',
    EDIT_WEB_APPLICATION: 'Editar aplicaciones web',
    DELETE_WEB_APPLICATION: 'Eliminar aplicaciones web',
    CAN_VIEW_ALL_RESOURCES: 'Lista general de recursos',
    CAN_BLOCK_ACTIONS_PREPARATION_SERVER:
      'Bloquear acciones de preparación del servidor',
    CAN_UNBLOCK_ACTIONS_PREPARATION_SERVER:
      'Desbloquear acciones del servidor de preparación',
    CAN_BLOCK_ACTIONS_PARTNER_SERVERS:
      'Bloquear acciones de preparación del servidor en la cuenta',
    CAN_UNBLOCK_ACTIONS_PARTNER_SERVERS:
      'Desbloquear acciones del servidor de preparación en la cuenta',
    BLOCK_SERVER_ACTIONS_SUCCESSFULLY_KEY:
      '¡Acciones del servidor bloqueadas con éxito!',
    BLOCK_ACTIONS_SERVER_KEY: 'Bloquear acciones del servidor',
    BLOCKING_TIME_SERVER_KEY: 'Tiempo de bloqueo de las acciones del servidor',
    BLOCKING_REASON_KEY: 'Motivo de bloqueo',
    BLOCKING_ACTIONS_KEY: 'Acciones de bloqueo',
    BLOCKING_SERVER_ACTIONS_DESCRIPTION_KEY:
      'Bloquear acciones del servidor impide a los usuarios realizar las siguientes operaciones: enlazar, desenlazar, conectar, detener, publicar nuevas imágenes y conectarse, durante el periodo seleccionado a continuación.',
    BLOCKED_PUBLICATIONS_DESCRIPTION_KEY:
      'La publicación de novedades está temporalmente bloqueada debido al bloqueo de acciones en el servidor realizado por {{name}} en {{time}}.',
    BLOCKED_PUBLICATIONS_RELEASE_KEY:
      'La publicación estará disponible en {{unblockDate}} o si se desbloquean las acciones.',
    BLOCKED_ACTIONS_ALERT_DESCRIPTION_KEY:
      'Las acciones en el servidor están temporalmente bloqueadas debido al bloqueo de acciones en el servidor realizado por {{name}} en {{time}}.',
    BLOCKED_ACTIONS_RELEASE_KEY:
      'Las acciones estarán disponibles en {{unblockDate}} o si se desbloquean las acciones.',
    SERVER_MAINTENANCE_ACTIONS_RELEASE_KEY:
      'Este servidor está en mantenimiento hasta {{unblockDate}}. Durante este periodo no es posible realizar acciones en el servidor ni publicar nuevas imágenes.',
    UNBLOCK_ACTIONS_SERVER_KEY: 'Desbloquear acciones del servidor',
    UNBLOCKING_ACTIONS_KEY: 'Desbloquear acciones',
    UNBLOCKING_SERVER_ACTIONS_DESCRIPTION_KEY:
      '¿Desea desbloquear las acciones del servidor?',
    UNBLOCKING_SERVER_ACTIONS_RESPONSIBLE_KEY:
      'El bloqueo de acciones fue realizado por {{name}} en {{time}} y finalizará en {{unblockDate}}',
    UNBLOCK_SERVER_ACTIONS_SUCCESSFULLY_KEY:
      '¡Acciones del servidor desbloqueadas con éxito!',
    UNBLOCKING_REASON_KEY: 'Motivo del desbloqueo',
    BLOCK_ACTIONS_TOOLTIP_SERVER_KEY:
      'Acciones desbloqueadas. Haga clic para bloquear las acciones del servidor',
    UNBLOCK_ACTIONS_TOOLTIP_SERVER_KEY:
      'Acciones bloqueadas. Haga clic para desbloquear las acciones del servidor',
    BLOCKED_ACTIONS_PARTNER_KEY: 'Acciones bloqueadas',
    MODAL_ACTIONS_BLOCKED_KEY:
      'La acción no se ejecutará en servidores con acciones bloqueadas (indicadas por el icono del candado junto al botón de acciones). Para ejecutarla en estos servidores, desbloquéelos individualmente o utilice la opción de desbloqueo masivo en las acciones generales.',
    DISABLE_RECAPTCHA_TOGGLE_KEY:
      'Desactivar reCAPTCHA temporalmente en Portal 2.0',
    LAST_RECAPTCHA_INACTIVE_KEY: 'Inactivación realizada por: ',
    BY_AT_KEY: '{{name}} en {{date}}.',
    INACTIVATING_REASON_KEY: 'Motivo de desactivación',
    INACTIVATING_REASON_DETAIL_KEY: 'Motivo de desactivación: ',
    INACTIVATE_RECAPTCHA_KEY: 'Inactivación de reCAPTCHA',
    INACTIVATE_RECAPTCHA_DESCRIPTION_KEY:
      'reCAPTCHA se inactivará en las páginas "Olvide mi contraseña", "Registre su contraseña" y "Cambiar mi contraseña" durante 30 días a partir de la fecha de inactivación',
    EDIT_BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT:
      'Configurar la monitorización de bloques para instancias con múltiples sesiones expiradas',
    BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT_KEY:
      'Bloquear instancias con múltiples sesiones expiradas',
    BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT_ALERT_KEY:
      'El bloqueo de instancias no se realiza en entornos de los modos de comportamiento: MANUAL y MICRO.',
    BLOCKED_BY_MONITORING_KEY: 'Bloqueado por monitorización',
    STATUS_ZERO_TRUST_KEY: 'Estado de Zero Trust',
    SPENT_SECONDS_TO_OPERATIONAL_ALERT_KEY:
      'Tempo hasta operativo o hasta alerta',
    EXPIRED_SESSIONS_KEY: 'Sesiones caducadas',
    CONTINUE_KEY: 'Continuar',
    VERIFICATION_CODE_KEY: 'Código de verificación',
    HELP_VERIFICATION_CODE_ONE_KEY:
      "El código de seguridad enviado en su correo electrónico está diseñado para garantizar la seguridad de las acciones realizadas. Para confirmar la acción, debes introducir el código en el campo 'Código de verificación'. Si no lo has recibido, puedes intentar reenviarlo haciendo clic en la opción de reenvío situada debajo del campo del código, 60 segundos después de la última solicitud.",
    HELP_VERIFICATION_CODE_TWO_KEY:
      'Si no recibes el código, comprueba tu bandeja de correo no deseado o spam. Confirma también la dirección de correo electrónico registrada en tu cuenta haciendo clic en tu nombre en el menú de la parte superior derecha > Perfil > Campo de correo electrónico',
    MORE_INFO_KEY: 'Más información',
    WAIT_KEY: 'Espere...',
    VERIFICATION_CODE_RETRY_SECONDS_KEY:
      'Si no has recibido el código en tu correo electrónico, puedes volver a intentarlo en {{seconds}} segundos.',
    VERIFICATION_CODE_RETRY_SECOND_KEY:
      'Si no has recibido el código en tu correo electrónico, puedes volver a intentarlo en {{seconds}} segundos.',
    VERIFICATION_CODE_RETRY_KEY:
      'Si no ha recibido el código, puede volver a enviar el correo electrónico',
    VERIFICATION_CODE_DESCRIPTION_KEY:
      'Se ha enviado un código de verificación a tu correo electrónico. Por favor, introdúzcalo a continuación para confirmar la acción:',
    INVALID_RESTRICTED_ACTION_TOKEN: 'Código de verificación incorrecto',
    RELEASE_RECAPTCHA_KEY:
      'El reCAPTCHA se reactivará automáticamente en {{date}}.',
    REACTIVATION_KEY: 'Reactivación: ',
    LDAP_TEST_RESULT: {
      AUTHENTICATE_ADMIN: 'Autenticación del administrador',
      CREATE_GROUP: 'Creación de grupo',
      CREATE_USER: 'Creación de usuario',
      ACTIVATE_USER: 'Activación de usuario',
      RESET_USER_PASSWORD: 'Restablecimiento de contraseña del usuario',
      AUTHENTICATE_USER: 'Autenticación del usuario',
      CHANGE_USER_PASSWORD: 'Cambio de contraseña del usuario',
      REMOVE_USER_FROM_GROUP: 'Eliminación del usuario del grupo',
      DELETE_USER: 'Eliminación de usuario',
      DELETE_GROUP: 'Eliminación de grupo',
    },
    CONNECTED_SUCCESSFULLY_KEY: 'Prueba realizada con éxito',
    CONNECTION_FAILED_KEY: 'Prueba fallida',
    CUSTOM_APP_COLOR_DETAILS_KEY: 'Detalles de la aplicación web',
    CUSTOM_DETAILS_COLOR_DETAILS_KEY:
      'Detalles en la página de inicio de sesión',
    LIST_LICENSE_GROUPS: 'Listar grupos de licencias',
    CREATE_LICENSE_GROUP: 'Crear grupo de licencias',
    EDIT_LICENSE_GROUP: 'Editar grupo de licencias',
    DELETE_LICENSE_GROUP: 'Eliminar grupo de licencias',
    EDIT_LICENSE_GROUP_CLIENTS: 'Editar clientes del grupo de licencias',
    LICENSE_GROUP_KEY: 'Grupo de licencias',
    LICENSE_GROUP_SUBTITLE_KEY: 'Listado y gestión de grupos de licencias',
    CREATE_LICENSE_GROUP_KEY: 'Crear grupo de licencias',
    GROUP_CREATED_SUCCESSFULLY_KEY: 'Grupo creado con éxito',
    GROUP_DELETED_SUCCESSFULLY_KEY: 'Grupo eliminado correctamente',
    DELETE_LICENSE_GROUP_KEY: 'Eliminar grupo de licencias',
    DELETE_LICENSE_GROUP_CONFIRM_KEY:
      '¿Está seguro de que desea eliminar este grupo de licencias?',
    ADD_CLIENTS_TO_GROUP_KEY: 'Añadir clientes al grupo',
    ADD_CLIENTS_TO_GROUP_DESCRIPTION_KEY:
      'Seleccione los clientes que desea añadir a este grupo de licencias',
    LICENSE_LIMIT_NOT_AVAILABLE: 'Cantidad de licencias no disponible',
    ENVIRONMENT_NOT_ALLOW_PER_CLIENT_LICENSES:
      'Este entorno no permite licencias por cliente',
    CLIENTS_ADDED_SUCCESSFULLY_KEY: 'Clientes añadidos con éxito',
    CLIENTS_UPDATED_SUCCESSFULLY_KEY: 'Clientes editados con éxito',
    GROUP_DETAILS_KEY: 'Detalles del grupo',
    LICENSES_QUANTITY_KEY: 'Número de licencias',
    CLIENTS_QUANTITY_KEY: 'Número de clientes',
    EDIT_GROUP_INFO_KEY: 'Editar nombre y licencias',
    EDIT_CLIENTS_KEY: 'Editar clientes',
    GROUP_UPDATED_SUCCESSFULLY_KEY: 'Grupo editado con éxito',
    UPDATE_LICENSE_GROUP_KEY: 'Editar grupo de licencias',
    EDIT_CLIENTS_IN_GROUP_KEY: 'Editar clientes en el grupo',
    EDIT_CLIENTS_DESCRIPTION_KEY:
      'Seleccione los clientes que desea añadir al grupo, o deseleccione los que desea eliminar',
    ACCESS_GROUP_KEY: 'Grupo de acceso',
    LICENSE_LIMIT_GROUP_KEY: 'Número de licencias en el grupo',
    THIS_CLIENT_IS_IN_GROUP_KEY:
      'Este cliente forma parte del grupo de licencias',
    CLIENT_IN_GROUP_TOOLTIP_KEY:
      'Para configurar licencias por cliente, debe eliminar este cliente del grupo de licencias',
    ZERO_TRUST_CARD_INFO_TEXT_KEY:
      'Solo se contabilizan los entornos con conexión pública.',
    ZERO_TRUST_CONFIG_INFO_TEXT_KEY:
      'Solo los entornos con conexión pública son elegibles.',
    NOT_IDENTIFIED_KEY: 'No identificado',
    ENVIRONMENT_NOT_ELIGIBLE_FOR_TEST_KEY:
      'Entorno no elegible para esta prueba',
    AVAILABLE_LICENSES_ENVIRONMENT_KEY: 'Licencias disponibles en el entorno',
    AVAILABLE_LICENSES_GROUP_KEY: 'Licencias disponibles para este grupo',
    REMOVED_PERMANENTLY_KEY: 'Eliminado permanentemente',
    CONDITION_OPERATORS: {
      ICONTAINS_KEY: '~ (contiene)',
      ICONTAINS_NOT_KEY: '!~ (no contiene)',
      IS_KEY: '= (es igual)',
      IS_NOT_KEY: '!= (no es igual)',
    },
    FILTERS_KEY: 'Filtros',
    SEARCH_FILTERS_KEY: 'Buscar filtros',
    NO_OPTIONS_KEY: 'Sin opciones',
    CLIENT_ALREADY_IN_LICENSE_GROUP_KEY:
      'Ha seleccionado un cliente que ya está en un grupo de licencias. Al confirmar, el cliente seleccionado se eliminará del grupo anterior y se añadirá a este grupo',
    MALFORMED_X509_PUBLIC_CERTIFICATE: 'Certificado de IdP x509 no válido',
    TITLE_FONTS_LOGIN_KEY: 'Inicio de sesión de textos y fuentes',
    TITLE_FONTS_MFA_KEY: 'Textos y fuentes MFA',
    LOGIN_PAGE_TITLE_TEXT_PTBR_KEY:
      'Título de la página de inicio de sesión en portugués',
    LOGIN_PAGE_SUBTITLE_TEXT_PTBR_KEY:
      'Subtítulo de la página de inicio de sesión en portugués',
    MFA_PAGE_TITLE_TEXT_PTBR_KEY: 'Título de la página MFA en portugués',
    MFA_PAGE_SUBTITLE_TEXT_PTBR_KEY: 'Subtítulo de la página MFA en portugués',
    MFA_FONT_SIZE_KEY: 'Tamaño de fuente del título del AMF',
    DESCRIPTION_MFA_FONT_SIZE_KEY: 'Tamaño de fuente de la descripción del AMF',
    LOGIN_PAGE_TITLE_TEXT_EN_KEY:
      'Título de la página de inicio de sesión en inglés',
    LOGIN_PAGE_SUBTITLE_TEXT_EN_KEY:
      'Subtítulo de la página de inicio de sesión en inglés',
    MFA_PAGE_TITLE_TEXT_EN_KEY: 'Título de la página MFA en inglés',
    MFA_PAGE_SUBTITLE_TEXT_EN_KEY: 'Subtítulo de la página MFA en inglés',
    LOGIN_PAGE_TITLE_TEXT_ES_KEY: 'Título de la página de login en español',
    LOGIN_PAGE_SUBTITLE_TEXT_ES_KEY:
      'Subtítulo de la página de inicio de sesión en español',
    MFA_PAGE_TITLE_TEXT_ES_KEY: 'Título de la página MFA en español',
    MFA_PAGE_SUBTITLE_TEXT_ES_KEY: 'Subtítulo de la página del MFA en español',
    USER_NOT_SOFT_DELETED:
      'No es posible eliminar este usuario ya que está vinculado a otros clientes.',
    APPLICATION_SERVER_KEY: 'Servidor de aplicaciones',
    SEE_MORE_KEY: '+ Ver más',
    SEE_LESS_KEY: '- Ver menos',
    BENCHMARK_INSTANCES_KEY: 'Métricas de la instancia',
    BENCHMARK_INTERVAL_KEY: 'Intervalo entre métricas (en minutos):',
    BENCHMARK_DURATION_KEY: 'Duración de cada métrica (en segundos):',
    SECONDS_KEY: 'Segundos',
    BENCHMARK_DURATION_TOOLTIP_KEY:
      'Tiempo, en segundos, que la rutina de verificación utilizará para recopilar la información.',
    BENCHMARK_INTERVAL_TOOLTIP_KEY:
      'Intervalo, en minutos, que el sistema esperará para ejecutar la rutina de verificación de la capacidad de procesamiento de la instancia.',
    BENCHMARK_NULL_KEY: 'Estado de las métricas no disponible',
    MATRIX_KEY: 'Matriz:',
    LOW_PERFORMANCE_MATRIX_KEY: 'Hasta 7.000 - Rendimiento bajo',
    MODERATE_PERFORMANCE_MATRIX_KEY: 'De 7.001 a 11.000 - Rendimiento moderado',
    MODERATE_TO_HIGH_PERFORMANCE_MATRIX_KEY:
      'De 11.001 a 12. 500 - Rendimiento moderado/alto',
    HIGH_PERFORMANCE_MATRIX_KEY: '12.501 a 30.000 - Rendimiento alto',
    LOW_PERFORMANCE_KEY: 'Bajo',
    MODERATE_PERFORMANCE_KEY: 'Moderado',
    MODERATE_TO_HIGH_PERFORMANCE_KEY: 'Moderado/Alto',
    HIGH_PERFORMANCE_KEY: 'Alto',
    BENCHMARK_INSTANCE_KEY: 'Métrica de instancia',
    OPERATIONS_KEY: 'Operaciones',
    BENCHMARK_CONFIG_KEY: 'Métrica del análisis de rendimiento',
    INTERVAL_IN_MINUTES_KEY: 'Intervalo: {{interval}} minutos',
    PROCESS_TIME_KEY: 'Tiempo de procesamiento: {{seconds}} segundos',
    BENCHMARK_DATE_AT_KEY: 'Métrica realizada a las: {{date}}',
    PLATFORM_OLD_VERSION_KEY:
      'Versión de la plataforma no compatible para la recopilación de métricas (>= 4.1.1.6)',
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_KEY:
      'Aplicar optimizaciones automáticamente',
    HIGH_RISK_ENVIRONMENT_KEY: 'Entorno de alto riesgo o con particularidades',
    HIGH_RISK_ENVIRONMENT_ALERT_KEY:
      'Al activar esta opción, el entorno se clasificará como de alto riesgo, lo que impedirá la creación y aplicación automática de optimizaciones.',
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_DESCRIPTION_KEY:
      'Permite la aplicación automática de optimizaciones en función del uso que los usuarios hacen del entorno, centrándose en la optimización y la reducción de costes.',
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_ALERT_KEY:
      'Las optimizaciones de alto riesgo requieren confirmación manual y no se aplicarán automáticamente.',
    HIGH_RISK_ENVIRONMENT_DESCRIPTION_KEY:
      'Active esta opción para evitar que los asesores se apliquen automáticamente.',
    SUGGEST_APPLY_ADVISOR_AUTOMATICALLY_TITLE_KEY:
      'Activar la aplicación automática de optimizaciones',
    SUGGEST_APPLY_ADVISOR_AUTOMATICALLY_DESCRIPTION_KEY:
      '¿Desea activar la aplicación automática de optimizaciones de riesgo bajo y medio en este entorno?',
    ADVISORS_CONFIGURATIONS_KEY: 'Ajustes de optimización',
    RISK_KEY: 'Riesgo',
    LOW_IMPACT_KEY: 'Bajo',
    MEDIUM_IMPACT_KEY: 'Medio',
    HIGH_IMPACT_KEY: 'Alto',
    DYNAMIC_ADVISOR_WEEKDAY_START_KEY: 'Inicio de asesor semanal',
    DYNAMIC_ADVISOR_WEEKDAY_END_KEY: 'Fin de asesor semanal',
    MONTH_KEY: 'Mes',
    ANNUAL_KEY: 'Anual',
    AUTOSKY_SYSTEM_KEY: 'Sistema Autosky',
    SCALING_ADVISOR_REVERT_HISTORY_NOT_FOUND:
      'La optimización no tiene un historial almacenado que pueda revertirse',
    ADVISORS_HISTORY_KEY: 'Historial de optimización',
    ADVISORS_KEY: 'Optimizaciones',
    CHECK_PASSWORD_HISTORY_KEY: 'Validar historial de contraseñas',
    CHECK_PASSWORD_COMPLEXITY_KEY: 'Validar complejidad de contraseñas',
    SECURE_DEVICE_VALIDATION_KEY: 'Validación de dispositivos seguros',
    ENABLE_DEVICE_VALIDATION_KEY: 'Activar validación de dispositivo',
    DEVICE_VALIDATION_TOOLTIP_KEY:
      'Habilita la autenticación del dispositivo mediante Token de seguridad.',
    ADMIN_PIN_KEY: 'Token administrativo',
    COPY_PIN_KEY: 'Copiar Token',
    REGENERATE_PIN_KEY: 'Regenerar Token',
    GET_ADMINISTRATIVE_PIN: 'Obtener Token administrativo',
    RESET_ADMINISTRATIVE_PIN: 'Renegerar Token administrativo',
    DEVICE_VALIDATION_ENABLED_MESSAGE:
      'La validación de dispositivo seguro está activa en este entorno',
    DEVICE_VALIDATION_DISABLED_MESSAGE:
      'La validación de dispositivo seguro está inactiva en este entorno',
    SECURE_DEVICE_VALIDATION_AT_ENVIRONMENT_KEY:
      'Validación de dispositivos seguros en el entorno',
    PIN_COPIED_KEY: 'Token copiado!',
    PIN_RESET_KEY: 'Token restablecido!',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY:
      'Forzar cambio de contraseña en el próximo inicio de sesión',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_DESCRIPTION_KEY:
      'El usuario {{name}} será obligado a restablecer su contraseña en el próximo inicio de sesión',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_KEY:
      'Forzar cambio de contraseña en el próximo inicio de sesión',
    WANT_FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_KEY:
      '¿Desea forzar el cambio de contraseña para los usuarios seleccionados?',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_DESCRIPTION_KEY:
      'Los usuarios seleccionados serán obligados a restablecer sus contraseñas en el próximo inicio de sesión',
    REMOVE_FORCE_RESET_PASSWORD_SELECTED_KEY:
      'Remover obligación de cambio de contraseña',
    WANT_REMOVE_FORCE_RESET_PASSWORD_SELECTED_KEY:
      '¿Desea remover la obligación de cambio de contraseña para los usuarios seleccionados?',
    REMOVE_FORCE_RESET_PASSWORD_SELECTED_DESCRIPTION_KEY:
      'Los usuarios seleccionados ya no serán obligados a restablecer sus contraseñas en el próximo inicio de sesión',
    REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY:
      'Remover obligación de cambio de contraseña en el próximo inicio de sesión',
    REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_DESCRIPTION_KEY:
      'El usuario {{name}} ya no será obligado a restablecer su contraseña en el próximo inicio de sesión',

    ACTIVE_FORCE_RESET_PASSWORD_SUCCESS_KEY:
      'Los usuarios seleccionados ahora están obligados a cambiar su contraseña en el próximo inicio de sesión',
    INACTIVE_FORCE_RESET_PASSWORD_SUCCESS_KEY:
      'Los usuarios seleccionados ya no están obligados a cambiar su contraseña en el próximo inicio de sesión',
    PASSWORD_CHANGE_REQUIRED_KEY:
      'El usuario debe cambiar su contraseña en el próximo inicio de sesión',

    TRUSTED_DEVICES_KEY: 'Dispositivos verificados',
    ENABLE_DEVICE_VALIDATION_BYPASS_KEY: 'Omitir validación de dispositivo',
    DISABLE_DEVICE_VALIDATION_BYPASS_KEY: 'Requerir validación de dispositivo',
    ENABLE_DEVICE_VALIDATION_BYPASS_SUCCESS_KEY:
      'Validación de dispositivo omitida con éxito',
    DISABLE_DEVICE_VALIDATION_BYPASS_SUCCESS_KEY:
      'Validación de dispositivo requerida con éxito',
    ENABLE_DEVICE_VALIDATION_BYPASS_MODAL_TITLE_KEY:
      '¿Omitir validación de dispositivo para este usuario?',
    DISABLE_DEVICE_VALIDATION_BYPASS_MODAL_TITLE_KEY:
      '¿Requerir validación de dispositivo para este usuario?',
    ENABLE_DEVICE_VALIDATION_BYPASS_MODAL_CONTENT_KEY:
      'Al confirmar, no se validará el dispositivo del usuario al iniciar sesión.',
    DISABLE_DEVICE_VALIDATION_BYPASS_MODAL_CONTENT_KEY:
      'Este usuario deberá validar su dispositivo nuevamente al iniciar sesión.',
    DEVICE_HASH_KEY: 'Hash',
    DEVICE_TYPE_KEY: 'Tipo',
    OPERATING_SYSTEM_KEY: 'Sistema Operativo',
    BROWSER_KEY: 'Navegador',
    DISABLED_DEVICE_KEY: 'Dispositivo deshabilitado',
    DELETE_TRUSTED_DEVICE_KEY: 'Deshabilitar dispositivo',
    CONFIRM_DELETE_TRUSTED_DEVICE_KEY: '¿Quieres desactivar el dispositivo?',
    CONFIRM_DELETE_TRUSTED_DEVICE_MESSAGE_KEY:
      '¿Está seguro de que desea deshabilitar este dispositivo verificado? El usuario deberá autenticarse nuevamente en este dispositivo.',
    TRUSTED_DEVICE_DELETED_SUCCESSFULLY_KEY:
      '¡Dispositivo deshabilitado exitosamente!',
    ERROR_DELETING_TRUSTED_DEVICE_KEY:
      'Error al deshabilitar dispositivo. Inténtelo nuevamente.',
    NO_TRUSTED_DEVICES_KEY: 'No se encontraron dispositivos.',
    LAST_VALIDATED_IP_KEY: 'Última IP validada',
    EMAIL_PIN_VALIDATION_KEY: 'Token por correo electrónico',
    ADM_PIN_VALIDATION_KEY: 'Token de administrador',
    ZERO_TRUST_ALLOWLIST_VALIDATION_KEY: 'Lista de permisos de Zero Trust',
    IP_HISTORY_VALIDATION_KEY: 'Historial de IP',
    MFA_ACTIVE_TOOLTIP: 'MFA activo',
    MFA_INACTIVE_TOOLTIP: 'MFA inactivo',
    MFA_CONFIGURED_TOOLTIP: 'MFA configurado',
    MFA_NOT_CONFIGURED_TOOLTIP: 'MFA no configurado',
    SAFE_DEVICE_ENABLED_TOOLTIP: 'Tiene dispositivo verificado',
    SAFE_DEVICE_DISABLED_TOOLTIP: 'No tiene dispositivo verificado',
    DEVICE_VALIDATION_BYPASS_ENABLED:
      'La validación del dispositivo está siendo omitida para este usuario.',
    PASSWORD_RESET_VALIDATION_KEY: 'Registro de contraseña',
    AUTO_REGISTER_NEXT_DEVICE_VALIDATION_KEY: 'Registro automático',
    SECURE_DEVICE_VALIDATION_TOOLTIP:
      'Active esta opción para requerir la validación segura del dispositivo mediante el Token Administrativo. Esta medida agrega una capa adicional de seguridad al acceso al entorno.',
    CAN_ENABLE_SERVER_MONITORING_MANAGEMENT:
      'Habilitar la gestión de la monitorización del servidor',
    CAN_DISABLE_SERVER_MONITORING_MANAGEMENT:
      'Deshabilitar la gestión de monitoreo del servidor',
    ENABLE_SERVER_MONITORING_MANAGEMENT_INFO_TEXT_KEY:
      'Activa la gestión del monitoreo en 24x7. Al encender o apagar el servidor, el monitoreo se ajustará automáticamente.',
    ENABLE_SERVER_MONITORING_MANAGEMENT_MODAL_TITLE_KEY:
      'Habilitar la gestión de monitoreo 24x7',
    ENABLE_SERVER_MONITORING_MANAGEMENT_MODAL_DESCRIPTION_KEY:
      '¿Desea activar la gestión del monitoreo en 24x7 para este servidor? Al encender o apagar el servidor, el monitoreo se ajustará automáticamente.',
    ENABLE_SERVER_MONITORING_MANAGEMENT_SUCCESSFULLY_KEY:
      '¡Gestión del monitoreo del servidor activada con éxito!',
    DISABLE_SERVER_MONITORING_MANAGEMENT_MODAL_TITLE_KEY:
      'Deshabilitar la gestión de monitoreo 24x7',
    DISABLE_SERVER_MONITORING_MANAGEMENT_MODAL_DESCRIPTION_KEY:
      '¿Desea desactivar la gestión del monitoreo en 24x7 para este servidor? El monitoreo ya no se ajustará automáticamente al encender o apagar el servidor.',
    DISABLE_SERVER_MONITORING_MANAGEMENT_SUCCESSFULLY_KEY:
      '¡Gestión del monitoreo del servidor desactivada con éxito!',
    CAN_VIEW_SERVER_MONITORING_STATUS:
      'Ver el estado de monitoreo del servidor',

    SERVER_MONITORING_STATUS: {
      DOWN_KEY: 'No disponible',
      UP_KEY: 'Encendido',
      TROUBLE_KEY: 'Con problemas',
      CRITICAL_KEY: 'Problemas críticos',
      SUSPENDED_KEY: 'Suspendido',
      MAINTENANCE_KEY: 'En mantenimiento',
      DISCOVERY_KEY: 'En descubrimiento',
      CONFIGURATION_ERROR_KEY: 'Error de configuración',
      WITHOUT_MONITOR_KEY: 'Sin monitoreo',
      UNAVAILABLE_KEY: 'Sin información',
    },
    STOPPING_KEY: 'Parando...',
    USERNAME_REQUIRED_FOR_EXTERNAL_AD:
      'El campo de Código en el AD es obligatorio para cuentas de AD externas.',
    MANAGED_EXTERNALLY:
      'Usuario gestionado externamente. Para cambiar la contraseña, contacte con el administrador del sistema.',
    SUSPEND_MONITORING_ERROR:
      'Error al suspender la monitorización del servidor.',
    NO_AD_AUTH_TITLE: 'AD en la autenticación',
    USE_ENVIRONMENT_SETTING_KEY: 'Usar configuración del entorno',
    AUTH_WITHOUT_AD_KEY: 'Autenticación sin AD',
    AUTH_WITH_AD_KEY: 'Autenticación con AD',
    AD_AUTH_CONFIG_KEY: 'Configuración de autenticación',
    PERFORMANCE_ANALYSIS_TITLE_KEY: 'Análisis de rendimiento de las instancias',
    PERFORMANCE_ANALYSIS_SUBTITLE_KEY:
      'La información se actualiza cada minuto',
    SEARCH_PLACEHOLDER_KEY: 'Buscar',
    CPU_CURRENT_KEY: 'CPU actual',
    CPU_AVERAGE_KEY: 'CPU promedio',
    MEMORY_CURRENT_KEY: 'Memoria actual',
    SESSIONS_CURRENT_KEY: 'Sesiones actuales',
    COLLECTION_TIME_KEY: 'Hora de la recopilación',
    LIST_PARTNER_INSTANCES: 'Listar instancias de la cuenta',
    SHOW_INSTANCES_LIST_KEY: 'Mostrar lista de instancias de la cuenta',
    ACTIVE_SALT_KEY: 'Usuario con salt activo',
    INACTIVE_SALT_KEY: 'Usuario con salt inactivo',
    DEVICE_VALIDATION_KEY: 'Entorno con validación de dispositivos seguros',
    USER_MFA_ACTIVE_TOOLTIP: 'Usuario con MFA activo',
    USER_MFA_INACTIVE_TOOLTIP: 'Usuario con MFA inactivo',
    COPY_INFORMATION_KEY: 'Copiar información',
    LIST_CLIENT_CERTIFICATES: 'Listar certificados digitales',
    CAN_MANAGE_CLIENT_CERTIFICATES: 'Gestionar certificados digitales',
    CREATE_DIGITAL_CERTIFICATE_KEY: 'Crear certificado',
    EDIT_DIGITAL_CERTIFICATE_KEY: 'Editar certificado',
    DELETE_DIGITAL_CERTIFICATE_KEY: 'Eliminar certificado',

    DIGITAL_CERTIFICATE_PATH_KEY: 'Ruta del certificado',
    CONFIRM_DELETE_DIGITAL_CERTIFICATE_KEY:
      '¿Estás seguro de que deseas eliminar el certificado digital',

    DIGITAL_CERTIFICATE_CREATED_SUCCESSFULLY_KEY:
      'Certificado digital creado con éxito.',
    DIGITAL_CERTIFICATE_EDITED_SUCCESSFULLY_KEY:
      'Certificado digital actualizado con éxito.',
    DIGITAL_CERTIFICATE_DELETED_SUCCESSFULLY_KEY:
      'Certificado digital eliminado con éxito.',
    LEAKED_CREDENTIALS_KEY: 'Credenciales filtradas',
    LIST_LEAKED_CREDENTIALS: 'Listar ususarios con credenciales filtradas',
    LEAKED_CREDENTIALS_SUBTITLE_KEY:
      'Listado de usuarios con credenciales filtradas',
    FORCE_RESET_PASSWORD_KEY: 'Forzar restablecimiento de contraseña',
    RESET_LEAKED_CREDENTIALS_USER_PASSWORD:
      'Restablecer la contraseña de usuarios con credenciales filtradas',
    SESSION_REMOVAL_MAX_LIMIT_KEY: 'Límite máximo de sesiones',
    SESSION_REMOVAL_MESSAGE_KEY: 'Mensaje de eliminación de sesión',
    IS_SESSION_REMOVAL_ENABLED_KEY: 'Habilitar eliminación de sesiones',
    REMOVE_SESSIONS_TOOLTIP_KEY:
      'Establece el número máximo de sesiones activas que una instancia puede tener para ser considerada para su eliminación. Solo se eliminarán las sesiones de las instancias que tengan hasta ese límite',
    PASSWORD_RESET_KEY: 'Contraseña restablecida',
    ADMIN_NOTIFIED_KEY: 'Administrador notificado',
    LIST_LEAKED_CREDENTIALS_CLIENTS:
      'Listar clientes de usuarios con credenciales filtradas',
    SSO_ACTIVE_KEY: 'SSO activo',
    CONFIRM_RESET_PASSWORD_KEY:
      '¿Desea obligar al usuario a restablecer la contraseña?',
    FORCE_RESET_SELECTED_KEY:
      'Forzar restablecimiento de contraseña para los seleccionados',
    SOLICITED_PASSWORD_RESET_KEY:
      '¡Se ha solicitado el restablecimiento de la contraseña!',
    CONFIRM_MULTIPLE_RESET_PASSWORD_KEY:
      '¿Desea obligar a los usuarios seleccionados a restablecer la contraseña?',
    REMOVE_USER_SESSIONS_KEY: 'Drenaje de instancias y sesiones',
    REMOVE_SESSIONS_TIME_KEY: 'Hora de drenaje',
    EDIT_ENV_SESSION_REMOVAL_INSTANCES:
      'Configurar el drenaje de instancias y sesiones',
    LIST_ENV_SESSION_REMOVAL_INSTANCES:
      'Ver detalles del drenaje de instancias y sesiones',
  },
};
